// source: messages/claims.message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var messages_file_message_pb = require('../messages/file.message_pb.js');
goog.object.extend(proto, messages_file_message_pb);
var messages_core_message_pb = require('../messages/core.message_pb.js');
goog.object.extend(proto, messages_core_message_pb);
goog.exportSymbol('proto.claims_messages.Activity', null, global);
goog.exportSymbol('proto.claims_messages.ActivityType', null, global);
goog.exportSymbol('proto.claims_messages.ActivityTypeName', null, global);
goog.exportSymbol('proto.claims_messages.BenefitCodeOption', null, global);
goog.exportSymbol('proto.claims_messages.BenefitCodes', null, global);
goog.exportSymbol('proto.claims_messages.Billing', null, global);
goog.exportSymbol('proto.claims_messages.Billing.BillingCase', null, global);
goog.exportSymbol('proto.claims_messages.BillingFlat', null, global);
goog.exportSymbol('proto.claims_messages.BillingFlatHigh', null, global);
goog.exportSymbol('proto.claims_messages.BillingHourly', null, global);
goog.exportSymbol('proto.claims_messages.BillingProviderType', null, global);
goog.exportSymbol('proto.claims_messages.CaseClaimDetail', null, global);
goog.exportSymbol('proto.claims_messages.CaseClaimServiceDetail', null, global);
goog.exportSymbol('proto.claims_messages.CheckClaimHasChecklistItemsRequest', null, global);
goog.exportSymbol('proto.claims_messages.CheckClaimHasChecklistItemsResponse', null, global);
goog.exportSymbol('proto.claims_messages.CheckForDuplicateClaimRequest', null, global);
goog.exportSymbol('proto.claims_messages.CheckForDuplicateClaimResponse', null, global);
goog.exportSymbol('proto.claims_messages.Checklist', null, global);
goog.exportSymbol('proto.claims_messages.ChecklistType', null, global);
goog.exportSymbol('proto.claims_messages.Claim', null, global);
goog.exportSymbol('proto.claims_messages.ClaimPerson', null, global);
goog.exportSymbol('proto.claims_messages.ClaimReport', null, global);
goog.exportSymbol('proto.claims_messages.ClaimReportImportError', null, global);
goog.exportSymbol('proto.claims_messages.ClaimReportType', null, global);
goog.exportSymbol('proto.claims_messages.ClaimReservation', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsApproveRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsApproveResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssignAnalystRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssignAnalystResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssignees', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssigneesUpdate', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssociateDocsChunkMetadata', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssociateDocsChunkRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssociateDocsChunkResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssociateDocsRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsAssociateDocsResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsCancelRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsCancelResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsCloseNotPaidRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsCloseNotPaidResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsClosePaidRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsClosePaidResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsDenyRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsDenyResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsDocument', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsDueDates', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsDuplicateRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsDuplicateResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsGetBillingRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsGetBillingResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsGetClaimRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsGetClaimResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsGetServicesRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsGetServicesResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsInReviewRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsInReviewResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsListRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsListResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsPendingInternalReviewRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsPendingInternalReviewResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsPendingProviderRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsPendingProviderResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsPendingVerificationRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsPendingVerificationResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsQueueForPaymentRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsQueueForPaymentResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsSearchRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsSearchResponse', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsService', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsStatus', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsStatusReason', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsStatusReasons', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsStatuses', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsStatusesUpdate', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsSubmitRequest', null, global);
goog.exportSymbol('proto.claims_messages.ClaimsSubmitResponse', null, global);
goog.exportSymbol('proto.claims_messages.CoreClaimsAssociateDocsRequest', null, global);
goog.exportSymbol('proto.claims_messages.CoreClaimsAssociateDocsResponse', null, global);
goog.exportSymbol('proto.claims_messages.CoreClaimsGetDocsRequest', null, global);
goog.exportSymbol('proto.claims_messages.CoreClaimsGetDocsResponse', null, global);
goog.exportSymbol('proto.claims_messages.CreateActivitiesRequest', null, global);
goog.exportSymbol('proto.claims_messages.CreateActivitiesResponse', null, global);
goog.exportSymbol('proto.claims_messages.CreateActivity', null, global);
goog.exportSymbol('proto.claims_messages.CreateActivityRequest', null, global);
goog.exportSymbol('proto.claims_messages.CreateActivityResponse', null, global);
goog.exportSymbol('proto.claims_messages.CreateClaimReservationRequest', null, global);
goog.exportSymbol('proto.claims_messages.CreateClaimReservationResponse', null, global);
goog.exportSymbol('proto.claims_messages.CreateNoteRequest', null, global);
goog.exportSymbol('proto.claims_messages.CreateNoteResponse', null, global);
goog.exportSymbol('proto.claims_messages.CreatePaymentExportRequest', null, global);
goog.exportSymbol('proto.claims_messages.CreatePaymentExportResponse', null, global);
goog.exportSymbol('proto.claims_messages.DeleteBillingRequest', null, global);
goog.exportSymbol('proto.claims_messages.DeleteBillingResponse', null, global);
goog.exportSymbol('proto.claims_messages.DeleteBillingsRequest', null, global);
goog.exportSymbol('proto.claims_messages.DeleteBillingsResponse', null, global);
goog.exportSymbol('proto.claims_messages.DeleteNoteRequest', null, global);
goog.exportSymbol('proto.claims_messages.DeleteNoteResponse', null, global);
goog.exportSymbol('proto.claims_messages.DeleteServiceRequest', null, global);
goog.exportSymbol('proto.claims_messages.DeleteServiceResponse', null, global);
goog.exportSymbol('proto.claims_messages.DocumentCategory', null, global);
goog.exportSymbol('proto.claims_messages.DynamicExportToCsvRequest', null, global);
goog.exportSymbol('proto.claims_messages.DynamicExportToCsvResponse', null, global);
goog.exportSymbol('proto.claims_messages.ExportClaimsToCsvRequest', null, global);
goog.exportSymbol('proto.claims_messages.ExportClaimsToCsvResponse', null, global);
goog.exportSymbol('proto.claims_messages.ExportEntityType', null, global);
goog.exportSymbol('proto.claims_messages.ExportFilterPair', null, global);
goog.exportSymbol('proto.claims_messages.ExportPaymentsCsvStatusRequest', null, global);
goog.exportSymbol('proto.claims_messages.ExportPaymentsCsvStatusResponse', null, global);
goog.exportSymbol('proto.claims_messages.ExportPaymentsToCsvRequest', null, global);
goog.exportSymbol('proto.claims_messages.ExportPaymentsToCsvResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetActivitiesByClaimIdRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetActivitiesByClaimIdResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetActivityTypesRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetActivityTypesResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetAnalystsRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetAnalystsResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetApprovedCountForAnalystRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetApprovedCountForAnalystResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetChecklistItemsByClaimIdRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetChecklistItemsByClaimIdResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetChecklistTemplateRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetChecklistTemplateResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimDetailListingRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimDetailListingResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimReportsRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimReportsResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimReservationFormDataRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimReservationFormDataResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimReservationRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimReservationResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimsStatusReasonsRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetClaimsStatusReasonsResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetNoteByIdRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetNoteByIdResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetNotesByClaimRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetNotesByClaimResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetNotesByIdRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetNotesByIdResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetNotesByUserRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetNotesByUserResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetOldestClaimForAnalystRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetOldestClaimForAnalystResponse', null, global);
goog.exportSymbol('proto.claims_messages.GetPinnedNotesByClaimRequest', null, global);
goog.exportSymbol('proto.claims_messages.GetPinnedNotesByClaimResponse', null, global);
goog.exportSymbol('proto.claims_messages.ImportClaimReportsRequest', null, global);
goog.exportSymbol('proto.claims_messages.ImportClaimReportsResponse', null, global);
goog.exportSymbol('proto.claims_messages.InitializeChecklistByClaimRequest', null, global);
goog.exportSymbol('proto.claims_messages.InitializeChecklistByClaimResponse', null, global);
goog.exportSymbol('proto.claims_messages.ListClaimReservationsRequest', null, global);
goog.exportSymbol('proto.claims_messages.ListClaimReservationsResponse', null, global);
goog.exportSymbol('proto.claims_messages.MemberType', null, global);
goog.exportSymbol('proto.claims_messages.Note', null, global);
goog.exportSymbol('proto.claims_messages.NoteType', null, global);
goog.exportSymbol('proto.claims_messages.NoteTypeName', null, global);
goog.exportSymbol('proto.claims_messages.PassGroupOption', null, global);
goog.exportSymbol('proto.claims_messages.PaymentExport', null, global);
goog.exportSymbol('proto.claims_messages.PaymentExportListRequest', null, global);
goog.exportSymbol('proto.claims_messages.PaymentExportListResponse', null, global);
goog.exportSymbol('proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest', null, global);
goog.exportSymbol('proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse', null, global);
goog.exportSymbol('proto.claims_messages.PinNoteRequest', null, global);
goog.exportSymbol('proto.claims_messages.PinNoteResponse', null, global);
goog.exportSymbol('proto.claims_messages.RecoverAssociatedDocumentRequest', null, global);
goog.exportSymbol('proto.claims_messages.RecoverAssociatedDocumentResponse', null, global);
goog.exportSymbol('proto.claims_messages.RecoverClaimReservationRequest', null, global);
goog.exportSymbol('proto.claims_messages.RecoverClaimReservationResponse', null, global);
goog.exportSymbol('proto.claims_messages.RemoveAssociatedDocumentRequest', null, global);
goog.exportSymbol('proto.claims_messages.RemoveAssociatedDocumentResponse', null, global);
goog.exportSymbol('proto.claims_messages.RemoveClaimReservationRequest', null, global);
goog.exportSymbol('proto.claims_messages.RemoveClaimReservationResponse', null, global);
goog.exportSymbol('proto.claims_messages.ReplaceCompletedFormsRequest', null, global);
goog.exportSymbol('proto.claims_messages.ReplaceCompletedFormsResponse', null, global);
goog.exportSymbol('proto.claims_messages.SearchNotesRequest', null, global);
goog.exportSymbol('proto.claims_messages.SearchNotesResponse', null, global);
goog.exportSymbol('proto.claims_messages.SetCompletedFormsCancelledDateRequest', null, global);
goog.exportSymbol('proto.claims_messages.SetCompletedFormsCancelledDateResponse', null, global);
goog.exportSymbol('proto.claims_messages.SyncCompletedFormsAmountPaidRequest', null, global);
goog.exportSymbol('proto.claims_messages.SyncCompletedFormsAmountPaidResponse', null, global);
goog.exportSymbol('proto.claims_messages.UncancelClaimRequest', null, global);
goog.exportSymbol('proto.claims_messages.UncancelClaimResponse', null, global);
goog.exportSymbol('proto.claims_messages.UnpinNoteRequest', null, global);
goog.exportSymbol('proto.claims_messages.UnpinNoteResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimCleanDateRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimCleanDateResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimsAssigneesRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimsAssigneesResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimsDueDatesRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimsDueDatesResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimsStatusesRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpdateClaimsStatusesResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpsertBillingRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpsertBillingResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpsertChecklistItemRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpsertChecklistItemResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpsertClaimRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpsertClaimResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpsertClaimsStatusReasonsRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpsertClaimsStatusReasonsResponse', null, global);
goog.exportSymbol('proto.claims_messages.UpsertServiceRequest', null, global);
goog.exportSymbol('proto.claims_messages.UpsertServiceResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.BillingFlat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.BillingFlat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.BillingFlat.displayName = 'proto.claims_messages.BillingFlat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.BillingHourly = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.BillingHourly, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.BillingHourly.displayName = 'proto.claims_messages.BillingHourly';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.BillingFlatHigh = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.BillingFlatHigh, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.BillingFlatHigh.displayName = 'proto.claims_messages.BillingFlatHigh';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.Billing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.claims_messages.Billing.oneofGroups_);
};
goog.inherits(proto.claims_messages.Billing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.Billing.displayName = 'proto.claims_messages.Billing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsDocument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsDocument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsDocument.displayName = 'proto.claims_messages.ClaimsDocument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsService = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ClaimsService.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ClaimsService, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsService.displayName = 'proto.claims_messages.ClaimsService';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimPerson = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimPerson, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimPerson.displayName = 'proto.claims_messages.ClaimPerson';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.Claim = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.Claim.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.Claim, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.Claim.displayName = 'proto.claims_messages.Claim';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimReport.displayName = 'proto.claims_messages.ClaimReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimReportsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetClaimReportsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimReportsRequest.displayName = 'proto.claims_messages.GetClaimReportsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimReportsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetClaimReportsResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetClaimReportsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimReportsResponse.displayName = 'proto.claims_messages.GetClaimReportsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimReportImportError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimReportImportError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimReportImportError.displayName = 'proto.claims_messages.ClaimReportImportError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ImportClaimReportsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ImportClaimReportsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ImportClaimReportsRequest.displayName = 'proto.claims_messages.ImportClaimReportsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ImportClaimReportsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ImportClaimReportsResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ImportClaimReportsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ImportClaimReportsResponse.displayName = 'proto.claims_messages.ImportClaimReportsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CaseClaimDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.CaseClaimDetail.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.CaseClaimDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CaseClaimDetail.displayName = 'proto.claims_messages.CaseClaimDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CaseClaimServiceDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.CaseClaimServiceDetail.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.CaseClaimServiceDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CaseClaimServiceDetail.displayName = 'proto.claims_messages.CaseClaimServiceDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertClaimRequest.displayName = 'proto.claims_messages.UpsertClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertClaimResponse.displayName = 'proto.claims_messages.UpsertClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ReplaceCompletedFormsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ReplaceCompletedFormsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ReplaceCompletedFormsRequest.displayName = 'proto.claims_messages.ReplaceCompletedFormsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ReplaceCompletedFormsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ReplaceCompletedFormsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ReplaceCompletedFormsResponse.displayName = 'proto.claims_messages.ReplaceCompletedFormsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.SetCompletedFormsCancelledDateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.SetCompletedFormsCancelledDateRequest.displayName = 'proto.claims_messages.SetCompletedFormsCancelledDateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.SetCompletedFormsCancelledDateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.SetCompletedFormsCancelledDateResponse.displayName = 'proto.claims_messages.SetCompletedFormsCancelledDateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.SyncCompletedFormsAmountPaidRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.SyncCompletedFormsAmountPaidRequest.displayName = 'proto.claims_messages.SyncCompletedFormsAmountPaidRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.SyncCompletedFormsAmountPaidResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.SyncCompletedFormsAmountPaidResponse.displayName = 'proto.claims_messages.SyncCompletedFormsAmountPaidResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertServiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertServiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertServiceRequest.displayName = 'proto.claims_messages.UpsertServiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertServiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertServiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertServiceResponse.displayName = 'proto.claims_messages.UpsertServiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteServiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DeleteServiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteServiceRequest.displayName = 'proto.claims_messages.DeleteServiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteServiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DeleteServiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteServiceResponse.displayName = 'proto.claims_messages.DeleteServiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertBillingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertBillingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertBillingRequest.displayName = 'proto.claims_messages.UpsertBillingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertBillingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertBillingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertBillingResponse.displayName = 'proto.claims_messages.UpsertBillingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteBillingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DeleteBillingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteBillingRequest.displayName = 'proto.claims_messages.DeleteBillingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteBillingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DeleteBillingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteBillingResponse.displayName = 'proto.claims_messages.DeleteBillingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteBillingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.DeleteBillingsRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.DeleteBillingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteBillingsRequest.displayName = 'proto.claims_messages.DeleteBillingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteBillingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DeleteBillingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteBillingsResponse.displayName = 'proto.claims_messages.DeleteBillingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsGetClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsGetClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsGetClaimRequest.displayName = 'proto.claims_messages.ClaimsGetClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsGetClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsGetClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsGetClaimResponse.displayName = 'proto.claims_messages.ClaimsGetClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsGetServicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsGetServicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsGetServicesRequest.displayName = 'proto.claims_messages.ClaimsGetServicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsGetServicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ClaimsGetServicesResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ClaimsGetServicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsGetServicesResponse.displayName = 'proto.claims_messages.ClaimsGetServicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsGetBillingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsGetBillingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsGetBillingRequest.displayName = 'proto.claims_messages.ClaimsGetBillingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsGetBillingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ClaimsGetBillingResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ClaimsGetBillingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsGetBillingResponse.displayName = 'proto.claims_messages.ClaimsGetBillingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.BenefitCodes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.BenefitCodes.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.BenefitCodes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.BenefitCodes.displayName = 'proto.claims_messages.BenefitCodes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ClaimsListRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ClaimsListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsListRequest.displayName = 'proto.claims_messages.ClaimsListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ClaimsListResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ClaimsListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsListResponse.displayName = 'proto.claims_messages.ClaimsListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsSearchRequest.displayName = 'proto.claims_messages.ClaimsSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ClaimsSearchResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ClaimsSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsSearchResponse.displayName = 'proto.claims_messages.ClaimsSearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsApproveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsApproveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsApproveRequest.displayName = 'proto.claims_messages.ClaimsApproveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsApproveResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsApproveResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsApproveResponse.displayName = 'proto.claims_messages.ClaimsApproveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsDenyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsDenyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsDenyRequest.displayName = 'proto.claims_messages.ClaimsDenyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsDenyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsDenyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsDenyResponse.displayName = 'proto.claims_messages.ClaimsDenyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsInReviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsInReviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsInReviewRequest.displayName = 'proto.claims_messages.ClaimsInReviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsInReviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsInReviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsInReviewResponse.displayName = 'proto.claims_messages.ClaimsInReviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsQueueForPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsQueueForPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsQueueForPaymentRequest.displayName = 'proto.claims_messages.ClaimsQueueForPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsQueueForPaymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsQueueForPaymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsQueueForPaymentResponse.displayName = 'proto.claims_messages.ClaimsQueueForPaymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsClosePaidRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsClosePaidRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsClosePaidRequest.displayName = 'proto.claims_messages.ClaimsClosePaidRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsClosePaidResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsClosePaidResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsClosePaidResponse.displayName = 'proto.claims_messages.ClaimsClosePaidResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsCloseNotPaidRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsCloseNotPaidRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsCloseNotPaidRequest.displayName = 'proto.claims_messages.ClaimsCloseNotPaidRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsCloseNotPaidResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsCloseNotPaidResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsCloseNotPaidResponse.displayName = 'proto.claims_messages.ClaimsCloseNotPaidResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.displayName = 'proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.displayName = 'proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsDuplicateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsDuplicateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsDuplicateRequest.displayName = 'proto.claims_messages.ClaimsDuplicateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsDuplicateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsDuplicateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsDuplicateResponse.displayName = 'proto.claims_messages.ClaimsDuplicateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsPendingProviderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsPendingProviderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsPendingProviderRequest.displayName = 'proto.claims_messages.ClaimsPendingProviderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsPendingProviderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsPendingProviderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsPendingProviderResponse.displayName = 'proto.claims_messages.ClaimsPendingProviderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsPendingVerificationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsPendingVerificationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsPendingVerificationRequest.displayName = 'proto.claims_messages.ClaimsPendingVerificationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsPendingVerificationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsPendingVerificationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsPendingVerificationResponse.displayName = 'proto.claims_messages.ClaimsPendingVerificationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsPendingInternalReviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsPendingInternalReviewRequest.displayName = 'proto.claims_messages.ClaimsPendingInternalReviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsPendingInternalReviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsPendingInternalReviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsPendingInternalReviewResponse.displayName = 'proto.claims_messages.ClaimsPendingInternalReviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssociateDocsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssociateDocsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssociateDocsRequest.displayName = 'proto.claims_messages.ClaimsAssociateDocsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssociateDocsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssociateDocsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssociateDocsResponse.displayName = 'proto.claims_messages.ClaimsAssociateDocsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CoreClaimsAssociateDocsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CoreClaimsAssociateDocsRequest.displayName = 'proto.claims_messages.CoreClaimsAssociateDocsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CoreClaimsAssociateDocsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CoreClaimsAssociateDocsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CoreClaimsAssociateDocsResponse.displayName = 'proto.claims_messages.CoreClaimsAssociateDocsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RemoveAssociatedDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RemoveAssociatedDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RemoveAssociatedDocumentRequest.displayName = 'proto.claims_messages.RemoveAssociatedDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RemoveAssociatedDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RemoveAssociatedDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RemoveAssociatedDocumentResponse.displayName = 'proto.claims_messages.RemoveAssociatedDocumentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RecoverAssociatedDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RecoverAssociatedDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RecoverAssociatedDocumentRequest.displayName = 'proto.claims_messages.RecoverAssociatedDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RecoverAssociatedDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RecoverAssociatedDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RecoverAssociatedDocumentResponse.displayName = 'proto.claims_messages.RecoverAssociatedDocumentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.displayName = 'proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.displayName = 'proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssociateDocsChunkMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssociateDocsChunkMetadata.displayName = 'proto.claims_messages.ClaimsAssociateDocsChunkMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssociateDocsChunkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssociateDocsChunkRequest.displayName = 'proto.claims_messages.ClaimsAssociateDocsChunkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssociateDocsChunkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssociateDocsChunkResponse.displayName = 'proto.claims_messages.ClaimsAssociateDocsChunkResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsCancelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsCancelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsCancelRequest.displayName = 'proto.claims_messages.ClaimsCancelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsCancelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsCancelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsCancelResponse.displayName = 'proto.claims_messages.ClaimsCancelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UncancelClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UncancelClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UncancelClaimRequest.displayName = 'proto.claims_messages.UncancelClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UncancelClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UncancelClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UncancelClaimResponse.displayName = 'proto.claims_messages.UncancelClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CoreClaimsGetDocsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CoreClaimsGetDocsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CoreClaimsGetDocsRequest.displayName = 'proto.claims_messages.CoreClaimsGetDocsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CoreClaimsGetDocsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.CoreClaimsGetDocsResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.CoreClaimsGetDocsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CoreClaimsGetDocsResponse.displayName = 'proto.claims_messages.CoreClaimsGetDocsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.Note = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.Note, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.Note.displayName = 'proto.claims_messages.Note';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.NoteType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.NoteType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.NoteType.displayName = 'proto.claims_messages.NoteType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateNoteRequest.displayName = 'proto.claims_messages.CreateNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateNoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateNoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateNoteResponse.displayName = 'proto.claims_messages.CreateNoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DeleteNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteNoteRequest.displayName = 'proto.claims_messages.DeleteNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DeleteNoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DeleteNoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DeleteNoteResponse.displayName = 'proto.claims_messages.DeleteNoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNoteByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetNoteByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNoteByIdRequest.displayName = 'proto.claims_messages.GetNoteByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNoteByIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetNoteByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNoteByIdResponse.displayName = 'proto.claims_messages.GetNoteByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNotesByIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetNotesByIdRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetNotesByIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNotesByIdRequest.displayName = 'proto.claims_messages.GetNotesByIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNotesByIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetNotesByIdResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetNotesByIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNotesByIdResponse.displayName = 'proto.claims_messages.GetNotesByIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNotesByClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetNotesByClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNotesByClaimRequest.displayName = 'proto.claims_messages.GetNotesByClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNotesByClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetNotesByClaimResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetNotesByClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNotesByClaimResponse.displayName = 'proto.claims_messages.GetNotesByClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetPinnedNotesByClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetPinnedNotesByClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetPinnedNotesByClaimRequest.displayName = 'proto.claims_messages.GetPinnedNotesByClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetPinnedNotesByClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetPinnedNotesByClaimResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetPinnedNotesByClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetPinnedNotesByClaimResponse.displayName = 'proto.claims_messages.GetPinnedNotesByClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNotesByUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetNotesByUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNotesByUserRequest.displayName = 'proto.claims_messages.GetNotesByUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetNotesByUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetNotesByUserResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetNotesByUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetNotesByUserResponse.displayName = 'proto.claims_messages.GetNotesByUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PinNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.PinNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PinNoteRequest.displayName = 'proto.claims_messages.PinNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PinNoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.PinNoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PinNoteResponse.displayName = 'proto.claims_messages.PinNoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UnpinNoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UnpinNoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UnpinNoteRequest.displayName = 'proto.claims_messages.UnpinNoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UnpinNoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UnpinNoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UnpinNoteResponse.displayName = 'proto.claims_messages.UnpinNoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.Activity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.Activity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.Activity.displayName = 'proto.claims_messages.Activity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateActivity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateActivity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateActivity.displayName = 'proto.claims_messages.CreateActivity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ActivityType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ActivityType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ActivityType.displayName = 'proto.claims_messages.ActivityType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateActivityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateActivityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateActivityRequest.displayName = 'proto.claims_messages.CreateActivityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateActivityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateActivityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateActivityResponse.displayName = 'proto.claims_messages.CreateActivityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateActivitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.CreateActivitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.CreateActivitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateActivitiesRequest.displayName = 'proto.claims_messages.CreateActivitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateActivitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateActivitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateActivitiesResponse.displayName = 'proto.claims_messages.CreateActivitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetActivityTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetActivityTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetActivityTypesRequest.displayName = 'proto.claims_messages.GetActivityTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetActivityTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetActivityTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetActivityTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetActivityTypesResponse.displayName = 'proto.claims_messages.GetActivityTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetActivitiesByClaimIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetActivitiesByClaimIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetActivitiesByClaimIdRequest.displayName = 'proto.claims_messages.GetActivitiesByClaimIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetActivitiesByClaimIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetActivitiesByClaimIdResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetActivitiesByClaimIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetActivitiesByClaimIdResponse.displayName = 'proto.claims_messages.GetActivitiesByClaimIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetOldestClaimForAnalystRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetOldestClaimForAnalystRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetOldestClaimForAnalystRequest.displayName = 'proto.claims_messages.GetOldestClaimForAnalystRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetOldestClaimForAnalystResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetOldestClaimForAnalystResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetOldestClaimForAnalystResponse.displayName = 'proto.claims_messages.GetOldestClaimForAnalystResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsSubmitRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsSubmitRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsSubmitRequest.displayName = 'proto.claims_messages.ClaimsSubmitRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsSubmitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsSubmitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsSubmitResponse.displayName = 'proto.claims_messages.ClaimsSubmitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssignAnalystRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssignAnalystRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssignAnalystRequest.displayName = 'proto.claims_messages.ClaimsAssignAnalystRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssignAnalystResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssignAnalystResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssignAnalystResponse.displayName = 'proto.claims_messages.ClaimsAssignAnalystResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetAnalystsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetAnalystsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetAnalystsRequest.displayName = 'proto.claims_messages.GetAnalystsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetAnalystsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetAnalystsResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetAnalystsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetAnalystsResponse.displayName = 'proto.claims_messages.GetAnalystsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ExportPaymentsToCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ExportPaymentsToCsvRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ExportPaymentsToCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ExportPaymentsToCsvRequest.displayName = 'proto.claims_messages.ExportPaymentsToCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ExportPaymentsToCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ExportPaymentsToCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ExportPaymentsToCsvResponse.displayName = 'proto.claims_messages.ExportPaymentsToCsvResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ExportPaymentsCsvStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ExportPaymentsCsvStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ExportPaymentsCsvStatusRequest.displayName = 'proto.claims_messages.ExportPaymentsCsvStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ExportPaymentsCsvStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ExportPaymentsCsvStatusResponse.displayName = 'proto.claims_messages.ExportPaymentsCsvStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ExportClaimsToCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ExportClaimsToCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ExportClaimsToCsvRequest.displayName = 'proto.claims_messages.ExportClaimsToCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ExportClaimsToCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ExportClaimsToCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ExportClaimsToCsvResponse.displayName = 'proto.claims_messages.ExportClaimsToCsvResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ExportFilterPair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ExportFilterPair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ExportFilterPair.displayName = 'proto.claims_messages.ExportFilterPair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DynamicExportToCsvRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.DynamicExportToCsvRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.DynamicExportToCsvRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DynamicExportToCsvRequest.displayName = 'proto.claims_messages.DynamicExportToCsvRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.DynamicExportToCsvResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.DynamicExportToCsvResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.DynamicExportToCsvResponse.displayName = 'proto.claims_messages.DynamicExportToCsvResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreatePaymentExportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreatePaymentExportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreatePaymentExportRequest.displayName = 'proto.claims_messages.CreatePaymentExportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreatePaymentExportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreatePaymentExportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreatePaymentExportResponse.displayName = 'proto.claims_messages.CreatePaymentExportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PaymentExport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.PaymentExport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PaymentExport.displayName = 'proto.claims_messages.PaymentExport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PaymentExportListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.PaymentExportListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PaymentExportListRequest.displayName = 'proto.claims_messages.PaymentExportListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PaymentExportListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.PaymentExportListResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.PaymentExportListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PaymentExportListResponse.displayName = 'proto.claims_messages.PaymentExportListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetApprovedCountForAnalystRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetApprovedCountForAnalystRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetApprovedCountForAnalystRequest.displayName = 'proto.claims_messages.GetApprovedCountForAnalystRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetApprovedCountForAnalystResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetApprovedCountForAnalystResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetApprovedCountForAnalystResponse.displayName = 'proto.claims_messages.GetApprovedCountForAnalystResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.Checklist = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.Checklist, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.Checklist.displayName = 'proto.claims_messages.Checklist';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertChecklistItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertChecklistItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertChecklistItemRequest.displayName = 'proto.claims_messages.UpsertChecklistItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertChecklistItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertChecklistItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertChecklistItemResponse.displayName = 'proto.claims_messages.UpsertChecklistItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.InitializeChecklistByClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.InitializeChecklistByClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.InitializeChecklistByClaimRequest.displayName = 'proto.claims_messages.InitializeChecklistByClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.InitializeChecklistByClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.InitializeChecklistByClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.InitializeChecklistByClaimResponse.displayName = 'proto.claims_messages.InitializeChecklistByClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CheckClaimHasChecklistItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CheckClaimHasChecklistItemsRequest.displayName = 'proto.claims_messages.CheckClaimHasChecklistItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CheckClaimHasChecklistItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CheckClaimHasChecklistItemsResponse.displayName = 'proto.claims_messages.CheckClaimHasChecklistItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetChecklistItemsByClaimIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetChecklistItemsByClaimIdRequest.displayName = 'proto.claims_messages.GetChecklistItemsByClaimIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetChecklistItemsByClaimIdResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetChecklistItemsByClaimIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetChecklistItemsByClaimIdResponse.displayName = 'proto.claims_messages.GetChecklistItemsByClaimIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetChecklistTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetChecklistTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetChecklistTemplateRequest.displayName = 'proto.claims_messages.GetChecklistTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetChecklistTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetChecklistTemplateResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetChecklistTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetChecklistTemplateResponse.displayName = 'proto.claims_messages.GetChecklistTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimDetailListingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetClaimDetailListingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimDetailListingRequest.displayName = 'proto.claims_messages.GetClaimDetailListingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimDetailListingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetClaimDetailListingResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetClaimDetailListingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimDetailListingResponse.displayName = 'proto.claims_messages.GetClaimDetailListingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsDueDates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsDueDates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsDueDates.displayName = 'proto.claims_messages.ClaimsDueDates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimsDueDatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.UpdateClaimsDueDatesRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.UpdateClaimsDueDatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimsDueDatesRequest.displayName = 'proto.claims_messages.UpdateClaimsDueDatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimsDueDatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpdateClaimsDueDatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimsDueDatesResponse.displayName = 'proto.claims_messages.UpdateClaimsDueDatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimCleanDateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpdateClaimCleanDateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimCleanDateRequest.displayName = 'proto.claims_messages.UpdateClaimCleanDateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimCleanDateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpdateClaimCleanDateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimCleanDateResponse.displayName = 'proto.claims_messages.UpdateClaimCleanDateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssignees = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssignees, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssignees.displayName = 'proto.claims_messages.ClaimsAssignees';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsAssigneesUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsAssigneesUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsAssigneesUpdate.displayName = 'proto.claims_messages.ClaimsAssigneesUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimsAssigneesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.UpdateClaimsAssigneesRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.UpdateClaimsAssigneesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimsAssigneesRequest.displayName = 'proto.claims_messages.UpdateClaimsAssigneesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimsAssigneesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.UpdateClaimsAssigneesResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.UpdateClaimsAssigneesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimsAssigneesResponse.displayName = 'proto.claims_messages.UpdateClaimsAssigneesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsStatuses = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsStatuses, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsStatuses.displayName = 'proto.claims_messages.ClaimsStatuses';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsStatusesUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsStatusesUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsStatusesUpdate.displayName = 'proto.claims_messages.ClaimsStatusesUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimsStatusesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.UpdateClaimsStatusesRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.UpdateClaimsStatusesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimsStatusesRequest.displayName = 'proto.claims_messages.UpdateClaimsStatusesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpdateClaimsStatusesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.UpdateClaimsStatusesResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.UpdateClaimsStatusesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpdateClaimsStatusesResponse.displayName = 'proto.claims_messages.UpdateClaimsStatusesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimsStatusReasons = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimsStatusReasons, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimsStatusReasons.displayName = 'proto.claims_messages.ClaimsStatusReasons';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimsStatusReasonsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetClaimsStatusReasonsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimsStatusReasonsRequest.displayName = 'proto.claims_messages.GetClaimsStatusReasonsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimsStatusReasonsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetClaimsStatusReasonsResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetClaimsStatusReasonsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimsStatusReasonsResponse.displayName = 'proto.claims_messages.GetClaimsStatusReasonsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.UpsertClaimsStatusReasonsRequest.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.UpsertClaimsStatusReasonsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertClaimsStatusReasonsRequest.displayName = 'proto.claims_messages.UpsertClaimsStatusReasonsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.UpsertClaimsStatusReasonsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.UpsertClaimsStatusReasonsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.UpsertClaimsStatusReasonsResponse.displayName = 'proto.claims_messages.UpsertClaimsStatusReasonsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.SearchNotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.SearchNotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.SearchNotesRequest.displayName = 'proto.claims_messages.SearchNotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.SearchNotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.SearchNotesResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.SearchNotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.SearchNotesResponse.displayName = 'proto.claims_messages.SearchNotesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CheckForDuplicateClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CheckForDuplicateClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CheckForDuplicateClaimRequest.displayName = 'proto.claims_messages.CheckForDuplicateClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CheckForDuplicateClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CheckForDuplicateClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CheckForDuplicateClaimResponse.displayName = 'proto.claims_messages.CheckForDuplicateClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ClaimReservation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ClaimReservation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ClaimReservation.displayName = 'proto.claims_messages.ClaimReservation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateClaimReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateClaimReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateClaimReservationRequest.displayName = 'proto.claims_messages.CreateClaimReservationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.CreateClaimReservationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.CreateClaimReservationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.CreateClaimReservationResponse.displayName = 'proto.claims_messages.CreateClaimReservationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RemoveClaimReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RemoveClaimReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RemoveClaimReservationRequest.displayName = 'proto.claims_messages.RemoveClaimReservationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RemoveClaimReservationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RemoveClaimReservationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RemoveClaimReservationResponse.displayName = 'proto.claims_messages.RemoveClaimReservationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RecoverClaimReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RecoverClaimReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RecoverClaimReservationRequest.displayName = 'proto.claims_messages.RecoverClaimReservationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.RecoverClaimReservationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.RecoverClaimReservationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.RecoverClaimReservationResponse.displayName = 'proto.claims_messages.RecoverClaimReservationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ListClaimReservationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.ListClaimReservationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ListClaimReservationsRequest.displayName = 'proto.claims_messages.ListClaimReservationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.ListClaimReservationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.ListClaimReservationsResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.ListClaimReservationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.ListClaimReservationsResponse.displayName = 'proto.claims_messages.ListClaimReservationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetClaimReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimReservationRequest.displayName = 'proto.claims_messages.GetClaimReservationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimReservationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetClaimReservationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimReservationResponse.displayName = 'proto.claims_messages.GetClaimReservationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimReservationFormDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.GetClaimReservationFormDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimReservationFormDataRequest.displayName = 'proto.claims_messages.GetClaimReservationFormDataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.PassGroupOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.PassGroupOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.PassGroupOption.displayName = 'proto.claims_messages.PassGroupOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.BenefitCodeOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.claims_messages.BenefitCodeOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.BenefitCodeOption.displayName = 'proto.claims_messages.BenefitCodeOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.claims_messages.GetClaimReservationFormDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.claims_messages.GetClaimReservationFormDataResponse.repeatedFields_, null);
};
goog.inherits(proto.claims_messages.GetClaimReservationFormDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.claims_messages.GetClaimReservationFormDataResponse.displayName = 'proto.claims_messages.GetClaimReservationFormDataResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.BillingFlat.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.BillingFlat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.BillingFlat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BillingFlat.toObject = function(includeInstance, msg) {
  var f, obj = {
standardRate: (f = msg.getStandardRate()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
discountedRate: (f = msg.getDiscountedRate()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
totalAmount: (f = msg.getTotalAmount()) && messages_core_message_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.BillingFlat}
 */
proto.claims_messages.BillingFlat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.BillingFlat;
  return proto.claims_messages.BillingFlat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.BillingFlat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.BillingFlat}
 */
proto.claims_messages.BillingFlat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setStandardRate(value);
      break;
    case 2:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setDiscountedRate(value);
      break;
    case 3:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.BillingFlat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.BillingFlat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.BillingFlat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BillingFlat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStandardRate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getDiscountedRate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getTotalAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional core_messages.Decimal standard_rate = 1;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingFlat.prototype.getStandardRate = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 1));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingFlat} returns this
*/
proto.claims_messages.BillingFlat.prototype.setStandardRate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingFlat} returns this
 */
proto.claims_messages.BillingFlat.prototype.clearStandardRate = function() {
  return this.setStandardRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingFlat.prototype.hasStandardRate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional core_messages.Decimal discounted_rate = 2;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingFlat.prototype.getDiscountedRate = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 2));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingFlat} returns this
*/
proto.claims_messages.BillingFlat.prototype.setDiscountedRate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingFlat} returns this
 */
proto.claims_messages.BillingFlat.prototype.clearDiscountedRate = function() {
  return this.setDiscountedRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingFlat.prototype.hasDiscountedRate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional core_messages.Decimal total_amount = 3;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingFlat.prototype.getTotalAmount = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 3));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingFlat} returns this
*/
proto.claims_messages.BillingFlat.prototype.setTotalAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingFlat} returns this
 */
proto.claims_messages.BillingFlat.prototype.clearTotalAmount = function() {
  return this.setTotalAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingFlat.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.BillingHourly.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.BillingHourly.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.BillingHourly} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BillingHourly.toObject = function(includeInstance, msg) {
  var f, obj = {
providertype: jspb.Message.getFieldWithDefault(msg, 1, 0),
standardRate: (f = msg.getStandardRate()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
discountedRate: (f = msg.getDiscountedRate()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
hours: (f = msg.getHours()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
totalAmount: (f = msg.getTotalAmount()) && messages_core_message_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.BillingHourly}
 */
proto.claims_messages.BillingHourly.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.BillingHourly;
  return proto.claims_messages.BillingHourly.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.BillingHourly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.BillingHourly}
 */
proto.claims_messages.BillingHourly.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.claims_messages.BillingProviderType} */ (reader.readEnum());
      msg.setProvidertype(value);
      break;
    case 2:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setStandardRate(value);
      break;
    case 3:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setDiscountedRate(value);
      break;
    case 4:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setHours(value);
      break;
    case 5:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.BillingHourly.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.BillingHourly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.BillingHourly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BillingHourly.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProvidertype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStandardRate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getDiscountedRate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getHours();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getTotalAmount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingProviderType providerType = 1;
 * @return {!proto.claims_messages.BillingProviderType}
 */
proto.claims_messages.BillingHourly.prototype.getProvidertype = function() {
  return /** @type {!proto.claims_messages.BillingProviderType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.claims_messages.BillingProviderType} value
 * @return {!proto.claims_messages.BillingHourly} returns this
 */
proto.claims_messages.BillingHourly.prototype.setProvidertype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional core_messages.Decimal standard_rate = 2;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingHourly.prototype.getStandardRate = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 2));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingHourly} returns this
*/
proto.claims_messages.BillingHourly.prototype.setStandardRate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingHourly} returns this
 */
proto.claims_messages.BillingHourly.prototype.clearStandardRate = function() {
  return this.setStandardRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingHourly.prototype.hasStandardRate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional core_messages.Decimal discounted_rate = 3;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingHourly.prototype.getDiscountedRate = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 3));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingHourly} returns this
*/
proto.claims_messages.BillingHourly.prototype.setDiscountedRate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingHourly} returns this
 */
proto.claims_messages.BillingHourly.prototype.clearDiscountedRate = function() {
  return this.setDiscountedRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingHourly.prototype.hasDiscountedRate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional core_messages.Decimal hours = 4;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingHourly.prototype.getHours = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 4));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingHourly} returns this
*/
proto.claims_messages.BillingHourly.prototype.setHours = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingHourly} returns this
 */
proto.claims_messages.BillingHourly.prototype.clearHours = function() {
  return this.setHours(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingHourly.prototype.hasHours = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional core_messages.Decimal total_amount = 5;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingHourly.prototype.getTotalAmount = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 5));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingHourly} returns this
*/
proto.claims_messages.BillingHourly.prototype.setTotalAmount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingHourly} returns this
 */
proto.claims_messages.BillingHourly.prototype.clearTotalAmount = function() {
  return this.setTotalAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingHourly.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.BillingFlatHigh.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.BillingFlatHigh.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.BillingFlatHigh} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BillingFlatHigh.toObject = function(includeInstance, msg) {
  var f, obj = {
standardRate: (f = msg.getStandardRate()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
discountedRate: (f = msg.getDiscountedRate()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
totalAmount: (f = msg.getTotalAmount()) && messages_core_message_pb.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.BillingFlatHigh}
 */
proto.claims_messages.BillingFlatHigh.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.BillingFlatHigh;
  return proto.claims_messages.BillingFlatHigh.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.BillingFlatHigh} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.BillingFlatHigh}
 */
proto.claims_messages.BillingFlatHigh.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setStandardRate(value);
      break;
    case 2:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setDiscountedRate(value);
      break;
    case 3:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.BillingFlatHigh.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.BillingFlatHigh.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.BillingFlatHigh} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BillingFlatHigh.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStandardRate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getDiscountedRate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getTotalAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional core_messages.Decimal standard_rate = 1;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingFlatHigh.prototype.getStandardRate = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 1));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingFlatHigh} returns this
*/
proto.claims_messages.BillingFlatHigh.prototype.setStandardRate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingFlatHigh} returns this
 */
proto.claims_messages.BillingFlatHigh.prototype.clearStandardRate = function() {
  return this.setStandardRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingFlatHigh.prototype.hasStandardRate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional core_messages.Decimal discounted_rate = 2;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingFlatHigh.prototype.getDiscountedRate = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 2));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingFlatHigh} returns this
*/
proto.claims_messages.BillingFlatHigh.prototype.setDiscountedRate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingFlatHigh} returns this
 */
proto.claims_messages.BillingFlatHigh.prototype.clearDiscountedRate = function() {
  return this.setDiscountedRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingFlatHigh.prototype.hasDiscountedRate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional core_messages.Decimal total_amount = 3;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.BillingFlatHigh.prototype.getTotalAmount = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 3));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.BillingFlatHigh} returns this
*/
proto.claims_messages.BillingFlatHigh.prototype.setTotalAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.BillingFlatHigh} returns this
 */
proto.claims_messages.BillingFlatHigh.prototype.clearTotalAmount = function() {
  return this.setTotalAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.BillingFlatHigh.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.claims_messages.Billing.oneofGroups_ = [[4,5,6]];

/**
 * @enum {number}
 */
proto.claims_messages.Billing.BillingCase = {
  BILLING_NOT_SET: 0,
  FLAT: 4,
  HOURLY: 5,
  FLAT_HIGH: 6
};

/**
 * @return {proto.claims_messages.Billing.BillingCase}
 */
proto.claims_messages.Billing.prototype.getBillingCase = function() {
  return /** @type {proto.claims_messages.Billing.BillingCase} */(jspb.Message.computeOneofCase(this, proto.claims_messages.Billing.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.Billing.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.Billing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.Billing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Billing.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
serviceId: jspb.Message.getFieldWithDefault(msg, 3, 0),
flat: (f = msg.getFlat()) && proto.claims_messages.BillingFlat.toObject(includeInstance, f),
hourly: (f = msg.getHourly()) && proto.claims_messages.BillingHourly.toObject(includeInstance, f),
flatHigh: (f = msg.getFlatHigh()) && proto.claims_messages.BillingFlatHigh.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.Billing}
 */
proto.claims_messages.Billing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.Billing;
  return proto.claims_messages.Billing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.Billing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.Billing}
 */
proto.claims_messages.Billing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceId(value);
      break;
    case 4:
      var value = new proto.claims_messages.BillingFlat;
      reader.readMessage(value,proto.claims_messages.BillingFlat.deserializeBinaryFromReader);
      msg.setFlat(value);
      break;
    case 5:
      var value = new proto.claims_messages.BillingHourly;
      reader.readMessage(value,proto.claims_messages.BillingHourly.deserializeBinaryFromReader);
      msg.setHourly(value);
      break;
    case 6:
      var value = new proto.claims_messages.BillingFlatHigh;
      reader.readMessage(value,proto.claims_messages.BillingFlatHigh.deserializeBinaryFromReader);
      msg.setFlatHigh(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.Billing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.Billing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.Billing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Billing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getServiceId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFlat();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.claims_messages.BillingFlat.serializeBinaryToWriter
    );
  }
  f = message.getHourly();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.claims_messages.BillingHourly.serializeBinaryToWriter
    );
  }
  f = message.getFlatHigh();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.claims_messages.BillingFlatHigh.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.Billing.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Billing} returns this
 */
proto.claims_messages.Billing.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Billing} returns this
 */
proto.claims_messages.Billing.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Billing.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.Billing.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Billing} returns this
 */
proto.claims_messages.Billing.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 service_id = 3;
 * @return {number}
 */
proto.claims_messages.Billing.prototype.getServiceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Billing} returns this
 */
proto.claims_messages.Billing.prototype.setServiceId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional BillingFlat flat = 4;
 * @return {?proto.claims_messages.BillingFlat}
 */
proto.claims_messages.Billing.prototype.getFlat = function() {
  return /** @type{?proto.claims_messages.BillingFlat} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.BillingFlat, 4));
};


/**
 * @param {?proto.claims_messages.BillingFlat|undefined} value
 * @return {!proto.claims_messages.Billing} returns this
*/
proto.claims_messages.Billing.prototype.setFlat = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.claims_messages.Billing.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Billing} returns this
 */
proto.claims_messages.Billing.prototype.clearFlat = function() {
  return this.setFlat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Billing.prototype.hasFlat = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional BillingHourly hourly = 5;
 * @return {?proto.claims_messages.BillingHourly}
 */
proto.claims_messages.Billing.prototype.getHourly = function() {
  return /** @type{?proto.claims_messages.BillingHourly} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.BillingHourly, 5));
};


/**
 * @param {?proto.claims_messages.BillingHourly|undefined} value
 * @return {!proto.claims_messages.Billing} returns this
*/
proto.claims_messages.Billing.prototype.setHourly = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.claims_messages.Billing.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Billing} returns this
 */
proto.claims_messages.Billing.prototype.clearHourly = function() {
  return this.setHourly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Billing.prototype.hasHourly = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional BillingFlatHigh flat_high = 6;
 * @return {?proto.claims_messages.BillingFlatHigh}
 */
proto.claims_messages.Billing.prototype.getFlatHigh = function() {
  return /** @type{?proto.claims_messages.BillingFlatHigh} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.BillingFlatHigh, 6));
};


/**
 * @param {?proto.claims_messages.BillingFlatHigh|undefined} value
 * @return {!proto.claims_messages.Billing} returns this
*/
proto.claims_messages.Billing.prototype.setFlatHigh = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.claims_messages.Billing.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Billing} returns this
 */
proto.claims_messages.Billing.prototype.clearFlatHigh = function() {
  return this.setFlatHigh(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Billing.prototype.hasFlatHigh = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsDocument.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsDocument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsDocument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDocument.toObject = function(includeInstance, msg) {
  var f, obj = {
file: (f = msg.getFile()) && messages_file_message_pb.FileIdentifier.toObject(includeInstance, f),
category: jspb.Message.getFieldWithDefault(msg, 2, 0),
isDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
fileSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
isGenerated: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsDocument}
 */
proto.claims_messages.ClaimsDocument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsDocument;
  return proto.claims_messages.ClaimsDocument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsDocument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsDocument}
 */
proto.claims_messages.ClaimsDocument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new messages_file_message_pb.FileIdentifier;
      reader.readMessage(value,messages_file_message_pb.FileIdentifier.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    case 2:
      var value = /** @type {!proto.claims_messages.DocumentCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeleted(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFileSize(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGenerated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsDocument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsDocument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsDocument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDocument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messages_file_message_pb.FileIdentifier.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsDeleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFileSize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getIsGenerated();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional file_messages.FileIdentifier file = 1;
 * @return {?proto.file_messages.FileIdentifier}
 */
proto.claims_messages.ClaimsDocument.prototype.getFile = function() {
  return /** @type{?proto.file_messages.FileIdentifier} */ (
    jspb.Message.getWrapperField(this, messages_file_message_pb.FileIdentifier, 1));
};


/**
 * @param {?proto.file_messages.FileIdentifier|undefined} value
 * @return {!proto.claims_messages.ClaimsDocument} returns this
*/
proto.claims_messages.ClaimsDocument.prototype.setFile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsDocument} returns this
 */
proto.claims_messages.ClaimsDocument.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsDocument.prototype.hasFile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DocumentCategory category = 2;
 * @return {!proto.claims_messages.DocumentCategory}
 */
proto.claims_messages.ClaimsDocument.prototype.getCategory = function() {
  return /** @type {!proto.claims_messages.DocumentCategory} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.claims_messages.DocumentCategory} value
 * @return {!proto.claims_messages.ClaimsDocument} returns this
 */
proto.claims_messages.ClaimsDocument.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool is_deleted = 3;
 * @return {boolean}
 */
proto.claims_messages.ClaimsDocument.prototype.getIsDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsDocument} returns this
 */
proto.claims_messages.ClaimsDocument.prototype.setIsDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int64 file_size = 4;
 * @return {number}
 */
proto.claims_messages.ClaimsDocument.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsDocument} returns this
 */
proto.claims_messages.ClaimsDocument.prototype.setFileSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_generated = 5;
 * @return {boolean}
 */
proto.claims_messages.ClaimsDocument.prototype.getIsGenerated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsDocument} returns this
 */
proto.claims_messages.ClaimsDocument.prototype.setIsGenerated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ClaimsService.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsService.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsService.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsService} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsService.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
legalBenefitId: jspb.Message.getFieldWithDefault(msg, 3, 0),
serviceProvidedFor: jspb.Message.getFieldWithDefault(msg, 4, 0),
billingList: jspb.Message.toObjectList(msg.getBillingList(),
    proto.claims_messages.Billing.toObject, includeInstance),
recipientAge: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
finalDisposition: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f,
consultationCompleted: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f,
officeWorkCompleted: (f = jspb.Message.getBooleanField(msg, 9)) == null ? undefined : f,
negotiationCorrespondenceCompleted: (f = jspb.Message.getBooleanField(msg, 10)) == null ? undefined : f,
lawsuitCaseFiledRespondedCompleted: (f = jspb.Message.getBooleanField(msg, 11)) == null ? undefined : f,
courtAppearanceCompleted: (f = jspb.Message.getBooleanField(msg, 12)) == null ? undefined : f,
caseFullyCompleted: (f = jspb.Message.getBooleanField(msg, 13)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsService}
 */
proto.claims_messages.ClaimsService.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsService;
  return proto.claims_messages.ClaimsService.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsService}
 */
proto.claims_messages.ClaimsService.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegalBenefitId(value);
      break;
    case 4:
      var value = /** @type {!proto.claims_messages.MemberType} */ (reader.readEnum());
      msg.setServiceProvidedFor(value);
      break;
    case 5:
      var value = new proto.claims_messages.Billing;
      reader.readMessage(value,proto.claims_messages.Billing.deserializeBinaryFromReader);
      msg.addBilling(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecipientAge(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinalDisposition(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsultationCompleted(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfficeWorkCompleted(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNegotiationCorrespondenceCompleted(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLawsuitCaseFiledRespondedCompleted(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCourtAppearanceCompleted(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCaseFullyCompleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsService.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsService.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsService.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLegalBenefitId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getServiceProvidedFor();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getBillingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.claims_messages.Billing.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeBool(
      11,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeBool(
      12,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsService.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.ClaimsService.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 legal_benefit_id = 3;
 * @return {number}
 */
proto.claims_messages.ClaimsService.prototype.getLegalBenefitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setLegalBenefitId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional MemberType service_provided_for = 4;
 * @return {!proto.claims_messages.MemberType}
 */
proto.claims_messages.ClaimsService.prototype.getServiceProvidedFor = function() {
  return /** @type {!proto.claims_messages.MemberType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.claims_messages.MemberType} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setServiceProvidedFor = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated Billing billing = 5;
 * @return {!Array<!proto.claims_messages.Billing>}
 */
proto.claims_messages.ClaimsService.prototype.getBillingList = function() {
  return /** @type{!Array<!proto.claims_messages.Billing>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Billing, 5));
};


/**
 * @param {!Array<!proto.claims_messages.Billing>} value
 * @return {!proto.claims_messages.ClaimsService} returns this
*/
proto.claims_messages.ClaimsService.prototype.setBillingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.claims_messages.Billing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Billing}
 */
proto.claims_messages.ClaimsService.prototype.addBilling = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.claims_messages.Billing, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearBillingList = function() {
  return this.setBillingList([]);
};


/**
 * optional int32 recipient_age = 6;
 * @return {number}
 */
proto.claims_messages.ClaimsService.prototype.getRecipientAge = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setRecipientAge = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearRecipientAge = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasRecipientAge = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool final_disposition = 7;
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.getFinalDisposition = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setFinalDisposition = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearFinalDisposition = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasFinalDisposition = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool consultation_completed = 8;
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.getConsultationCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setConsultationCompleted = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearConsultationCompleted = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasConsultationCompleted = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool office_work_completed = 9;
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.getOfficeWorkCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setOfficeWorkCompleted = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearOfficeWorkCompleted = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasOfficeWorkCompleted = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool negotiation_correspondence_completed = 10;
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.getNegotiationCorrespondenceCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setNegotiationCorrespondenceCompleted = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearNegotiationCorrespondenceCompleted = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasNegotiationCorrespondenceCompleted = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool lawsuit_case_filed_responded_completed = 11;
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.getLawsuitCaseFiledRespondedCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setLawsuitCaseFiledRespondedCompleted = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearLawsuitCaseFiledRespondedCompleted = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasLawsuitCaseFiledRespondedCompleted = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool court_appearance_completed = 12;
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.getCourtAppearanceCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setCourtAppearanceCompleted = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearCourtAppearanceCompleted = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasCourtAppearanceCompleted = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool case_fully_completed = 13;
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.getCaseFullyCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.setCaseFullyCompleted = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsService} returns this
 */
proto.claims_messages.ClaimsService.prototype.clearCaseFullyCompleted = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsService.prototype.hasCaseFullyCompleted = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimPerson.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimPerson.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimPerson} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimPerson.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.ClaimPerson.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimPerson;
  return proto.claims_messages.ClaimPerson.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimPerson} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.ClaimPerson.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimPerson.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimPerson.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimPerson} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimPerson.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimPerson.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimPerson} returns this
 */
proto.claims_messages.ClaimPerson.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.claims_messages.ClaimPerson.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimPerson} returns this
 */
proto.claims_messages.ClaimPerson.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.Claim.repeatedFields_ = [8,16,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.Claim.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.Claim.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.Claim} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Claim.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
caseId: jspb.Message.getFieldWithDefault(msg, 2, 0),
atty: (f = msg.getAtty()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
member: (f = msg.getMember()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
dateOfInitialConsultation: (f = msg.getDateOfInitialConsultation()) && messages_core_message_pb.Date.toObject(includeInstance, f),
finalDateOfService: (f = msg.getFinalDateOfService()) && messages_core_message_pb.Date.toObject(includeInstance, f),
assignedAnalyst: (f = msg.getAssignedAnalyst()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
servicesList: jspb.Message.toObjectList(msg.getServicesList(),
    proto.claims_messages.ClaimsService.toObject, includeInstance),
billingNonCoveredFees: (f = msg.getBillingNonCoveredFees()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
billingNonCoveredServicesHours: (f = msg.getBillingNonCoveredServicesHours()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
marketValueTotal: (f = msg.getMarketValueTotal()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
dueDate: (f = msg.getDueDate()) && messages_core_message_pb.Date.toObject(includeInstance, f),
status: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
cancelReason: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
denyReason: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.claims_messages.ClaimsDocument.toObject, includeInstance),
passGroupId: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
checklistItemsList: jspb.Message.toObjectList(msg.getChecklistItemsList(),
    proto.claims_messages.Checklist.toObject, includeInstance),
checklistComplete: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
submittedAt: (f = jspb.Message.getField(msg, 20)) == null ? undefined : f,
submittedByUserId: (f = jspb.Message.getField(msg, 21)) == null ? undefined : f,
createdByUserId: (f = jspb.Message.getField(msg, 22)) == null ? undefined : f,
createdAt: jspb.Message.getFieldWithDefault(msg, 23, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 24, 0),
lampCaseId: (f = jspb.Message.getField(msg, 25)) == null ? undefined : f,
approvedAt: (f = jspb.Message.getField(msg, 26)) == null ? undefined : f,
receivedOn: (f = jspb.Message.getField(msg, 27)) == null ? undefined : f,
totalDocumentsSize: (f = jspb.Message.getField(msg, 28)) == null ? undefined : f,
createdByUser: (f = msg.getCreatedByUser()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
legalMatterState: (f = msg.getLegalMatterState()) && messages_core_message_pb.State.toObject(includeInstance, f),
cleanDate: (f = msg.getCleanDate()) && messages_core_message_pb.Date.toObject(includeInstance, f),
totalNetworkCost: (f = msg.getTotalNetworkCost()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
submittedTotalNetworkCost: (f = msg.getSubmittedTotalNetworkCost()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
attyActive: (f = jspb.Message.getBooleanField(msg, 34)) == null ? undefined : f,
isHeldForAudit: (f = jspb.Message.getBooleanField(msg, 35)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.Claim}
 */
proto.claims_messages.Claim.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.Claim;
  return proto.claims_messages.Claim.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.Claim} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.Claim}
 */
proto.claims_messages.Claim.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    case 3:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setAtty(value);
      break;
    case 4:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setMember(value);
      break;
    case 5:
      var value = new messages_core_message_pb.Date;
      reader.readMessage(value,messages_core_message_pb.Date.deserializeBinaryFromReader);
      msg.setDateOfInitialConsultation(value);
      break;
    case 6:
      var value = new messages_core_message_pb.Date;
      reader.readMessage(value,messages_core_message_pb.Date.deserializeBinaryFromReader);
      msg.setFinalDateOfService(value);
      break;
    case 7:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setAssignedAnalyst(value);
      break;
    case 8:
      var value = new proto.claims_messages.ClaimsService;
      reader.readMessage(value,proto.claims_messages.ClaimsService.deserializeBinaryFromReader);
      msg.addServices(value);
      break;
    case 9:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setBillingNonCoveredFees(value);
      break;
    case 10:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setBillingNonCoveredServicesHours(value);
      break;
    case 11:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setMarketValueTotal(value);
      break;
    case 12:
      var value = new messages_core_message_pb.Date;
      reader.readMessage(value,messages_core_message_pb.Date.deserializeBinaryFromReader);
      msg.setDueDate(value);
      break;
    case 13:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCancelReason(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDenyReason(value);
      break;
    case 16:
      var value = new proto.claims_messages.ClaimsDocument;
      reader.readMessage(value,proto.claims_messages.ClaimsDocument.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassGroupId(value);
      break;
    case 18:
      var value = new proto.claims_messages.Checklist;
      reader.readMessage(value,proto.claims_messages.Checklist.deserializeBinaryFromReader);
      msg.addChecklistItems(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setChecklistComplete(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedAt(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubmittedByUserId(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedByUserId(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLampCaseId(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApprovedAt(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivedOn(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalDocumentsSize(value);
      break;
    case 29:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setCreatedByUser(value);
      break;
    case 30:
      var value = new messages_core_message_pb.State;
      reader.readMessage(value,messages_core_message_pb.State.deserializeBinaryFromReader);
      msg.setLegalMatterState(value);
      break;
    case 31:
      var value = new messages_core_message_pb.Date;
      reader.readMessage(value,messages_core_message_pb.Date.deserializeBinaryFromReader);
      msg.setCleanDate(value);
      break;
    case 32:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalNetworkCost(value);
      break;
    case 33:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setSubmittedTotalNetworkCost(value);
      break;
    case 34:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAttyActive(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsHeldForAudit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.Claim.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.Claim.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.Claim} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Claim.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCaseId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAtty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = message.getMember();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = message.getDateOfInitialConsultation();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      messages_core_message_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getFinalDateOfService();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      messages_core_message_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getAssignedAnalyst();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.claims_messages.ClaimsService.serializeBinaryToWriter
    );
  }
  f = message.getBillingNonCoveredFees();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getBillingNonCoveredServicesHours();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getMarketValueTotal();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getDueDate();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      messages_core_message_pb.Date.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.claims_messages.ClaimsDocument.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getChecklistItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.claims_messages.Checklist.serializeBinaryToWriter
    );
  }
  f = message.getChecklistComplete();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeInt32(
      25,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeString(
      27,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeInt64(
      28,
      f
    );
  }
  f = message.getCreatedByUser();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = message.getLegalMatterState();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      messages_core_message_pb.State.serializeBinaryToWriter
    );
  }
  f = message.getCleanDate();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      messages_core_message_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTotalNetworkCost();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getSubmittedTotalNetworkCost();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeBool(
      34,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeBool(
      35,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 case_id = 2;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ClaimPerson atty = 3;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.Claim.prototype.getAtty = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 3));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setAtty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearAtty = function() {
  return this.setAtty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasAtty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ClaimPerson member = 4;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.Claim.prototype.getMember = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 4));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setMember = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearMember = function() {
  return this.setMember(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasMember = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional core_messages.Date date_of_initial_consultation = 5;
 * @return {?proto.core_messages.Date}
 */
proto.claims_messages.Claim.prototype.getDateOfInitialConsultation = function() {
  return /** @type{?proto.core_messages.Date} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Date, 5));
};


/**
 * @param {?proto.core_messages.Date|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setDateOfInitialConsultation = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearDateOfInitialConsultation = function() {
  return this.setDateOfInitialConsultation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasDateOfInitialConsultation = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional core_messages.Date final_date_of_service = 6;
 * @return {?proto.core_messages.Date}
 */
proto.claims_messages.Claim.prototype.getFinalDateOfService = function() {
  return /** @type{?proto.core_messages.Date} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Date, 6));
};


/**
 * @param {?proto.core_messages.Date|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setFinalDateOfService = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearFinalDateOfService = function() {
  return this.setFinalDateOfService(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasFinalDateOfService = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ClaimPerson assigned_analyst = 7;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.Claim.prototype.getAssignedAnalyst = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 7));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setAssignedAnalyst = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearAssignedAnalyst = function() {
  return this.setAssignedAnalyst(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasAssignedAnalyst = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated ClaimsService services = 8;
 * @return {!Array<!proto.claims_messages.ClaimsService>}
 */
proto.claims_messages.Claim.prototype.getServicesList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsService>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsService, 8));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsService>} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.claims_messages.ClaimsService=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsService}
 */
proto.claims_messages.Claim.prototype.addServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.claims_messages.ClaimsService, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearServicesList = function() {
  return this.setServicesList([]);
};


/**
 * optional core_messages.Decimal billing_non_covered_fees = 9;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.Claim.prototype.getBillingNonCoveredFees = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 9));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setBillingNonCoveredFees = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearBillingNonCoveredFees = function() {
  return this.setBillingNonCoveredFees(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasBillingNonCoveredFees = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional core_messages.Decimal billing_non_covered_services_hours = 10;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.Claim.prototype.getBillingNonCoveredServicesHours = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 10));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setBillingNonCoveredServicesHours = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearBillingNonCoveredServicesHours = function() {
  return this.setBillingNonCoveredServicesHours(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasBillingNonCoveredServicesHours = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional core_messages.Decimal market_value_total = 11;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.Claim.prototype.getMarketValueTotal = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 11));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setMarketValueTotal = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearMarketValueTotal = function() {
  return this.setMarketValueTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasMarketValueTotal = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional core_messages.Date due_date = 12;
 * @return {?proto.core_messages.Date}
 */
proto.claims_messages.Claim.prototype.getDueDate = function() {
  return /** @type{?proto.core_messages.Date} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Date, 12));
};


/**
 * @param {?proto.core_messages.Date|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setDueDate = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearDueDate = function() {
  return this.setDueDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasDueDate = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ClaimsStatus status = 13;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.Claim.prototype.getStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string cancel_reason = 14;
 * @return {string}
 */
proto.claims_messages.Claim.prototype.getCancelReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setCancelReason = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearCancelReason = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasCancelReason = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string deny_reason = 15;
 * @return {string}
 */
proto.claims_messages.Claim.prototype.getDenyReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setDenyReason = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearDenyReason = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasDenyReason = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated ClaimsDocument documents = 16;
 * @return {!Array<!proto.claims_messages.ClaimsDocument>}
 */
proto.claims_messages.Claim.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsDocument, 16));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsDocument>} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.claims_messages.ClaimsDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsDocument}
 */
proto.claims_messages.Claim.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.claims_messages.ClaimsDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};


/**
 * optional string pass_group_id = 17;
 * @return {string}
 */
proto.claims_messages.Claim.prototype.getPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setPassGroupId = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearPassGroupId = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasPassGroupId = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated Checklist checklist_items = 18;
 * @return {!Array<!proto.claims_messages.Checklist>}
 */
proto.claims_messages.Claim.prototype.getChecklistItemsList = function() {
  return /** @type{!Array<!proto.claims_messages.Checklist>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Checklist, 18));
};


/**
 * @param {!Array<!proto.claims_messages.Checklist>} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setChecklistItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.claims_messages.Checklist=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Checklist}
 */
proto.claims_messages.Claim.prototype.addChecklistItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.claims_messages.Checklist, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearChecklistItemsList = function() {
  return this.setChecklistItemsList([]);
};


/**
 * optional bool checklist_complete = 19;
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.getChecklistComplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setChecklistComplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional int64 submitted_at = 20;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getSubmittedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setSubmittedAt = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearSubmittedAt = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasSubmittedAt = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional int32 submitted_by_user_id = 21;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getSubmittedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setSubmittedByUserId = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearSubmittedByUserId = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasSubmittedByUserId = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional int32 created_by_user_id = 22;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getCreatedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setCreatedByUserId = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearCreatedByUserId = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasCreatedByUserId = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional int64 created_at = 23;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 updated_at = 24;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int32 lamp_case_id = 25;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getLampCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setLampCaseId = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearLampCaseId = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasLampCaseId = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional int64 approved_at = 26;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getApprovedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setApprovedAt = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearApprovedAt = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasApprovedAt = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional string received_on = 27;
 * @return {string}
 */
proto.claims_messages.Claim.prototype.getReceivedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setReceivedOn = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearReceivedOn = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasReceivedOn = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional int64 total_documents_size = 28;
 * @return {number}
 */
proto.claims_messages.Claim.prototype.getTotalDocumentsSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setTotalDocumentsSize = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearTotalDocumentsSize = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasTotalDocumentsSize = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional ClaimPerson created_by_user = 29;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.Claim.prototype.getCreatedByUser = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 29));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setCreatedByUser = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearCreatedByUser = function() {
  return this.setCreatedByUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasCreatedByUser = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional core_messages.State legal_matter_state = 30;
 * @return {?proto.core_messages.State}
 */
proto.claims_messages.Claim.prototype.getLegalMatterState = function() {
  return /** @type{?proto.core_messages.State} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.State, 30));
};


/**
 * @param {?proto.core_messages.State|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setLegalMatterState = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearLegalMatterState = function() {
  return this.setLegalMatterState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasLegalMatterState = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional core_messages.Date clean_date = 31;
 * @return {?proto.core_messages.Date}
 */
proto.claims_messages.Claim.prototype.getCleanDate = function() {
  return /** @type{?proto.core_messages.Date} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Date, 31));
};


/**
 * @param {?proto.core_messages.Date|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setCleanDate = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearCleanDate = function() {
  return this.setCleanDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasCleanDate = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional core_messages.Decimal total_network_cost = 32;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.Claim.prototype.getTotalNetworkCost = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 32));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setTotalNetworkCost = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearTotalNetworkCost = function() {
  return this.setTotalNetworkCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasTotalNetworkCost = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional core_messages.Decimal submitted_total_network_cost = 33;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.Claim.prototype.getSubmittedTotalNetworkCost = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 33));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.Claim} returns this
*/
proto.claims_messages.Claim.prototype.setSubmittedTotalNetworkCost = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearSubmittedTotalNetworkCost = function() {
  return this.setSubmittedTotalNetworkCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasSubmittedTotalNetworkCost = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional bool atty_active = 34;
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.getAttyActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 34, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setAttyActive = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearAttyActive = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasAttyActive = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional bool is_held_for_audit = 35;
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.getIsHeldForAudit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.setIsHeldForAudit = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Claim} returns this
 */
proto.claims_messages.Claim.prototype.clearIsHeldForAudit = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Claim.prototype.hasIsHeldForAudit = function() {
  return jspb.Message.getField(this, 35) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimReport.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimReport.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
reportName: jspb.Message.getFieldWithDefault(msg, 3, ""),
reportedOn: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, 0),
createdAt: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimReport}
 */
proto.claims_messages.ClaimReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimReport;
  return proto.claims_messages.ClaimReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimReport}
 */
proto.claims_messages.ClaimReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportedOn(value);
      break;
    case 5:
      var value = /** @type {!proto.claims_messages.ClaimReportType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getReportName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReportedOn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimReport.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReport} returns this
 */
proto.claims_messages.ClaimReport.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.ClaimReport.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReport} returns this
 */
proto.claims_messages.ClaimReport.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string report_name = 3;
 * @return {string}
 */
proto.claims_messages.ClaimReport.prototype.getReportName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReport} returns this
 */
proto.claims_messages.ClaimReport.prototype.setReportName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string reported_on = 4;
 * @return {string}
 */
proto.claims_messages.ClaimReport.prototype.getReportedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReport} returns this
 */
proto.claims_messages.ClaimReport.prototype.setReportedOn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional ClaimReportType type = 5;
 * @return {!proto.claims_messages.ClaimReportType}
 */
proto.claims_messages.ClaimReport.prototype.getType = function() {
  return /** @type {!proto.claims_messages.ClaimReportType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.claims_messages.ClaimReportType} value
 * @return {!proto.claims_messages.ClaimReport} returns this
 */
proto.claims_messages.ClaimReport.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.claims_messages.ClaimReport.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReport} returns this
 */
proto.claims_messages.ClaimReport.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimReport} returns this
 */
proto.claims_messages.ClaimReport.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReport.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimReportsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimReportsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimReportsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReportsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimReportsRequest}
 */
proto.claims_messages.GetClaimReportsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimReportsRequest;
  return proto.claims_messages.GetClaimReportsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimReportsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimReportsRequest}
 */
proto.claims_messages.GetClaimReportsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimReportsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimReportsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimReportsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReportsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.GetClaimReportsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetClaimReportsRequest} returns this
 */
proto.claims_messages.GetClaimReportsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetClaimReportsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimReportsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimReportsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimReportsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReportsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
reportsList: jspb.Message.toObjectList(msg.getReportsList(),
    proto.claims_messages.ClaimReport.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimReportsResponse}
 */
proto.claims_messages.GetClaimReportsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimReportsResponse;
  return proto.claims_messages.GetClaimReportsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimReportsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimReportsResponse}
 */
proto.claims_messages.GetClaimReportsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimReport;
      reader.readMessage(value,proto.claims_messages.ClaimReport.deserializeBinaryFromReader);
      msg.addReports(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimReportsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimReportsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimReportsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReportsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReportsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimReport.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimReport reports = 1;
 * @return {!Array<!proto.claims_messages.ClaimReport>}
 */
proto.claims_messages.GetClaimReportsResponse.prototype.getReportsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimReport, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimReport>} value
 * @return {!proto.claims_messages.GetClaimReportsResponse} returns this
*/
proto.claims_messages.GetClaimReportsResponse.prototype.setReportsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimReport}
 */
proto.claims_messages.GetClaimReportsResponse.prototype.addReports = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetClaimReportsResponse} returns this
 */
proto.claims_messages.GetClaimReportsResponse.prototype.clearReportsList = function() {
  return this.setReportsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimReportImportError.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimReportImportError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimReportImportError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimReportImportError.toObject = function(includeInstance, msg) {
  var f, obj = {
rowNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
reportName: jspb.Message.getFieldWithDefault(msg, 3, ""),
reportedOn: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, ""),
errorMessage: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimReportImportError}
 */
proto.claims_messages.ClaimReportImportError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimReportImportError;
  return proto.claims_messages.ClaimReportImportError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimReportImportError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimReportImportError}
 */
proto.claims_messages.ClaimReportImportError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRowNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportedOn(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimReportImportError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimReportImportError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimReportImportError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimReportImportError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getReportName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReportedOn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 row_number = 1;
 * @return {number}
 */
proto.claims_messages.ClaimReportImportError.prototype.getRowNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReportImportError} returns this
 */
proto.claims_messages.ClaimReportImportError.prototype.setRowNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.ClaimReportImportError.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReportImportError} returns this
 */
proto.claims_messages.ClaimReportImportError.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string report_name = 3;
 * @return {string}
 */
proto.claims_messages.ClaimReportImportError.prototype.getReportName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReportImportError} returns this
 */
proto.claims_messages.ClaimReportImportError.prototype.setReportName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string reported_on = 4;
 * @return {string}
 */
proto.claims_messages.ClaimReportImportError.prototype.getReportedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReportImportError} returns this
 */
proto.claims_messages.ClaimReportImportError.prototype.setReportedOn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.claims_messages.ClaimReportImportError.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReportImportError} returns this
 */
proto.claims_messages.ClaimReportImportError.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string error_message = 6;
 * @return {string}
 */
proto.claims_messages.ClaimReportImportError.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReportImportError} returns this
 */
proto.claims_messages.ClaimReportImportError.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ImportClaimReportsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ImportClaimReportsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ImportClaimReportsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ImportClaimReportsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
csvData: msg.getCsvData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ImportClaimReportsRequest}
 */
proto.claims_messages.ImportClaimReportsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ImportClaimReportsRequest;
  return proto.claims_messages.ImportClaimReportsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ImportClaimReportsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ImportClaimReportsRequest}
 */
proto.claims_messages.ImportClaimReportsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCsvData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ImportClaimReportsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ImportClaimReportsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ImportClaimReportsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ImportClaimReportsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsvData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes csv_data = 1;
 * @return {string}
 */
proto.claims_messages.ImportClaimReportsRequest.prototype.getCsvData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes csv_data = 1;
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {string}
 */
proto.claims_messages.ImportClaimReportsRequest.prototype.getCsvData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCsvData()));
};


/**
 * optional bytes csv_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {!Uint8Array}
 */
proto.claims_messages.ImportClaimReportsRequest.prototype.getCsvData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCsvData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.claims_messages.ImportClaimReportsRequest} returns this
 */
proto.claims_messages.ImportClaimReportsRequest.prototype.setCsvData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ImportClaimReportsResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ImportClaimReportsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ImportClaimReportsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ImportClaimReportsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0),
successfulRows: jspb.Message.getFieldWithDefault(msg, 2, 0),
failedRows: jspb.Message.getFieldWithDefault(msg, 3, 0),
errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.claims_messages.ClaimReportImportError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ImportClaimReportsResponse}
 */
proto.claims_messages.ImportClaimReportsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ImportClaimReportsResponse;
  return proto.claims_messages.ImportClaimReportsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ImportClaimReportsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ImportClaimReportsResponse}
 */
proto.claims_messages.ImportClaimReportsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRows(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuccessfulRows(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailedRows(value);
      break;
    case 4:
      var value = new proto.claims_messages.ClaimReportImportError;
      reader.readMessage(value,proto.claims_messages.ClaimReportImportError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ImportClaimReportsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ImportClaimReportsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ImportClaimReportsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccessfulRows();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFailedRows();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.claims_messages.ClaimReportImportError.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 total_rows = 1;
 * @return {number}
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ImportClaimReportsResponse} returns this
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 successful_rows = 2;
 * @return {number}
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.getSuccessfulRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ImportClaimReportsResponse} returns this
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.setSuccessfulRows = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 failed_rows = 3;
 * @return {number}
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.getFailedRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ImportClaimReportsResponse} returns this
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.setFailedRows = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ClaimReportImportError errors = 4;
 * @return {!Array<!proto.claims_messages.ClaimReportImportError>}
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimReportImportError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimReportImportError, 4));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimReportImportError>} value
 * @return {!proto.claims_messages.ImportClaimReportsResponse} returns this
*/
proto.claims_messages.ImportClaimReportsResponse.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.claims_messages.ClaimReportImportError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimReportImportError}
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.claims_messages.ClaimReportImportError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ImportClaimReportsResponse} returns this
 */
proto.claims_messages.ImportClaimReportsResponse.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.CaseClaimDetail.repeatedFields_ = [2,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CaseClaimDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CaseClaimDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CaseClaimDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CaseClaimDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
serviceList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
totalAmount: (f = msg.getTotalAmount()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
submittedAt: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
status: jspb.Message.getFieldWithDefault(msg, 5, 0),
serviceDetailsList: jspb.Message.toObjectList(msg.getServiceDetailsList(),
    proto.claims_messages.CaseClaimServiceDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CaseClaimDetail}
 */
proto.claims_messages.CaseClaimDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CaseClaimDetail;
  return proto.claims_messages.CaseClaimDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CaseClaimDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CaseClaimDetail}
 */
proto.claims_messages.CaseClaimDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addService(value);
      break;
    case 3:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedAt(value);
      break;
    case 5:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = new proto.claims_messages.CaseClaimServiceDetail;
      reader.readMessage(value,proto.claims_messages.CaseClaimServiceDetail.deserializeBinaryFromReader);
      msg.addServiceDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CaseClaimDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CaseClaimDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CaseClaimDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CaseClaimDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getServiceList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getTotalAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getServiceDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.claims_messages.CaseClaimServiceDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.CaseClaimDetail.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string service = 2;
 * @return {!Array<string>}
 */
proto.claims_messages.CaseClaimDetail.prototype.getServiceList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.setServiceList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.addService = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.clearServiceList = function() {
  return this.setServiceList([]);
};


/**
 * optional core_messages.Decimal total_amount = 3;
 * @return {?proto.core_messages.Decimal}
 */
proto.claims_messages.CaseClaimDetail.prototype.getTotalAmount = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 3));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
*/
proto.claims_messages.CaseClaimDetail.prototype.setTotalAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.clearTotalAmount = function() {
  return this.setTotalAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CaseClaimDetail.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 submitted_at = 4;
 * @return {number}
 */
proto.claims_messages.CaseClaimDetail.prototype.getSubmittedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.setSubmittedAt = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.clearSubmittedAt = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CaseClaimDetail.prototype.hasSubmittedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ClaimsStatus status = 5;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.CaseClaimDetail.prototype.getStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated CaseClaimServiceDetail service_details = 6;
 * @return {!Array<!proto.claims_messages.CaseClaimServiceDetail>}
 */
proto.claims_messages.CaseClaimDetail.prototype.getServiceDetailsList = function() {
  return /** @type{!Array<!proto.claims_messages.CaseClaimServiceDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.CaseClaimServiceDetail, 6));
};


/**
 * @param {!Array<!proto.claims_messages.CaseClaimServiceDetail>} value
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
*/
proto.claims_messages.CaseClaimDetail.prototype.setServiceDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.claims_messages.CaseClaimServiceDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.CaseClaimServiceDetail}
 */
proto.claims_messages.CaseClaimDetail.prototype.addServiceDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.claims_messages.CaseClaimServiceDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.CaseClaimDetail} returns this
 */
proto.claims_messages.CaseClaimDetail.prototype.clearServiceDetailsList = function() {
  return this.setServiceDetailsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.CaseClaimServiceDetail.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CaseClaimServiceDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CaseClaimServiceDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CaseClaimServiceDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
service: jspb.Message.getFieldWithDefault(msg, 1, ""),
caseWorkLevelsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CaseClaimServiceDetail}
 */
proto.claims_messages.CaseClaimServiceDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CaseClaimServiceDetail;
  return proto.claims_messages.CaseClaimServiceDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CaseClaimServiceDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CaseClaimServiceDetail}
 */
proto.claims_messages.CaseClaimServiceDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setService(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCaseWorkLevels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CaseClaimServiceDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CaseClaimServiceDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CaseClaimServiceDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getService();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaseWorkLevelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string service = 1;
 * @return {string}
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.getService = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CaseClaimServiceDetail} returns this
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.setService = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string case_work_levels = 2;
 * @return {!Array<string>}
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.getCaseWorkLevelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.claims_messages.CaseClaimServiceDetail} returns this
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.setCaseWorkLevelsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.CaseClaimServiceDetail} returns this
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.addCaseWorkLevels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.CaseClaimServiceDetail} returns this
 */
proto.claims_messages.CaseClaimServiceDetail.prototype.clearCaseWorkLevelsList = function() {
  return this.setCaseWorkLevelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claim: (f = msg.getClaim()) && proto.claims_messages.Claim.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertClaimRequest}
 */
proto.claims_messages.UpsertClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertClaimRequest;
  return proto.claims_messages.UpsertClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertClaimRequest}
 */
proto.claims_messages.UpsertClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Claim;
      reader.readMessage(value,proto.claims_messages.Claim.deserializeBinaryFromReader);
      msg.setClaim(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaim();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Claim.serializeBinaryToWriter
    );
  }
};


/**
 * optional Claim claim = 1;
 * @return {?proto.claims_messages.Claim}
 */
proto.claims_messages.UpsertClaimRequest.prototype.getClaim = function() {
  return /** @type{?proto.claims_messages.Claim} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Claim, 1));
};


/**
 * @param {?proto.claims_messages.Claim|undefined} value
 * @return {!proto.claims_messages.UpsertClaimRequest} returns this
*/
proto.claims_messages.UpsertClaimRequest.prototype.setClaim = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.UpsertClaimRequest} returns this
 */
proto.claims_messages.UpsertClaimRequest.prototype.clearClaim = function() {
  return this.setClaim(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.UpsertClaimRequest.prototype.hasClaim = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claim: (f = msg.getClaim()) && proto.claims_messages.Claim.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertClaimResponse}
 */
proto.claims_messages.UpsertClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertClaimResponse;
  return proto.claims_messages.UpsertClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertClaimResponse}
 */
proto.claims_messages.UpsertClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Claim;
      reader.readMessage(value,proto.claims_messages.Claim.deserializeBinaryFromReader);
      msg.setClaim(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaim();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Claim.serializeBinaryToWriter
    );
  }
};


/**
 * optional Claim claim = 1;
 * @return {?proto.claims_messages.Claim}
 */
proto.claims_messages.UpsertClaimResponse.prototype.getClaim = function() {
  return /** @type{?proto.claims_messages.Claim} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Claim, 1));
};


/**
 * @param {?proto.claims_messages.Claim|undefined} value
 * @return {!proto.claims_messages.UpsertClaimResponse} returns this
*/
proto.claims_messages.UpsertClaimResponse.prototype.setClaim = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.UpsertClaimResponse} returns this
 */
proto.claims_messages.UpsertClaimResponse.prototype.clearClaim = function() {
  return this.setClaim(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.UpsertClaimResponse.prototype.hasClaim = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ReplaceCompletedFormsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ReplaceCompletedFormsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ReplaceCompletedFormsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ReplaceCompletedFormsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ReplaceCompletedFormsRequest}
 */
proto.claims_messages.ReplaceCompletedFormsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ReplaceCompletedFormsRequest;
  return proto.claims_messages.ReplaceCompletedFormsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ReplaceCompletedFormsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ReplaceCompletedFormsRequest}
 */
proto.claims_messages.ReplaceCompletedFormsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ReplaceCompletedFormsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ReplaceCompletedFormsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ReplaceCompletedFormsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ReplaceCompletedFormsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ReplaceCompletedFormsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ReplaceCompletedFormsRequest} returns this
 */
proto.claims_messages.ReplaceCompletedFormsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ReplaceCompletedFormsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ReplaceCompletedFormsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ReplaceCompletedFormsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ReplaceCompletedFormsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
recordsCreated: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ReplaceCompletedFormsResponse}
 */
proto.claims_messages.ReplaceCompletedFormsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ReplaceCompletedFormsResponse;
  return proto.claims_messages.ReplaceCompletedFormsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ReplaceCompletedFormsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ReplaceCompletedFormsResponse}
 */
proto.claims_messages.ReplaceCompletedFormsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRecordsCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ReplaceCompletedFormsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ReplaceCompletedFormsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ReplaceCompletedFormsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ReplaceCompletedFormsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecordsCreated();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 records_created = 1;
 * @return {number}
 */
proto.claims_messages.ReplaceCompletedFormsResponse.prototype.getRecordsCreated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ReplaceCompletedFormsResponse} returns this
 */
proto.claims_messages.ReplaceCompletedFormsResponse.prototype.setRecordsCreated = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.SetCompletedFormsCancelledDateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.SetCompletedFormsCancelledDateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.SetCompletedFormsCancelledDateRequest}
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.SetCompletedFormsCancelledDateRequest;
  return proto.claims_messages.SetCompletedFormsCancelledDateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.SetCompletedFormsCancelledDateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.SetCompletedFormsCancelledDateRequest}
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.SetCompletedFormsCancelledDateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.SetCompletedFormsCancelledDateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.SetCompletedFormsCancelledDateRequest} returns this
 */
proto.claims_messages.SetCompletedFormsCancelledDateRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.SetCompletedFormsCancelledDateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.SetCompletedFormsCancelledDateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
recordsUpdated: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.SetCompletedFormsCancelledDateResponse}
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.SetCompletedFormsCancelledDateResponse;
  return proto.claims_messages.SetCompletedFormsCancelledDateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.SetCompletedFormsCancelledDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.SetCompletedFormsCancelledDateResponse}
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRecordsUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.SetCompletedFormsCancelledDateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.SetCompletedFormsCancelledDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecordsUpdated();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 records_updated = 1;
 * @return {number}
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.prototype.getRecordsUpdated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.SetCompletedFormsCancelledDateResponse} returns this
 */
proto.claims_messages.SetCompletedFormsCancelledDateResponse.prototype.setRecordsUpdated = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.SyncCompletedFormsAmountPaidRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.SyncCompletedFormsAmountPaidRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.SyncCompletedFormsAmountPaidRequest}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.SyncCompletedFormsAmountPaidRequest;
  return proto.claims_messages.SyncCompletedFormsAmountPaidRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.SyncCompletedFormsAmountPaidRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.SyncCompletedFormsAmountPaidRequest}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.SyncCompletedFormsAmountPaidRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.SyncCompletedFormsAmountPaidRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.SyncCompletedFormsAmountPaidRequest} returns this
 */
proto.claims_messages.SyncCompletedFormsAmountPaidRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.SyncCompletedFormsAmountPaidResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.SyncCompletedFormsAmountPaidResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
recordsAffected: jspb.Message.getFieldWithDefault(msg, 1, 0),
rebuilt: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.SyncCompletedFormsAmountPaidResponse}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.SyncCompletedFormsAmountPaidResponse;
  return proto.claims_messages.SyncCompletedFormsAmountPaidResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.SyncCompletedFormsAmountPaidResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.SyncCompletedFormsAmountPaidResponse}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRecordsAffected(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRebuilt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.SyncCompletedFormsAmountPaidResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.SyncCompletedFormsAmountPaidResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecordsAffected();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getRebuilt();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional uint64 records_affected = 1;
 * @return {number}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.prototype.getRecordsAffected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.SyncCompletedFormsAmountPaidResponse} returns this
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.prototype.setRecordsAffected = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool rebuilt = 2;
 * @return {boolean}
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.prototype.getRebuilt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.SyncCompletedFormsAmountPaidResponse} returns this
 */
proto.claims_messages.SyncCompletedFormsAmountPaidResponse.prototype.setRebuilt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertServiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertServiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertServiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertServiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsService: (f = msg.getClaimsService()) && proto.claims_messages.ClaimsService.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertServiceRequest}
 */
proto.claims_messages.UpsertServiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertServiceRequest;
  return proto.claims_messages.UpsertServiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertServiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertServiceRequest}
 */
proto.claims_messages.UpsertServiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsService;
      reader.readMessage(value,proto.claims_messages.ClaimsService.deserializeBinaryFromReader);
      msg.setClaimsService(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertServiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertServiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertServiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertServiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsService();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimsService.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimsService claims_service = 1;
 * @return {?proto.claims_messages.ClaimsService}
 */
proto.claims_messages.UpsertServiceRequest.prototype.getClaimsService = function() {
  return /** @type{?proto.claims_messages.ClaimsService} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimsService, 1));
};


/**
 * @param {?proto.claims_messages.ClaimsService|undefined} value
 * @return {!proto.claims_messages.UpsertServiceRequest} returns this
*/
proto.claims_messages.UpsertServiceRequest.prototype.setClaimsService = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.UpsertServiceRequest} returns this
 */
proto.claims_messages.UpsertServiceRequest.prototype.clearClaimsService = function() {
  return this.setClaimsService(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.UpsertServiceRequest.prototype.hasClaimsService = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertServiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertServiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertServiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertServiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsService: (f = msg.getClaimsService()) && proto.claims_messages.ClaimsService.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertServiceResponse}
 */
proto.claims_messages.UpsertServiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertServiceResponse;
  return proto.claims_messages.UpsertServiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertServiceResponse}
 */
proto.claims_messages.UpsertServiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsService;
      reader.readMessage(value,proto.claims_messages.ClaimsService.deserializeBinaryFromReader);
      msg.setClaimsService(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertServiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertServiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertServiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsService();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimsService.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimsService claims_service = 1;
 * @return {?proto.claims_messages.ClaimsService}
 */
proto.claims_messages.UpsertServiceResponse.prototype.getClaimsService = function() {
  return /** @type{?proto.claims_messages.ClaimsService} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimsService, 1));
};


/**
 * @param {?proto.claims_messages.ClaimsService|undefined} value
 * @return {!proto.claims_messages.UpsertServiceResponse} returns this
*/
proto.claims_messages.UpsertServiceResponse.prototype.setClaimsService = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.UpsertServiceResponse} returns this
 */
proto.claims_messages.UpsertServiceResponse.prototype.clearClaimsService = function() {
  return this.setClaimsService(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.UpsertServiceResponse.prototype.hasClaimsService = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteServiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteServiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteServiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteServiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
claimServiceId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteServiceRequest}
 */
proto.claims_messages.DeleteServiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteServiceRequest;
  return proto.claims_messages.DeleteServiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteServiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteServiceRequest}
 */
proto.claims_messages.DeleteServiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimServiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteServiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteServiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteServiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteServiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimServiceId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.DeleteServiceRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DeleteServiceRequest} returns this
 */
proto.claims_messages.DeleteServiceRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 claim_service_id = 2;
 * @return {number}
 */
proto.claims_messages.DeleteServiceRequest.prototype.getClaimServiceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DeleteServiceRequest} returns this
 */
proto.claims_messages.DeleteServiceRequest.prototype.setClaimServiceId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteServiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteServiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteServiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteServiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteServiceResponse}
 */
proto.claims_messages.DeleteServiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteServiceResponse;
  return proto.claims_messages.DeleteServiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteServiceResponse}
 */
proto.claims_messages.DeleteServiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteServiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteServiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteServiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertBillingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertBillingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertBillingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertBillingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
billing: (f = msg.getBilling()) && proto.claims_messages.Billing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertBillingRequest}
 */
proto.claims_messages.UpsertBillingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertBillingRequest;
  return proto.claims_messages.UpsertBillingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertBillingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertBillingRequest}
 */
proto.claims_messages.UpsertBillingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Billing;
      reader.readMessage(value,proto.claims_messages.Billing.deserializeBinaryFromReader);
      msg.setBilling(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertBillingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertBillingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertBillingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertBillingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBilling();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Billing.serializeBinaryToWriter
    );
  }
};


/**
 * optional Billing billing = 1;
 * @return {?proto.claims_messages.Billing}
 */
proto.claims_messages.UpsertBillingRequest.prototype.getBilling = function() {
  return /** @type{?proto.claims_messages.Billing} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Billing, 1));
};


/**
 * @param {?proto.claims_messages.Billing|undefined} value
 * @return {!proto.claims_messages.UpsertBillingRequest} returns this
*/
proto.claims_messages.UpsertBillingRequest.prototype.setBilling = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.UpsertBillingRequest} returns this
 */
proto.claims_messages.UpsertBillingRequest.prototype.clearBilling = function() {
  return this.setBilling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.UpsertBillingRequest.prototype.hasBilling = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertBillingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertBillingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertBillingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertBillingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
billing: (f = msg.getBilling()) && proto.claims_messages.Billing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertBillingResponse}
 */
proto.claims_messages.UpsertBillingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertBillingResponse;
  return proto.claims_messages.UpsertBillingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertBillingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertBillingResponse}
 */
proto.claims_messages.UpsertBillingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Billing;
      reader.readMessage(value,proto.claims_messages.Billing.deserializeBinaryFromReader);
      msg.setBilling(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertBillingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertBillingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertBillingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertBillingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBilling();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Billing.serializeBinaryToWriter
    );
  }
};


/**
 * optional Billing billing = 1;
 * @return {?proto.claims_messages.Billing}
 */
proto.claims_messages.UpsertBillingResponse.prototype.getBilling = function() {
  return /** @type{?proto.claims_messages.Billing} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Billing, 1));
};


/**
 * @param {?proto.claims_messages.Billing|undefined} value
 * @return {!proto.claims_messages.UpsertBillingResponse} returns this
*/
proto.claims_messages.UpsertBillingResponse.prototype.setBilling = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.UpsertBillingResponse} returns this
 */
proto.claims_messages.UpsertBillingResponse.prototype.clearBilling = function() {
  return this.setBilling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.UpsertBillingResponse.prototype.hasBilling = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteBillingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteBillingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteBillingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
billingId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteBillingRequest}
 */
proto.claims_messages.DeleteBillingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteBillingRequest;
  return proto.claims_messages.DeleteBillingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteBillingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteBillingRequest}
 */
proto.claims_messages.DeleteBillingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBillingId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteBillingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteBillingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteBillingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBillingId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.DeleteBillingRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DeleteBillingRequest} returns this
 */
proto.claims_messages.DeleteBillingRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 billing_id = 2;
 * @return {number}
 */
proto.claims_messages.DeleteBillingRequest.prototype.getBillingId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DeleteBillingRequest} returns this
 */
proto.claims_messages.DeleteBillingRequest.prototype.setBillingId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteBillingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteBillingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteBillingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteBillingResponse}
 */
proto.claims_messages.DeleteBillingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteBillingResponse;
  return proto.claims_messages.DeleteBillingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteBillingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteBillingResponse}
 */
proto.claims_messages.DeleteBillingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteBillingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteBillingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteBillingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.DeleteBillingsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteBillingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteBillingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteBillingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
billingIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteBillingsRequest}
 */
proto.claims_messages.DeleteBillingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteBillingsRequest;
  return proto.claims_messages.DeleteBillingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteBillingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteBillingsRequest}
 */
proto.claims_messages.DeleteBillingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBillingIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteBillingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteBillingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteBillingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBillingIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.DeleteBillingsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DeleteBillingsRequest} returns this
 */
proto.claims_messages.DeleteBillingsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 billing_ids = 2;
 * @return {!Array<number>}
 */
proto.claims_messages.DeleteBillingsRequest.prototype.getBillingIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.claims_messages.DeleteBillingsRequest} returns this
 */
proto.claims_messages.DeleteBillingsRequest.prototype.setBillingIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.DeleteBillingsRequest} returns this
 */
proto.claims_messages.DeleteBillingsRequest.prototype.addBillingIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.DeleteBillingsRequest} returns this
 */
proto.claims_messages.DeleteBillingsRequest.prototype.clearBillingIdsList = function() {
  return this.setBillingIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteBillingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteBillingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteBillingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteBillingsResponse}
 */
proto.claims_messages.DeleteBillingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteBillingsResponse;
  return proto.claims_messages.DeleteBillingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteBillingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteBillingsResponse}
 */
proto.claims_messages.DeleteBillingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteBillingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteBillingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteBillingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteBillingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsGetClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsGetClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsGetClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsGetClaimRequest}
 */
proto.claims_messages.ClaimsGetClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsGetClaimRequest;
  return proto.claims_messages.ClaimsGetClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsGetClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsGetClaimRequest}
 */
proto.claims_messages.ClaimsGetClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsGetClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsGetClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsGetClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsGetClaimRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsGetClaimRequest} returns this
 */
proto.claims_messages.ClaimsGetClaimRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsGetClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsGetClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsGetClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claim: (f = msg.getClaim()) && proto.claims_messages.Claim.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsGetClaimResponse}
 */
proto.claims_messages.ClaimsGetClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsGetClaimResponse;
  return proto.claims_messages.ClaimsGetClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsGetClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsGetClaimResponse}
 */
proto.claims_messages.ClaimsGetClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Claim;
      reader.readMessage(value,proto.claims_messages.Claim.deserializeBinaryFromReader);
      msg.setClaim(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsGetClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsGetClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsGetClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaim();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Claim.serializeBinaryToWriter
    );
  }
};


/**
 * optional Claim claim = 1;
 * @return {?proto.claims_messages.Claim}
 */
proto.claims_messages.ClaimsGetClaimResponse.prototype.getClaim = function() {
  return /** @type{?proto.claims_messages.Claim} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Claim, 1));
};


/**
 * @param {?proto.claims_messages.Claim|undefined} value
 * @return {!proto.claims_messages.ClaimsGetClaimResponse} returns this
*/
proto.claims_messages.ClaimsGetClaimResponse.prototype.setClaim = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsGetClaimResponse} returns this
 */
proto.claims_messages.ClaimsGetClaimResponse.prototype.clearClaim = function() {
  return this.setClaim(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsGetClaimResponse.prototype.hasClaim = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsGetServicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsGetServicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsGetServicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetServicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsGetServicesRequest}
 */
proto.claims_messages.ClaimsGetServicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsGetServicesRequest;
  return proto.claims_messages.ClaimsGetServicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsGetServicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsGetServicesRequest}
 */
proto.claims_messages.ClaimsGetServicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsGetServicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsGetServicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsGetServicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetServicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsGetServicesRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsGetServicesRequest} returns this
 */
proto.claims_messages.ClaimsGetServicesRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ClaimsGetServicesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsGetServicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsGetServicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsGetServicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetServicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
servicesList: jspb.Message.toObjectList(msg.getServicesList(),
    proto.claims_messages.ClaimsService.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsGetServicesResponse}
 */
proto.claims_messages.ClaimsGetServicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsGetServicesResponse;
  return proto.claims_messages.ClaimsGetServicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsGetServicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsGetServicesResponse}
 */
proto.claims_messages.ClaimsGetServicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsService;
      reader.readMessage(value,proto.claims_messages.ClaimsService.deserializeBinaryFromReader);
      msg.addServices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsGetServicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsGetServicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsGetServicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetServicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsService.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsService services = 1;
 * @return {!Array<!proto.claims_messages.ClaimsService>}
 */
proto.claims_messages.ClaimsGetServicesResponse.prototype.getServicesList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsService>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsService, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsService>} value
 * @return {!proto.claims_messages.ClaimsGetServicesResponse} returns this
*/
proto.claims_messages.ClaimsGetServicesResponse.prototype.setServicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsService=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsService}
 */
proto.claims_messages.ClaimsGetServicesResponse.prototype.addServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsService, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ClaimsGetServicesResponse} returns this
 */
proto.claims_messages.ClaimsGetServicesResponse.prototype.clearServicesList = function() {
  return this.setServicesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsGetBillingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsGetBillingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsGetBillingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetBillingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsGetBillingRequest}
 */
proto.claims_messages.ClaimsGetBillingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsGetBillingRequest;
  return proto.claims_messages.ClaimsGetBillingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsGetBillingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsGetBillingRequest}
 */
proto.claims_messages.ClaimsGetBillingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsGetBillingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsGetBillingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsGetBillingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetBillingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsGetBillingRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsGetBillingRequest} returns this
 */
proto.claims_messages.ClaimsGetBillingRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ClaimsGetBillingResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsGetBillingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsGetBillingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsGetBillingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetBillingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
billingList: jspb.Message.toObjectList(msg.getBillingList(),
    proto.claims_messages.Billing.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsGetBillingResponse}
 */
proto.claims_messages.ClaimsGetBillingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsGetBillingResponse;
  return proto.claims_messages.ClaimsGetBillingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsGetBillingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsGetBillingResponse}
 */
proto.claims_messages.ClaimsGetBillingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Billing;
      reader.readMessage(value,proto.claims_messages.Billing.deserializeBinaryFromReader);
      msg.addBilling(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsGetBillingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsGetBillingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsGetBillingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsGetBillingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Billing.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Billing billing = 1;
 * @return {!Array<!proto.claims_messages.Billing>}
 */
proto.claims_messages.ClaimsGetBillingResponse.prototype.getBillingList = function() {
  return /** @type{!Array<!proto.claims_messages.Billing>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Billing, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Billing>} value
 * @return {!proto.claims_messages.ClaimsGetBillingResponse} returns this
*/
proto.claims_messages.ClaimsGetBillingResponse.prototype.setBillingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Billing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Billing}
 */
proto.claims_messages.ClaimsGetBillingResponse.prototype.addBilling = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Billing, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ClaimsGetBillingResponse} returns this
 */
proto.claims_messages.ClaimsGetBillingResponse.prototype.clearBillingList = function() {
  return this.setBillingList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.BenefitCodes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.BenefitCodes.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.BenefitCodes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.BenefitCodes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BenefitCodes.toObject = function(includeInstance, msg) {
  var f, obj = {
valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.BenefitCodes}
 */
proto.claims_messages.BenefitCodes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.BenefitCodes;
  return proto.claims_messages.BenefitCodes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.BenefitCodes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.BenefitCodes}
 */
proto.claims_messages.BenefitCodes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.BenefitCodes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.BenefitCodes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.BenefitCodes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BenefitCodes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.claims_messages.BenefitCodes.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.claims_messages.BenefitCodes} returns this
 */
proto.claims_messages.BenefitCodes.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.BenefitCodes} returns this
 */
proto.claims_messages.BenefitCodes.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.BenefitCodes} returns this
 */
proto.claims_messages.BenefitCodes.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ClaimsListRequest.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
assignedAnalystId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
sortField: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
sortDir: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
searchField: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
searchString: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
attyId: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
idsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
diaryRole: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
benefitCodes: (f = msg.getBenefitCodes()) && proto.claims_messages.BenefitCodes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsListRequest}
 */
proto.claims_messages.ClaimsListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsListRequest;
  return proto.claims_messages.ClaimsListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsListRequest}
 */
proto.claims_messages.ClaimsListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedAnalystId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDir(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchField(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchString(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    case 9:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIds(values[i]);
      }
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiaryRole(value);
      break;
    case 11:
      var value = new proto.claims_messages.BenefitCodes;
      reader.readMessage(value,proto.claims_messages.BenefitCodes.deserializeBinaryFromReader);
      msg.setBenefitCodes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBenefitCodes();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.claims_messages.BenefitCodes.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 assigned_analyst_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsListRequest.prototype.getAssignedAnalystId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setAssignedAnalystId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearAssignedAnalystId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasAssignedAnalystId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.claims_messages.ClaimsListRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.claims_messages.ClaimsListRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string sort_field = 4;
 * @return {string}
 */
proto.claims_messages.ClaimsListRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setSortField = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearSortField = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasSortField = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string sort_dir = 5;
 * @return {string}
 */
proto.claims_messages.ClaimsListRequest.prototype.getSortDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setSortDir = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearSortDir = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasSortDir = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string search_field = 6;
 * @return {string}
 */
proto.claims_messages.ClaimsListRequest.prototype.getSearchField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setSearchField = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearSearchField = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasSearchField = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string search_string = 7;
 * @return {string}
 */
proto.claims_messages.ClaimsListRequest.prototype.getSearchString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setSearchString = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearSearchString = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasSearchString = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 atty_id = 8;
 * @return {number}
 */
proto.claims_messages.ClaimsListRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearAttyId = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasAttyId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated int32 ids = 9;
 * @return {!Array<number>}
 */
proto.claims_messages.ClaimsListRequest.prototype.getIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * optional string diary_role = 10;
 * @return {string}
 */
proto.claims_messages.ClaimsListRequest.prototype.getDiaryRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.setDiaryRole = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearDiaryRole = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasDiaryRole = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional BenefitCodes benefit_codes = 11;
 * @return {?proto.claims_messages.BenefitCodes}
 */
proto.claims_messages.ClaimsListRequest.prototype.getBenefitCodes = function() {
  return /** @type{?proto.claims_messages.BenefitCodes} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.BenefitCodes, 11));
};


/**
 * @param {?proto.claims_messages.BenefitCodes|undefined} value
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
*/
proto.claims_messages.ClaimsListRequest.prototype.setBenefitCodes = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsListRequest} returns this
 */
proto.claims_messages.ClaimsListRequest.prototype.clearBenefitCodes = function() {
  return this.setBenefitCodes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListRequest.prototype.hasBenefitCodes = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ClaimsListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claimList: jspb.Message.toObjectList(msg.getClaimList(),
    proto.claims_messages.Claim.toObject, includeInstance),
paginationResponse: (f = msg.getPaginationResponse()) && messages_core_message_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsListResponse}
 */
proto.claims_messages.ClaimsListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsListResponse;
  return proto.claims_messages.ClaimsListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsListResponse}
 */
proto.claims_messages.ClaimsListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Claim;
      reader.readMessage(value,proto.claims_messages.Claim.deserializeBinaryFromReader);
      msg.addClaim(value);
      break;
    case 2:
      var value = new messages_core_message_pb.PaginationResponse;
      reader.readMessage(value,messages_core_message_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Claim.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Claim claim = 1;
 * @return {!Array<!proto.claims_messages.Claim>}
 */
proto.claims_messages.ClaimsListResponse.prototype.getClaimList = function() {
  return /** @type{!Array<!proto.claims_messages.Claim>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Claim, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Claim>} value
 * @return {!proto.claims_messages.ClaimsListResponse} returns this
*/
proto.claims_messages.ClaimsListResponse.prototype.setClaimList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Claim=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Claim}
 */
proto.claims_messages.ClaimsListResponse.prototype.addClaim = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Claim, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ClaimsListResponse} returns this
 */
proto.claims_messages.ClaimsListResponse.prototype.clearClaimList = function() {
  return this.setClaimList([]);
};


/**
 * optional core_messages.PaginationResponse pagination_response = 2;
 * @return {?proto.core_messages.PaginationResponse}
 */
proto.claims_messages.ClaimsListResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.core_messages.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.core_messages.PaginationResponse|undefined} value
 * @return {!proto.claims_messages.ClaimsListResponse} returns this
*/
proto.claims_messages.ClaimsListResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsListResponse} returns this
 */
proto.claims_messages.ClaimsListResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsListResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
term: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsSearchRequest}
 */
proto.claims_messages.ClaimsSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsSearchRequest;
  return proto.claims_messages.ClaimsSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsSearchRequest}
 */
proto.claims_messages.ClaimsSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTerm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string term = 1;
 * @return {string}
 */
proto.claims_messages.ClaimsSearchRequest.prototype.getTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsSearchRequest} returns this
 */
proto.claims_messages.ClaimsSearchRequest.prototype.setTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ClaimsSearchResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claimList: jspb.Message.toObjectList(msg.getClaimList(),
    proto.claims_messages.Claim.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsSearchResponse}
 */
proto.claims_messages.ClaimsSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsSearchResponse;
  return proto.claims_messages.ClaimsSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsSearchResponse}
 */
proto.claims_messages.ClaimsSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Claim;
      reader.readMessage(value,proto.claims_messages.Claim.deserializeBinaryFromReader);
      msg.addClaim(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Claim.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Claim claim = 1;
 * @return {!Array<!proto.claims_messages.Claim>}
 */
proto.claims_messages.ClaimsSearchResponse.prototype.getClaimList = function() {
  return /** @type{!Array<!proto.claims_messages.Claim>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Claim, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Claim>} value
 * @return {!proto.claims_messages.ClaimsSearchResponse} returns this
*/
proto.claims_messages.ClaimsSearchResponse.prototype.setClaimList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Claim=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Claim}
 */
proto.claims_messages.ClaimsSearchResponse.prototype.addClaim = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Claim, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ClaimsSearchResponse} returns this
 */
proto.claims_messages.ClaimsSearchResponse.prototype.clearClaimList = function() {
  return this.setClaimList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsApproveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsApproveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsApproveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsApproveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsApproveRequest}
 */
proto.claims_messages.ClaimsApproveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsApproveRequest;
  return proto.claims_messages.ClaimsApproveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsApproveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsApproveRequest}
 */
proto.claims_messages.ClaimsApproveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsApproveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsApproveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsApproveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsApproveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsApproveRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsApproveRequest} returns this
 */
proto.claims_messages.ClaimsApproveRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsApproveResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsApproveResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsApproveResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsApproveResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsApproveResponse}
 */
proto.claims_messages.ClaimsApproveResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsApproveResponse;
  return proto.claims_messages.ClaimsApproveResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsApproveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsApproveResponse}
 */
proto.claims_messages.ClaimsApproveResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsApproveResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsApproveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsApproveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsApproveResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsDenyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsDenyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsDenyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDenyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
denyReason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsDenyRequest}
 */
proto.claims_messages.ClaimsDenyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsDenyRequest;
  return proto.claims_messages.ClaimsDenyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsDenyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsDenyRequest}
 */
proto.claims_messages.ClaimsDenyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDenyReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsDenyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsDenyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsDenyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDenyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDenyReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsDenyRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsDenyRequest} returns this
 */
proto.claims_messages.ClaimsDenyRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string deny_reason = 2;
 * @return {string}
 */
proto.claims_messages.ClaimsDenyRequest.prototype.getDenyReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsDenyRequest} returns this
 */
proto.claims_messages.ClaimsDenyRequest.prototype.setDenyReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsDenyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsDenyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsDenyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDenyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsDenyResponse}
 */
proto.claims_messages.ClaimsDenyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsDenyResponse;
  return proto.claims_messages.ClaimsDenyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsDenyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsDenyResponse}
 */
proto.claims_messages.ClaimsDenyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsDenyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsDenyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsDenyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDenyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsInReviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsInReviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsInReviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsInReviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsInReviewRequest}
 */
proto.claims_messages.ClaimsInReviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsInReviewRequest;
  return proto.claims_messages.ClaimsInReviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsInReviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsInReviewRequest}
 */
proto.claims_messages.ClaimsInReviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsInReviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsInReviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsInReviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsInReviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsInReviewRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsInReviewRequest} returns this
 */
proto.claims_messages.ClaimsInReviewRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsInReviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsInReviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsInReviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsInReviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsInReviewResponse}
 */
proto.claims_messages.ClaimsInReviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsInReviewResponse;
  return proto.claims_messages.ClaimsInReviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsInReviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsInReviewResponse}
 */
proto.claims_messages.ClaimsInReviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsInReviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsInReviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsInReviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsInReviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsQueueForPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsQueueForPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsQueueForPaymentRequest}
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsQueueForPaymentRequest;
  return proto.claims_messages.ClaimsQueueForPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsQueueForPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsQueueForPaymentRequest}
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsQueueForPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsQueueForPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsQueueForPaymentRequest} returns this
 */
proto.claims_messages.ClaimsQueueForPaymentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsQueueForPaymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsQueueForPaymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsQueueForPaymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsQueueForPaymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsQueueForPaymentResponse}
 */
proto.claims_messages.ClaimsQueueForPaymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsQueueForPaymentResponse;
  return proto.claims_messages.ClaimsQueueForPaymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsQueueForPaymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsQueueForPaymentResponse}
 */
proto.claims_messages.ClaimsQueueForPaymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsQueueForPaymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsQueueForPaymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsQueueForPaymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsQueueForPaymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsClosePaidRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsClosePaidRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsClosePaidRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsClosePaidRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsClosePaidRequest}
 */
proto.claims_messages.ClaimsClosePaidRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsClosePaidRequest;
  return proto.claims_messages.ClaimsClosePaidRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsClosePaidRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsClosePaidRequest}
 */
proto.claims_messages.ClaimsClosePaidRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsClosePaidRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsClosePaidRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsClosePaidRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsClosePaidRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsClosePaidRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsClosePaidRequest} returns this
 */
proto.claims_messages.ClaimsClosePaidRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsClosePaidResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsClosePaidResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsClosePaidResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsClosePaidResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsClosePaidResponse}
 */
proto.claims_messages.ClaimsClosePaidResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsClosePaidResponse;
  return proto.claims_messages.ClaimsClosePaidResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsClosePaidResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsClosePaidResponse}
 */
proto.claims_messages.ClaimsClosePaidResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsClosePaidResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsClosePaidResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsClosePaidResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsClosePaidResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsCloseNotPaidRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsCloseNotPaidRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidRequest}
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsCloseNotPaidRequest;
  return proto.claims_messages.ClaimsCloseNotPaidRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidRequest}
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsCloseNotPaidRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsCloseNotPaidRequest} returns this
 */
proto.claims_messages.ClaimsCloseNotPaidRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsCloseNotPaidResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsCloseNotPaidResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsCloseNotPaidResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidResponse}
 */
proto.claims_messages.ClaimsCloseNotPaidResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsCloseNotPaidResponse;
  return proto.claims_messages.ClaimsCloseNotPaidResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidResponse}
 */
proto.claims_messages.ClaimsCloseNotPaidResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsCloseNotPaidResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsCloseNotPaidResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest;
  return proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest} returns this
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse;
  return proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCloseNotPaidGoodwillResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsDuplicateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsDuplicateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsDuplicateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDuplicateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsDuplicateRequest}
 */
proto.claims_messages.ClaimsDuplicateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsDuplicateRequest;
  return proto.claims_messages.ClaimsDuplicateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsDuplicateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsDuplicateRequest}
 */
proto.claims_messages.ClaimsDuplicateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsDuplicateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsDuplicateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsDuplicateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDuplicateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsDuplicateRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsDuplicateRequest} returns this
 */
proto.claims_messages.ClaimsDuplicateRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsDuplicateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsDuplicateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsDuplicateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDuplicateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsDuplicateResponse}
 */
proto.claims_messages.ClaimsDuplicateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsDuplicateResponse;
  return proto.claims_messages.ClaimsDuplicateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsDuplicateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsDuplicateResponse}
 */
proto.claims_messages.ClaimsDuplicateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsDuplicateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsDuplicateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsDuplicateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDuplicateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsPendingProviderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsPendingProviderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsPendingProviderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingProviderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
sendEmail: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsPendingProviderRequest}
 */
proto.claims_messages.ClaimsPendingProviderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsPendingProviderRequest;
  return proto.claims_messages.ClaimsPendingProviderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsPendingProviderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsPendingProviderRequest}
 */
proto.claims_messages.ClaimsPendingProviderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsPendingProviderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsPendingProviderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsPendingProviderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingProviderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSendEmail();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsPendingProviderRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsPendingProviderRequest} returns this
 */
proto.claims_messages.ClaimsPendingProviderRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool send_email = 2;
 * @return {boolean}
 */
proto.claims_messages.ClaimsPendingProviderRequest.prototype.getSendEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsPendingProviderRequest} returns this
 */
proto.claims_messages.ClaimsPendingProviderRequest.prototype.setSendEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsPendingProviderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsPendingProviderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsPendingProviderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingProviderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsPendingProviderResponse}
 */
proto.claims_messages.ClaimsPendingProviderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsPendingProviderResponse;
  return proto.claims_messages.ClaimsPendingProviderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsPendingProviderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsPendingProviderResponse}
 */
proto.claims_messages.ClaimsPendingProviderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsPendingProviderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsPendingProviderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsPendingProviderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingProviderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsPendingVerificationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsPendingVerificationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsPendingVerificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingVerificationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsPendingVerificationRequest}
 */
proto.claims_messages.ClaimsPendingVerificationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsPendingVerificationRequest;
  return proto.claims_messages.ClaimsPendingVerificationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsPendingVerificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsPendingVerificationRequest}
 */
proto.claims_messages.ClaimsPendingVerificationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsPendingVerificationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsPendingVerificationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsPendingVerificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingVerificationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsPendingVerificationRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsPendingVerificationRequest} returns this
 */
proto.claims_messages.ClaimsPendingVerificationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsPendingVerificationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsPendingVerificationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsPendingVerificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingVerificationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsPendingVerificationResponse}
 */
proto.claims_messages.ClaimsPendingVerificationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsPendingVerificationResponse;
  return proto.claims_messages.ClaimsPendingVerificationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsPendingVerificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsPendingVerificationResponse}
 */
proto.claims_messages.ClaimsPendingVerificationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsPendingVerificationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsPendingVerificationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsPendingVerificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingVerificationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsPendingInternalReviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsPendingInternalReviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsPendingInternalReviewRequest}
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsPendingInternalReviewRequest;
  return proto.claims_messages.ClaimsPendingInternalReviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsPendingInternalReviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsPendingInternalReviewRequest}
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsPendingInternalReviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsPendingInternalReviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsPendingInternalReviewRequest} returns this
 */
proto.claims_messages.ClaimsPendingInternalReviewRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsPendingInternalReviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsPendingInternalReviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsPendingInternalReviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingInternalReviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsPendingInternalReviewResponse}
 */
proto.claims_messages.ClaimsPendingInternalReviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsPendingInternalReviewResponse;
  return proto.claims_messages.ClaimsPendingInternalReviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsPendingInternalReviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsPendingInternalReviewResponse}
 */
proto.claims_messages.ClaimsPendingInternalReviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsPendingInternalReviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsPendingInternalReviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsPendingInternalReviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsPendingInternalReviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssociateDocsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssociateDocsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
file: (f = msg.getFile()) && messages_file_message_pb.File.toObject(includeInstance, f),
category: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssociateDocsRequest}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssociateDocsRequest;
  return proto.claims_messages.ClaimsAssociateDocsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssociateDocsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssociateDocsRequest}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = new messages_file_message_pb.File;
      reader.readMessage(value,messages_file_message_pb.File.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    case 3:
      var value = /** @type {!proto.claims_messages.DocumentCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssociateDocsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssociateDocsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_file_message_pb.File.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsRequest} returns this
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional file_messages.File file = 2;
 * @return {?proto.file_messages.File}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.getFile = function() {
  return /** @type{?proto.file_messages.File} */ (
    jspb.Message.getWrapperField(this, messages_file_message_pb.File, 2));
};


/**
 * @param {?proto.file_messages.File|undefined} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsRequest} returns this
*/
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.setFile = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssociateDocsRequest} returns this
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.hasFile = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DocumentCategory category = 3;
 * @return {!proto.claims_messages.DocumentCategory}
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.getCategory = function() {
  return /** @type {!proto.claims_messages.DocumentCategory} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.claims_messages.DocumentCategory} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsRequest} returns this
 */
proto.claims_messages.ClaimsAssociateDocsRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssociateDocsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssociateDocsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssociateDocsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssociateDocsResponse}
 */
proto.claims_messages.ClaimsAssociateDocsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssociateDocsResponse;
  return proto.claims_messages.ClaimsAssociateDocsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssociateDocsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssociateDocsResponse}
 */
proto.claims_messages.ClaimsAssociateDocsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssociateDocsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssociateDocsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssociateDocsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CoreClaimsAssociateDocsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CoreClaimsAssociateDocsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
file: (f = msg.getFile()) && messages_file_message_pb.FileIdentifier.toObject(includeInstance, f),
category: jspb.Message.getFieldWithDefault(msg, 3, 0),
isGenerated: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsRequest}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CoreClaimsAssociateDocsRequest;
  return proto.claims_messages.CoreClaimsAssociateDocsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CoreClaimsAssociateDocsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsRequest}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = new messages_file_message_pb.FileIdentifier;
      reader.readMessage(value,messages_file_message_pb.FileIdentifier.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    case 3:
      var value = /** @type {!proto.claims_messages.DocumentCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGenerated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CoreClaimsAssociateDocsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CoreClaimsAssociateDocsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_file_message_pb.FileIdentifier.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getIsGenerated();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsRequest} returns this
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional file_messages.FileIdentifier file = 2;
 * @return {?proto.file_messages.FileIdentifier}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.getFile = function() {
  return /** @type{?proto.file_messages.FileIdentifier} */ (
    jspb.Message.getWrapperField(this, messages_file_message_pb.FileIdentifier, 2));
};


/**
 * @param {?proto.file_messages.FileIdentifier|undefined} value
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsRequest} returns this
*/
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.setFile = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsRequest} returns this
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.hasFile = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DocumentCategory category = 3;
 * @return {!proto.claims_messages.DocumentCategory}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.getCategory = function() {
  return /** @type {!proto.claims_messages.DocumentCategory} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.claims_messages.DocumentCategory} value
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsRequest} returns this
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool is_generated = 4;
 * @return {boolean}
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.getIsGenerated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsRequest} returns this
 */
proto.claims_messages.CoreClaimsAssociateDocsRequest.prototype.setIsGenerated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CoreClaimsAssociateDocsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CoreClaimsAssociateDocsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CoreClaimsAssociateDocsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsAssociateDocsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsResponse}
 */
proto.claims_messages.CoreClaimsAssociateDocsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CoreClaimsAssociateDocsResponse;
  return proto.claims_messages.CoreClaimsAssociateDocsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CoreClaimsAssociateDocsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CoreClaimsAssociateDocsResponse}
 */
proto.claims_messages.CoreClaimsAssociateDocsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CoreClaimsAssociateDocsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CoreClaimsAssociateDocsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CoreClaimsAssociateDocsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsAssociateDocsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RemoveAssociatedDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RemoveAssociatedDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RemoveAssociatedDocumentRequest}
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RemoveAssociatedDocumentRequest;
  return proto.claims_messages.RemoveAssociatedDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RemoveAssociatedDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RemoveAssociatedDocumentRequest}
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RemoveAssociatedDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RemoveAssociatedDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.RemoveAssociatedDocumentRequest} returns this
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.RemoveAssociatedDocumentRequest} returns this
 */
proto.claims_messages.RemoveAssociatedDocumentRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RemoveAssociatedDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RemoveAssociatedDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RemoveAssociatedDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveAssociatedDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RemoveAssociatedDocumentResponse}
 */
proto.claims_messages.RemoveAssociatedDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RemoveAssociatedDocumentResponse;
  return proto.claims_messages.RemoveAssociatedDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RemoveAssociatedDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RemoveAssociatedDocumentResponse}
 */
proto.claims_messages.RemoveAssociatedDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RemoveAssociatedDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RemoveAssociatedDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RemoveAssociatedDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveAssociatedDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RecoverAssociatedDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RecoverAssociatedDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RecoverAssociatedDocumentRequest}
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RecoverAssociatedDocumentRequest;
  return proto.claims_messages.RecoverAssociatedDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RecoverAssociatedDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RecoverAssociatedDocumentRequest}
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RecoverAssociatedDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RecoverAssociatedDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.RecoverAssociatedDocumentRequest} returns this
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.RecoverAssociatedDocumentRequest} returns this
 */
proto.claims_messages.RecoverAssociatedDocumentRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RecoverAssociatedDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RecoverAssociatedDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RecoverAssociatedDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverAssociatedDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RecoverAssociatedDocumentResponse}
 */
proto.claims_messages.RecoverAssociatedDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RecoverAssociatedDocumentResponse;
  return proto.claims_messages.RecoverAssociatedDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RecoverAssociatedDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RecoverAssociatedDocumentResponse}
 */
proto.claims_messages.RecoverAssociatedDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RecoverAssociatedDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RecoverAssociatedDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RecoverAssociatedDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverAssociatedDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest;
  return proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest} returns this
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest} returns this
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse;
  return proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PermanentlyRemoveAssociatedDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssociateDocsChunkMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
category: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalSize: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssociateDocsChunkMetadata;
  return proto.claims_messages.ClaimsAssociateDocsChunkMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {!proto.claims_messages.DocumentCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssociateDocsChunkMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional DocumentCategory category = 5;
 * @return {!proto.claims_messages.DocumentCategory}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.getCategory = function() {
  return /** @type {!proto.claims_messages.DocumentCategory} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.claims_messages.DocumentCategory} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional uint64 total_size = 6;
 * @return {number}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.getTotalSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.setTotalSize = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkMetadata} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.clearTotalSize = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssociateDocsChunkMetadata.prototype.hasTotalSize = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssociateDocsChunkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
metadata: (f = msg.getMetadata()) && proto.claims_messages.ClaimsAssociateDocsChunkMetadata.toObject(includeInstance, f),
chunkData: msg.getChunkData_asB64(),
sequenceNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
isLastChunk: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkRequest}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssociateDocsChunkRequest;
  return proto.claims_messages.ClaimsAssociateDocsChunkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkRequest}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsAssociateDocsChunkMetadata;
      reader.readMessage(value,proto.claims_messages.ClaimsAssociateDocsChunkMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChunkData(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSequenceNumber(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLastChunk(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssociateDocsChunkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimsAssociateDocsChunkMetadata.serializeBinaryToWriter
    );
  }
  f = message.getChunkData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getIsLastChunk();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional ClaimsAssociateDocsChunkMetadata metadata = 1;
 * @return {?proto.claims_messages.ClaimsAssociateDocsChunkMetadata}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.getMetadata = function() {
  return /** @type{?proto.claims_messages.ClaimsAssociateDocsChunkMetadata} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimsAssociateDocsChunkMetadata, 1));
};


/**
 * @param {?proto.claims_messages.ClaimsAssociateDocsChunkMetadata|undefined} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} returns this
*/
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes chunk_data = 2;
 * @return {string}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.getChunkData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes chunk_data = 2;
 * This is a type-conversion wrapper around `getChunkData()`
 * @return {string}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.getChunkData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChunkData()));
};


/**
 * optional bytes chunk_data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChunkData()`
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.getChunkData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChunkData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.setChunkData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional uint32 sequence_number = 3;
 * @return {number}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool is_last_chunk = 4;
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.getIsLastChunk = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkRequest} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkRequest.prototype.setIsLastChunk = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssociateDocsChunkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
bytesReceived: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkResponse}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssociateDocsChunkResponse;
  return proto.claims_messages.ClaimsAssociateDocsChunkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkResponse}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBytesReceived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssociateDocsChunkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssociateDocsChunkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBytesReceived();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkResponse} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkResponse} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.setFileId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkResponse} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.clearFileId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.hasFileId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 bytes_received = 3;
 * @return {number}
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.getBytesReceived = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssociateDocsChunkResponse} returns this
 */
proto.claims_messages.ClaimsAssociateDocsChunkResponse.prototype.setBytesReceived = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsCancelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsCancelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsCancelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCancelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsCancelRequest}
 */
proto.claims_messages.ClaimsCancelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsCancelRequest;
  return proto.claims_messages.ClaimsCancelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsCancelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsCancelRequest}
 */
proto.claims_messages.ClaimsCancelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsCancelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsCancelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsCancelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCancelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsCancelRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsCancelRequest} returns this
 */
proto.claims_messages.ClaimsCancelRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.claims_messages.ClaimsCancelRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsCancelRequest} returns this
 */
proto.claims_messages.ClaimsCancelRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsCancelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsCancelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsCancelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCancelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsCancelResponse}
 */
proto.claims_messages.ClaimsCancelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsCancelResponse;
  return proto.claims_messages.ClaimsCancelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsCancelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsCancelResponse}
 */
proto.claims_messages.ClaimsCancelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsCancelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsCancelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsCancelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsCancelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UncancelClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UncancelClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UncancelClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UncancelClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UncancelClaimRequest}
 */
proto.claims_messages.UncancelClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UncancelClaimRequest;
  return proto.claims_messages.UncancelClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UncancelClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UncancelClaimRequest}
 */
proto.claims_messages.UncancelClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UncancelClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UncancelClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UncancelClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UncancelClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.UncancelClaimRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.UncancelClaimRequest} returns this
 */
proto.claims_messages.UncancelClaimRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UncancelClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UncancelClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UncancelClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UncancelClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UncancelClaimResponse}
 */
proto.claims_messages.UncancelClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UncancelClaimResponse;
  return proto.claims_messages.UncancelClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UncancelClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UncancelClaimResponse}
 */
proto.claims_messages.UncancelClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UncancelClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UncancelClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UncancelClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UncancelClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CoreClaimsGetDocsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CoreClaimsGetDocsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CoreClaimsGetDocsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsGetDocsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CoreClaimsGetDocsRequest}
 */
proto.claims_messages.CoreClaimsGetDocsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CoreClaimsGetDocsRequest;
  return proto.claims_messages.CoreClaimsGetDocsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CoreClaimsGetDocsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CoreClaimsGetDocsRequest}
 */
proto.claims_messages.CoreClaimsGetDocsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CoreClaimsGetDocsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CoreClaimsGetDocsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CoreClaimsGetDocsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsGetDocsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.CoreClaimsGetDocsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CoreClaimsGetDocsRequest} returns this
 */
proto.claims_messages.CoreClaimsGetDocsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.CoreClaimsGetDocsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CoreClaimsGetDocsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CoreClaimsGetDocsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CoreClaimsGetDocsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsGetDocsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.claims_messages.ClaimsDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CoreClaimsGetDocsResponse}
 */
proto.claims_messages.CoreClaimsGetDocsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CoreClaimsGetDocsResponse;
  return proto.claims_messages.CoreClaimsGetDocsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CoreClaimsGetDocsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CoreClaimsGetDocsResponse}
 */
proto.claims_messages.CoreClaimsGetDocsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsDocument;
      reader.readMessage(value,proto.claims_messages.ClaimsDocument.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CoreClaimsGetDocsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CoreClaimsGetDocsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CoreClaimsGetDocsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CoreClaimsGetDocsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsDocument.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsDocument documents = 1;
 * @return {!Array<!proto.claims_messages.ClaimsDocument>}
 */
proto.claims_messages.CoreClaimsGetDocsResponse.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsDocument, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsDocument>} value
 * @return {!proto.claims_messages.CoreClaimsGetDocsResponse} returns this
*/
proto.claims_messages.CoreClaimsGetDocsResponse.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsDocument}
 */
proto.claims_messages.CoreClaimsGetDocsResponse.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.CoreClaimsGetDocsResponse} returns this
 */
proto.claims_messages.CoreClaimsGetDocsResponse.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.Note.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.Note.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.Note} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Note.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
userId: jspb.Message.getFieldWithDefault(msg, 3, 0),
userName: jspb.Message.getFieldWithDefault(msg, 4, ""),
userRole: jspb.Message.getFieldWithDefault(msg, 5, ""),
note: jspb.Message.getFieldWithDefault(msg, 6, ""),
noteType: (f = msg.getNoteType()) && proto.claims_messages.NoteType.toObject(includeInstance, f),
isPinned: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.Note}
 */
proto.claims_messages.Note.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.Note;
  return proto.claims_messages.Note.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.Note} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.Note}
 */
proto.claims_messages.Note.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserRole(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 7:
      var value = new proto.claims_messages.NoteType;
      reader.readMessage(value,proto.claims_messages.NoteType.deserializeBinaryFromReader);
      msg.setNoteType(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPinned(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.Note.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.Note.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.Note} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Note.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserRole();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNoteType();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.claims_messages.NoteType.serializeBinaryToWriter
    );
  }
  f = message.getIsPinned();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.Note.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.Note.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.claims_messages.Note.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string user_name = 4;
 * @return {string}
 */
proto.claims_messages.Note.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string user_role = 5;
 * @return {string}
 */
proto.claims_messages.Note.prototype.getUserRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setUserRole = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string note = 6;
 * @return {string}
 */
proto.claims_messages.Note.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional NoteType note_type = 7;
 * @return {?proto.claims_messages.NoteType}
 */
proto.claims_messages.Note.prototype.getNoteType = function() {
  return /** @type{?proto.claims_messages.NoteType} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.NoteType, 7));
};


/**
 * @param {?proto.claims_messages.NoteType|undefined} value
 * @return {!proto.claims_messages.Note} returns this
*/
proto.claims_messages.Note.prototype.setNoteType = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.clearNoteType = function() {
  return this.setNoteType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Note.prototype.hasNoteType = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool is_pinned = 8;
 * @return {boolean}
 */
proto.claims_messages.Note.prototype.getIsPinned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setIsPinned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.claims_messages.Note.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Note} returns this
 */
proto.claims_messages.Note.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.NoteType.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.NoteType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.NoteType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.NoteType.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.NoteType}
 */
proto.claims_messages.NoteType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.NoteType;
  return proto.claims_messages.NoteType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.NoteType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.NoteType}
 */
proto.claims_messages.NoteType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.NoteType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.NoteType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.NoteType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.NoteType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.claims_messages.NoteType.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.NoteType} returns this
 */
proto.claims_messages.NoteType.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.claims_messages.NoteType.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.NoteType} returns this
 */
proto.claims_messages.NoteType.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.claims_messages.NoteType.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.NoteType} returns this
 */
proto.claims_messages.NoteType.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
note: jspb.Message.getFieldWithDefault(msg, 2, ""),
noteType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateNoteRequest}
 */
proto.claims_messages.CreateNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateNoteRequest;
  return proto.claims_messages.CreateNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateNoteRequest}
 */
proto.claims_messages.CreateNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 3:
      var value = /** @type {!proto.claims_messages.NoteTypeName} */ (reader.readEnum());
      msg.setNoteType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNoteType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.CreateNoteRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateNoteRequest} returns this
 */
proto.claims_messages.CreateNoteRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string note = 2;
 * @return {string}
 */
proto.claims_messages.CreateNoteRequest.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateNoteRequest} returns this
 */
proto.claims_messages.CreateNoteRequest.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional NoteTypeName note_type = 3;
 * @return {!proto.claims_messages.NoteTypeName}
 */
proto.claims_messages.CreateNoteRequest.prototype.getNoteType = function() {
  return /** @type {!proto.claims_messages.NoteTypeName} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.claims_messages.NoteTypeName} value
 * @return {!proto.claims_messages.CreateNoteRequest} returns this
 */
proto.claims_messages.CreateNoteRequest.prototype.setNoteType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateNoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateNoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateNoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
note: (f = msg.getNote()) && proto.claims_messages.Note.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateNoteResponse}
 */
proto.claims_messages.CreateNoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateNoteResponse;
  return proto.claims_messages.CreateNoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateNoteResponse}
 */
proto.claims_messages.CreateNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Note;
      reader.readMessage(value,proto.claims_messages.Note.deserializeBinaryFromReader);
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateNoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateNoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateNoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNote();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Note.serializeBinaryToWriter
    );
  }
};


/**
 * optional Note note = 1;
 * @return {?proto.claims_messages.Note}
 */
proto.claims_messages.CreateNoteResponse.prototype.getNote = function() {
  return /** @type{?proto.claims_messages.Note} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Note, 1));
};


/**
 * @param {?proto.claims_messages.Note|undefined} value
 * @return {!proto.claims_messages.CreateNoteResponse} returns this
*/
proto.claims_messages.CreateNoteResponse.prototype.setNote = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.CreateNoteResponse} returns this
 */
proto.claims_messages.CreateNoteResponse.prototype.clearNote = function() {
  return this.setNote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateNoteResponse.prototype.hasNote = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteNoteRequest}
 */
proto.claims_messages.DeleteNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteNoteRequest;
  return proto.claims_messages.DeleteNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteNoteRequest}
 */
proto.claims_messages.DeleteNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNoteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 note_id = 1;
 * @return {number}
 */
proto.claims_messages.DeleteNoteRequest.prototype.getNoteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DeleteNoteRequest} returns this
 */
proto.claims_messages.DeleteNoteRequest.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DeleteNoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DeleteNoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DeleteNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteNoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DeleteNoteResponse}
 */
proto.claims_messages.DeleteNoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DeleteNoteResponse;
  return proto.claims_messages.DeleteNoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DeleteNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DeleteNoteResponse}
 */
proto.claims_messages.DeleteNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DeleteNoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DeleteNoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DeleteNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DeleteNoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNoteByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNoteByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNoteByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNoteByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNoteByIdRequest}
 */
proto.claims_messages.GetNoteByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNoteByIdRequest;
  return proto.claims_messages.GetNoteByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNoteByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNoteByIdRequest}
 */
proto.claims_messages.GetNoteByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNoteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNoteByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNoteByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNoteByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNoteByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 note_id = 1;
 * @return {number}
 */
proto.claims_messages.GetNoteByIdRequest.prototype.getNoteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetNoteByIdRequest} returns this
 */
proto.claims_messages.GetNoteByIdRequest.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNoteByIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNoteByIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNoteByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNoteByIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
note: (f = msg.getNote()) && proto.claims_messages.Note.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNoteByIdResponse}
 */
proto.claims_messages.GetNoteByIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNoteByIdResponse;
  return proto.claims_messages.GetNoteByIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNoteByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNoteByIdResponse}
 */
proto.claims_messages.GetNoteByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Note;
      reader.readMessage(value,proto.claims_messages.Note.deserializeBinaryFromReader);
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNoteByIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNoteByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNoteByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNoteByIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNote();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Note.serializeBinaryToWriter
    );
  }
};


/**
 * optional Note note = 1;
 * @return {?proto.claims_messages.Note}
 */
proto.claims_messages.GetNoteByIdResponse.prototype.getNote = function() {
  return /** @type{?proto.claims_messages.Note} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Note, 1));
};


/**
 * @param {?proto.claims_messages.Note|undefined} value
 * @return {!proto.claims_messages.GetNoteByIdResponse} returns this
*/
proto.claims_messages.GetNoteByIdResponse.prototype.setNote = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.GetNoteByIdResponse} returns this
 */
proto.claims_messages.GetNoteByIdResponse.prototype.clearNote = function() {
  return this.setNote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetNoteByIdResponse.prototype.hasNote = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetNotesByIdRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNotesByIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNotesByIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNotesByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNotesByIdRequest}
 */
proto.claims_messages.GetNotesByIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNotesByIdRequest;
  return proto.claims_messages.GetNotesByIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNotesByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNotesByIdRequest}
 */
proto.claims_messages.GetNotesByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addNoteIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNotesByIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNotesByIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNotesByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 note_ids = 1;
 * @return {!Array<number>}
 */
proto.claims_messages.GetNotesByIdRequest.prototype.getNoteIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.claims_messages.GetNotesByIdRequest} returns this
 */
proto.claims_messages.GetNotesByIdRequest.prototype.setNoteIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.GetNotesByIdRequest} returns this
 */
proto.claims_messages.GetNotesByIdRequest.prototype.addNoteIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetNotesByIdRequest} returns this
 */
proto.claims_messages.GetNotesByIdRequest.prototype.clearNoteIdsList = function() {
  return this.setNoteIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetNotesByIdResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNotesByIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNotesByIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNotesByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.claims_messages.Note.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNotesByIdResponse}
 */
proto.claims_messages.GetNotesByIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNotesByIdResponse;
  return proto.claims_messages.GetNotesByIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNotesByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNotesByIdResponse}
 */
proto.claims_messages.GetNotesByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Note;
      reader.readMessage(value,proto.claims_messages.Note.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNotesByIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNotesByIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNotesByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Note.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Note notes = 1;
 * @return {!Array<!proto.claims_messages.Note>}
 */
proto.claims_messages.GetNotesByIdResponse.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.claims_messages.Note>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Note, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Note>} value
 * @return {!proto.claims_messages.GetNotesByIdResponse} returns this
*/
proto.claims_messages.GetNotesByIdResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Note}
 */
proto.claims_messages.GetNotesByIdResponse.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Note, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetNotesByIdResponse} returns this
 */
proto.claims_messages.GetNotesByIdResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNotesByClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNotesByClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNotesByClaimRequest}
 */
proto.claims_messages.GetNotesByClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNotesByClaimRequest;
  return proto.claims_messages.GetNotesByClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNotesByClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNotesByClaimRequest}
 */
proto.claims_messages.GetNotesByClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNotesByClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNotesByClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetNotesByClaimRequest} returns this
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetNotesByClaimRequest} returns this
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetNotesByClaimRequest} returns this
 */
proto.claims_messages.GetNotesByClaimRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetNotesByClaimResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNotesByClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNotesByClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.claims_messages.Note.toObject, includeInstance),
paginationResponse: (f = msg.getPaginationResponse()) && messages_core_message_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNotesByClaimResponse}
 */
proto.claims_messages.GetNotesByClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNotesByClaimResponse;
  return proto.claims_messages.GetNotesByClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNotesByClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNotesByClaimResponse}
 */
proto.claims_messages.GetNotesByClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Note;
      reader.readMessage(value,proto.claims_messages.Note.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    case 2:
      var value = new messages_core_message_pb.PaginationResponse;
      reader.readMessage(value,messages_core_message_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNotesByClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNotesByClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Note.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Note notes = 1;
 * @return {!Array<!proto.claims_messages.Note>}
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.claims_messages.Note>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Note, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Note>} value
 * @return {!proto.claims_messages.GetNotesByClaimResponse} returns this
*/
proto.claims_messages.GetNotesByClaimResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Note}
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Note, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetNotesByClaimResponse} returns this
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};


/**
 * optional core_messages.PaginationResponse pagination_response = 2;
 * @return {?proto.core_messages.PaginationResponse}
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.core_messages.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.core_messages.PaginationResponse|undefined} value
 * @return {!proto.claims_messages.GetNotesByClaimResponse} returns this
*/
proto.claims_messages.GetNotesByClaimResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.GetNotesByClaimResponse} returns this
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetNotesByClaimResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetPinnedNotesByClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetPinnedNotesByClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetPinnedNotesByClaimRequest}
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetPinnedNotesByClaimRequest;
  return proto.claims_messages.GetPinnedNotesByClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetPinnedNotesByClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetPinnedNotesByClaimRequest}
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetPinnedNotesByClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetPinnedNotesByClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetPinnedNotesByClaimRequest} returns this
 */
proto.claims_messages.GetPinnedNotesByClaimRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetPinnedNotesByClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetPinnedNotesByClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.claims_messages.Note.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetPinnedNotesByClaimResponse}
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetPinnedNotesByClaimResponse;
  return proto.claims_messages.GetPinnedNotesByClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetPinnedNotesByClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetPinnedNotesByClaimResponse}
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Note;
      reader.readMessage(value,proto.claims_messages.Note.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetPinnedNotesByClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetPinnedNotesByClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Note.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Note notes = 1;
 * @return {!Array<!proto.claims_messages.Note>}
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.claims_messages.Note>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Note, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Note>} value
 * @return {!proto.claims_messages.GetPinnedNotesByClaimResponse} returns this
*/
proto.claims_messages.GetPinnedNotesByClaimResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Note}
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Note, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetPinnedNotesByClaimResponse} returns this
 */
proto.claims_messages.GetPinnedNotesByClaimResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNotesByUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNotesByUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNotesByUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNotesByUserRequest}
 */
proto.claims_messages.GetNotesByUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNotesByUserRequest;
  return proto.claims_messages.GetNotesByUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNotesByUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNotesByUserRequest}
 */
proto.claims_messages.GetNotesByUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNotesByUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNotesByUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNotesByUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.claims_messages.GetNotesByUserRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetNotesByUserRequest} returns this
 */
proto.claims_messages.GetNotesByUserRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetNotesByUserResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetNotesByUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetNotesByUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetNotesByUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.claims_messages.Note.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetNotesByUserResponse}
 */
proto.claims_messages.GetNotesByUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetNotesByUserResponse;
  return proto.claims_messages.GetNotesByUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetNotesByUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetNotesByUserResponse}
 */
proto.claims_messages.GetNotesByUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Note;
      reader.readMessage(value,proto.claims_messages.Note.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetNotesByUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetNotesByUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetNotesByUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetNotesByUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Note.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Note notes = 1;
 * @return {!Array<!proto.claims_messages.Note>}
 */
proto.claims_messages.GetNotesByUserResponse.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.claims_messages.Note>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Note, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Note>} value
 * @return {!proto.claims_messages.GetNotesByUserResponse} returns this
*/
proto.claims_messages.GetNotesByUserResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Note}
 */
proto.claims_messages.GetNotesByUserResponse.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Note, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetNotesByUserResponse} returns this
 */
proto.claims_messages.GetNotesByUserResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PinNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PinNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PinNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PinNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PinNoteRequest}
 */
proto.claims_messages.PinNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PinNoteRequest;
  return proto.claims_messages.PinNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PinNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PinNoteRequest}
 */
proto.claims_messages.PinNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNoteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PinNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PinNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PinNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PinNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 note_id = 1;
 * @return {number}
 */
proto.claims_messages.PinNoteRequest.prototype.getNoteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.PinNoteRequest} returns this
 */
proto.claims_messages.PinNoteRequest.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PinNoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PinNoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PinNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PinNoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PinNoteResponse}
 */
proto.claims_messages.PinNoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PinNoteResponse;
  return proto.claims_messages.PinNoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PinNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PinNoteResponse}
 */
proto.claims_messages.PinNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PinNoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PinNoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PinNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PinNoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UnpinNoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UnpinNoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UnpinNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UnpinNoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
noteId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UnpinNoteRequest}
 */
proto.claims_messages.UnpinNoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UnpinNoteRequest;
  return proto.claims_messages.UnpinNoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UnpinNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UnpinNoteRequest}
 */
proto.claims_messages.UnpinNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNoteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UnpinNoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UnpinNoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UnpinNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UnpinNoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoteId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 note_id = 1;
 * @return {number}
 */
proto.claims_messages.UnpinNoteRequest.prototype.getNoteId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.UnpinNoteRequest} returns this
 */
proto.claims_messages.UnpinNoteRequest.prototype.setNoteId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UnpinNoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UnpinNoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UnpinNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UnpinNoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UnpinNoteResponse}
 */
proto.claims_messages.UnpinNoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UnpinNoteResponse;
  return proto.claims_messages.UnpinNoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UnpinNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UnpinNoteResponse}
 */
proto.claims_messages.UnpinNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UnpinNoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UnpinNoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UnpinNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UnpinNoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.Activity.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.Activity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.Activity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Activity.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
userId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
userName: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
userRole: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
activityType: (f = msg.getActivityType()) && proto.claims_messages.ActivityType.toObject(includeInstance, f),
activityMessage: jspb.Message.getFieldWithDefault(msg, 7, ""),
activityLog: jspb.Message.getFieldWithDefault(msg, 8, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.Activity}
 */
proto.claims_messages.Activity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.Activity;
  return proto.claims_messages.Activity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.Activity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.Activity}
 */
proto.claims_messages.Activity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserRole(value);
      break;
    case 6:
      var value = new proto.claims_messages.ActivityType;
      reader.readMessage(value,proto.claims_messages.ActivityType.deserializeBinaryFromReader);
      msg.setActivityType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityMessage(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityLog(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.Activity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.Activity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.Activity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Activity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getActivityType();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.claims_messages.ActivityType.serializeBinaryToWriter
    );
  }
  f = message.getActivityMessage();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getActivityLog();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.Activity.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Activity.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.Activity.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.claims_messages.Activity.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setUserId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.clearUserId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Activity.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string user_name = 4;
 * @return {string}
 */
proto.claims_messages.Activity.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setUserName = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.clearUserName = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Activity.prototype.hasUserName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string user_role = 5;
 * @return {string}
 */
proto.claims_messages.Activity.prototype.getUserRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setUserRole = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.clearUserRole = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Activity.prototype.hasUserRole = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ActivityType activity_type = 6;
 * @return {?proto.claims_messages.ActivityType}
 */
proto.claims_messages.Activity.prototype.getActivityType = function() {
  return /** @type{?proto.claims_messages.ActivityType} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ActivityType, 6));
};


/**
 * @param {?proto.claims_messages.ActivityType|undefined} value
 * @return {!proto.claims_messages.Activity} returns this
*/
proto.claims_messages.Activity.prototype.setActivityType = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.clearActivityType = function() {
  return this.setActivityType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.Activity.prototype.hasActivityType = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string activity_message = 7;
 * @return {string}
 */
proto.claims_messages.Activity.prototype.getActivityMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setActivityMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string activity_log = 8;
 * @return {string}
 */
proto.claims_messages.Activity.prototype.getActivityLog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setActivityLog = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.claims_messages.Activity.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Activity} returns this
 */
proto.claims_messages.Activity.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateActivity.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateActivity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivity.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
userName: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
userRole: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
activityType: jspb.Message.getFieldWithDefault(msg, 5, 0),
activityMessage: jspb.Message.getFieldWithDefault(msg, 6, ""),
activityLog: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateActivity}
 */
proto.claims_messages.CreateActivity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateActivity;
  return proto.claims_messages.CreateActivity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateActivity}
 */
proto.claims_messages.CreateActivity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserRole(value);
      break;
    case 5:
      var value = /** @type {!proto.claims_messages.ActivityTypeName} */ (reader.readEnum());
      msg.setActivityType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityMessage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityLog(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateActivity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateActivity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActivityType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getActivityMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActivityLog();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.CreateActivity.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.claims_messages.CreateActivity.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setUserId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.clearUserId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivity.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.claims_messages.CreateActivity.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setUserName = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.clearUserName = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivity.prototype.hasUserName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string user_role = 4;
 * @return {string}
 */
proto.claims_messages.CreateActivity.prototype.getUserRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setUserRole = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.clearUserRole = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivity.prototype.hasUserRole = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ActivityTypeName activity_type = 5;
 * @return {!proto.claims_messages.ActivityTypeName}
 */
proto.claims_messages.CreateActivity.prototype.getActivityType = function() {
  return /** @type {!proto.claims_messages.ActivityTypeName} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.claims_messages.ActivityTypeName} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setActivityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string activity_message = 6;
 * @return {string}
 */
proto.claims_messages.CreateActivity.prototype.getActivityMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setActivityMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string activity_log = 7;
 * @return {string}
 */
proto.claims_messages.CreateActivity.prototype.getActivityLog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setActivityLog = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.claims_messages.CreateActivity.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivity} returns this
 */
proto.claims_messages.CreateActivity.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivity.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ActivityType.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ActivityType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ActivityType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ActivityType.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ActivityType}
 */
proto.claims_messages.ActivityType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ActivityType;
  return proto.claims_messages.ActivityType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ActivityType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ActivityType}
 */
proto.claims_messages.ActivityType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ActivityType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ActivityType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ActivityType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ActivityType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.claims_messages.ActivityType.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ActivityType} returns this
 */
proto.claims_messages.ActivityType.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.claims_messages.ActivityType.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ActivityType} returns this
 */
proto.claims_messages.ActivityType.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.claims_messages.ActivityType.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ActivityType} returns this
 */
proto.claims_messages.ActivityType.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateActivityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateActivityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateActivityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
userName: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
userRole: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
activityType: jspb.Message.getFieldWithDefault(msg, 5, 0),
activityMessage: jspb.Message.getFieldWithDefault(msg, 6, ""),
activityLog: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateActivityRequest}
 */
proto.claims_messages.CreateActivityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateActivityRequest;
  return proto.claims_messages.CreateActivityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateActivityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateActivityRequest}
 */
proto.claims_messages.CreateActivityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserRole(value);
      break;
    case 5:
      var value = /** @type {!proto.claims_messages.ActivityTypeName} */ (reader.readEnum());
      msg.setActivityType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityMessage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityLog(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateActivityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateActivityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateActivityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActivityType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getActivityMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActivityLog();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.CreateActivityRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.claims_messages.CreateActivityRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setUserId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.clearUserId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivityRequest.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.claims_messages.CreateActivityRequest.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setUserName = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.clearUserName = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivityRequest.prototype.hasUserName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string user_role = 4;
 * @return {string}
 */
proto.claims_messages.CreateActivityRequest.prototype.getUserRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setUserRole = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.clearUserRole = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivityRequest.prototype.hasUserRole = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ActivityTypeName activity_type = 5;
 * @return {!proto.claims_messages.ActivityTypeName}
 */
proto.claims_messages.CreateActivityRequest.prototype.getActivityType = function() {
  return /** @type {!proto.claims_messages.ActivityTypeName} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.claims_messages.ActivityTypeName} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setActivityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string activity_message = 6;
 * @return {string}
 */
proto.claims_messages.CreateActivityRequest.prototype.getActivityMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setActivityMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string activity_log = 7;
 * @return {string}
 */
proto.claims_messages.CreateActivityRequest.prototype.getActivityLog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setActivityLog = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.claims_messages.CreateActivityRequest.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateActivityRequest} returns this
 */
proto.claims_messages.CreateActivityRequest.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateActivityRequest.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateActivityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateActivityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateActivityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateActivityResponse}
 */
proto.claims_messages.CreateActivityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateActivityResponse;
  return proto.claims_messages.CreateActivityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateActivityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateActivityResponse}
 */
proto.claims_messages.CreateActivityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateActivityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateActivityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateActivityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.CreateActivitiesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateActivitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateActivitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateActivitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.claims_messages.CreateActivity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateActivitiesRequest}
 */
proto.claims_messages.CreateActivitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateActivitiesRequest;
  return proto.claims_messages.CreateActivitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateActivitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateActivitiesRequest}
 */
proto.claims_messages.CreateActivitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.CreateActivity;
      reader.readMessage(value,proto.claims_messages.CreateActivity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateActivitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateActivitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateActivitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.CreateActivity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CreateActivity activities = 1;
 * @return {!Array<!proto.claims_messages.CreateActivity>}
 */
proto.claims_messages.CreateActivitiesRequest.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.claims_messages.CreateActivity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.CreateActivity, 1));
};


/**
 * @param {!Array<!proto.claims_messages.CreateActivity>} value
 * @return {!proto.claims_messages.CreateActivitiesRequest} returns this
*/
proto.claims_messages.CreateActivitiesRequest.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.CreateActivity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.CreateActivity}
 */
proto.claims_messages.CreateActivitiesRequest.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.CreateActivity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.CreateActivitiesRequest} returns this
 */
proto.claims_messages.CreateActivitiesRequest.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateActivitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateActivitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateActivitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateActivitiesResponse}
 */
proto.claims_messages.CreateActivitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateActivitiesResponse;
  return proto.claims_messages.CreateActivitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateActivitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateActivitiesResponse}
 */
proto.claims_messages.CreateActivitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateActivitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateActivitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateActivitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateActivitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetActivityTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetActivityTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetActivityTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivityTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetActivityTypesRequest}
 */
proto.claims_messages.GetActivityTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetActivityTypesRequest;
  return proto.claims_messages.GetActivityTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetActivityTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetActivityTypesRequest}
 */
proto.claims_messages.GetActivityTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetActivityTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetActivityTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetActivityTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivityTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetActivityTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetActivityTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetActivityTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetActivityTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivityTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
activityTypesList: jspb.Message.toObjectList(msg.getActivityTypesList(),
    proto.claims_messages.ActivityType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetActivityTypesResponse}
 */
proto.claims_messages.GetActivityTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetActivityTypesResponse;
  return proto.claims_messages.GetActivityTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetActivityTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetActivityTypesResponse}
 */
proto.claims_messages.GetActivityTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ActivityType;
      reader.readMessage(value,proto.claims_messages.ActivityType.deserializeBinaryFromReader);
      msg.addActivityTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetActivityTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetActivityTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetActivityTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivityTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ActivityType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivityType activity_types = 1;
 * @return {!Array<!proto.claims_messages.ActivityType>}
 */
proto.claims_messages.GetActivityTypesResponse.prototype.getActivityTypesList = function() {
  return /** @type{!Array<!proto.claims_messages.ActivityType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ActivityType, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ActivityType>} value
 * @return {!proto.claims_messages.GetActivityTypesResponse} returns this
*/
proto.claims_messages.GetActivityTypesResponse.prototype.setActivityTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ActivityType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ActivityType}
 */
proto.claims_messages.GetActivityTypesResponse.prototype.addActivityTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ActivityType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetActivityTypesResponse} returns this
 */
proto.claims_messages.GetActivityTypesResponse.prototype.clearActivityTypesList = function() {
  return this.setActivityTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetActivitiesByClaimIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetActivitiesByClaimIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
filterRole: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
filterActivityType: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetActivitiesByClaimIdRequest;
  return proto.claims_messages.GetActivitiesByClaimIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetActivitiesByClaimIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterRole(value);
      break;
    case 5:
      var value = /** @type {!proto.claims_messages.ActivityTypeName} */ (reader.readEnum());
      msg.setFilterActivityType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetActivitiesByClaimIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetActivitiesByClaimIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!proto.claims_messages.ActivityTypeName} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string filter_role = 4;
 * @return {string}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.getFilterRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.setFilterRole = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.clearFilterRole = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.hasFilterRole = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ActivityTypeName filter_activity_type = 5;
 * @return {!proto.claims_messages.ActivityTypeName}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.getFilterActivityType = function() {
  return /** @type {!proto.claims_messages.ActivityTypeName} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.claims_messages.ActivityTypeName} value
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.setFilterActivityType = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdRequest} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.clearFilterActivityType = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetActivitiesByClaimIdRequest.prototype.hasFilterActivityType = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetActivitiesByClaimIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetActivitiesByClaimIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.claims_messages.Activity.toObject, includeInstance),
paginationResponse: (f = msg.getPaginationResponse()) && messages_core_message_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdResponse}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetActivitiesByClaimIdResponse;
  return proto.claims_messages.GetActivitiesByClaimIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetActivitiesByClaimIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdResponse}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Activity;
      reader.readMessage(value,proto.claims_messages.Activity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    case 2:
      var value = new messages_core_message_pb.PaginationResponse;
      reader.readMessage(value,messages_core_message_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetActivitiesByClaimIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetActivitiesByClaimIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Activity.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Activity activities = 1;
 * @return {!Array<!proto.claims_messages.Activity>}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.claims_messages.Activity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Activity, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Activity>} value
 * @return {!proto.claims_messages.GetActivitiesByClaimIdResponse} returns this
*/
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Activity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Activity}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Activity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdResponse} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * optional core_messages.PaginationResponse pagination_response = 2;
 * @return {?proto.core_messages.PaginationResponse}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.core_messages.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.core_messages.PaginationResponse|undefined} value
 * @return {!proto.claims_messages.GetActivitiesByClaimIdResponse} returns this
*/
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.GetActivitiesByClaimIdResponse} returns this
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetActivitiesByClaimIdResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetOldestClaimForAnalystRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetOldestClaimForAnalystRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetOldestClaimForAnalystRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetOldestClaimForAnalystRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetOldestClaimForAnalystRequest}
 */
proto.claims_messages.GetOldestClaimForAnalystRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetOldestClaimForAnalystRequest;
  return proto.claims_messages.GetOldestClaimForAnalystRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetOldestClaimForAnalystRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetOldestClaimForAnalystRequest}
 */
proto.claims_messages.GetOldestClaimForAnalystRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetOldestClaimForAnalystRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetOldestClaimForAnalystRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetOldestClaimForAnalystRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetOldestClaimForAnalystRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetOldestClaimForAnalystResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetOldestClaimForAnalystResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claim: (f = msg.getClaim()) && proto.claims_messages.Claim.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetOldestClaimForAnalystResponse}
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetOldestClaimForAnalystResponse;
  return proto.claims_messages.GetOldestClaimForAnalystResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetOldestClaimForAnalystResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetOldestClaimForAnalystResponse}
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Claim;
      reader.readMessage(value,proto.claims_messages.Claim.deserializeBinaryFromReader);
      msg.setClaim(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetOldestClaimForAnalystResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetOldestClaimForAnalystResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaim();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.Claim.serializeBinaryToWriter
    );
  }
};


/**
 * optional Claim claim = 1;
 * @return {?proto.claims_messages.Claim}
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.prototype.getClaim = function() {
  return /** @type{?proto.claims_messages.Claim} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.Claim, 1));
};


/**
 * @param {?proto.claims_messages.Claim|undefined} value
 * @return {!proto.claims_messages.GetOldestClaimForAnalystResponse} returns this
*/
proto.claims_messages.GetOldestClaimForAnalystResponse.prototype.setClaim = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.GetOldestClaimForAnalystResponse} returns this
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.prototype.clearClaim = function() {
  return this.setClaim(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetOldestClaimForAnalystResponse.prototype.hasClaim = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsSubmitRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsSubmitRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsSubmitRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSubmitRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
receivedOn: (f = msg.getReceivedOn()) && messages_core_message_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsSubmitRequest}
 */
proto.claims_messages.ClaimsSubmitRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsSubmitRequest;
  return proto.claims_messages.ClaimsSubmitRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsSubmitRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsSubmitRequest}
 */
proto.claims_messages.ClaimsSubmitRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = new messages_core_message_pb.Date;
      reader.readMessage(value,messages_core_message_pb.Date.deserializeBinaryFromReader);
      msg.setReceivedOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsSubmitRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsSubmitRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsSubmitRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSubmitRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getReceivedOn();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsSubmitRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsSubmitRequest} returns this
 */
proto.claims_messages.ClaimsSubmitRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional core_messages.Date received_on = 2;
 * @return {?proto.core_messages.Date}
 */
proto.claims_messages.ClaimsSubmitRequest.prototype.getReceivedOn = function() {
  return /** @type{?proto.core_messages.Date} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Date, 2));
};


/**
 * @param {?proto.core_messages.Date|undefined} value
 * @return {!proto.claims_messages.ClaimsSubmitRequest} returns this
*/
proto.claims_messages.ClaimsSubmitRequest.prototype.setReceivedOn = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsSubmitRequest} returns this
 */
proto.claims_messages.ClaimsSubmitRequest.prototype.clearReceivedOn = function() {
  return this.setReceivedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsSubmitRequest.prototype.hasReceivedOn = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsSubmitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsSubmitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsSubmitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSubmitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsSubmitResponse}
 */
proto.claims_messages.ClaimsSubmitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsSubmitResponse;
  return proto.claims_messages.ClaimsSubmitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsSubmitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsSubmitResponse}
 */
proto.claims_messages.ClaimsSubmitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsSubmitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsSubmitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsSubmitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsSubmitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssignAnalystRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssignAnalystRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssignAnalystRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssignAnalystRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
assignedAnalystId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssignAnalystRequest}
 */
proto.claims_messages.ClaimsAssignAnalystRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssignAnalystRequest;
  return proto.claims_messages.ClaimsAssignAnalystRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssignAnalystRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssignAnalystRequest}
 */
proto.claims_messages.ClaimsAssignAnalystRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedAnalystId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssignAnalystRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssignAnalystRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssignAnalystRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssignAnalystRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAssignedAnalystId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsAssignAnalystRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssignAnalystRequest} returns this
 */
proto.claims_messages.ClaimsAssignAnalystRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 assigned_analyst_id = 2;
 * @return {number}
 */
proto.claims_messages.ClaimsAssignAnalystRequest.prototype.getAssignedAnalystId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssignAnalystRequest} returns this
 */
proto.claims_messages.ClaimsAssignAnalystRequest.prototype.setAssignedAnalystId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssignAnalystResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssignAnalystResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssignAnalystResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssignAnalystResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
assignedAnalyst: (f = msg.getAssignedAnalyst()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssignAnalystResponse}
 */
proto.claims_messages.ClaimsAssignAnalystResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssignAnalystResponse;
  return proto.claims_messages.ClaimsAssignAnalystResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssignAnalystResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssignAnalystResponse}
 */
proto.claims_messages.ClaimsAssignAnalystResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setAssignedAnalyst(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssignAnalystResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssignAnalystResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssignAnalystResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssignAnalystResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssignedAnalyst();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimPerson assigned_analyst = 1;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.ClaimsAssignAnalystResponse.prototype.getAssignedAnalyst = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 1));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.ClaimsAssignAnalystResponse} returns this
*/
proto.claims_messages.ClaimsAssignAnalystResponse.prototype.setAssignedAnalyst = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssignAnalystResponse} returns this
 */
proto.claims_messages.ClaimsAssignAnalystResponse.prototype.clearAssignedAnalyst = function() {
  return this.setAssignedAnalyst(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssignAnalystResponse.prototype.hasAssignedAnalyst = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetAnalystsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetAnalystsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetAnalystsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetAnalystsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
filterRole: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetAnalystsRequest}
 */
proto.claims_messages.GetAnalystsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetAnalystsRequest;
  return proto.claims_messages.GetAnalystsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetAnalystsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetAnalystsRequest}
 */
proto.claims_messages.GetAnalystsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetAnalystsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetAnalystsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetAnalystsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetAnalystsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string filter_role = 1;
 * @return {string}
 */
proto.claims_messages.GetAnalystsRequest.prototype.getFilterRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.GetAnalystsRequest} returns this
 */
proto.claims_messages.GetAnalystsRequest.prototype.setFilterRole = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.GetAnalystsRequest} returns this
 */
proto.claims_messages.GetAnalystsRequest.prototype.clearFilterRole = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetAnalystsRequest.prototype.hasFilterRole = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetAnalystsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetAnalystsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetAnalystsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetAnalystsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetAnalystsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
analystsList: jspb.Message.toObjectList(msg.getAnalystsList(),
    proto.claims_messages.ClaimPerson.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetAnalystsResponse}
 */
proto.claims_messages.GetAnalystsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetAnalystsResponse;
  return proto.claims_messages.GetAnalystsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetAnalystsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetAnalystsResponse}
 */
proto.claims_messages.GetAnalystsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.addAnalysts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetAnalystsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetAnalystsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetAnalystsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetAnalystsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnalystsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimPerson analysts = 1;
 * @return {!Array<!proto.claims_messages.ClaimPerson>}
 */
proto.claims_messages.GetAnalystsResponse.prototype.getAnalystsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimPerson>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimPerson, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimPerson>} value
 * @return {!proto.claims_messages.GetAnalystsResponse} returns this
*/
proto.claims_messages.GetAnalystsResponse.prototype.setAnalystsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimPerson=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.GetAnalystsResponse.prototype.addAnalysts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimPerson, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetAnalystsResponse} returns this
 */
proto.claims_messages.GetAnalystsResponse.prototype.clearAnalystsList = function() {
  return this.setAnalystsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ExportPaymentsToCsvRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ExportPaymentsToCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ExportPaymentsToCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ExportPaymentsToCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsToCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ExportPaymentsToCsvRequest}
 */
proto.claims_messages.ExportPaymentsToCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ExportPaymentsToCsvRequest;
  return proto.claims_messages.ExportPaymentsToCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ExportPaymentsToCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ExportPaymentsToCsvRequest}
 */
proto.claims_messages.ExportPaymentsToCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addClaimIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportPaymentsToCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ExportPaymentsToCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ExportPaymentsToCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsToCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 claim_ids = 1;
 * @return {!Array<number>}
 */
proto.claims_messages.ExportPaymentsToCsvRequest.prototype.getClaimIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.claims_messages.ExportPaymentsToCsvRequest} returns this
 */
proto.claims_messages.ExportPaymentsToCsvRequest.prototype.setClaimIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ExportPaymentsToCsvRequest} returns this
 */
proto.claims_messages.ExportPaymentsToCsvRequest.prototype.addClaimIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ExportPaymentsToCsvRequest} returns this
 */
proto.claims_messages.ExportPaymentsToCsvRequest.prototype.clearClaimIdsList = function() {
  return this.setClaimIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ExportPaymentsToCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ExportPaymentsToCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ExportPaymentsToCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsToCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ExportPaymentsToCsvResponse}
 */
proto.claims_messages.ExportPaymentsToCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ExportPaymentsToCsvResponse;
  return proto.claims_messages.ExportPaymentsToCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ExportPaymentsToCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ExportPaymentsToCsvResponse}
 */
proto.claims_messages.ExportPaymentsToCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportPaymentsToCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ExportPaymentsToCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ExportPaymentsToCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsToCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ExportPaymentsCsvStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ExportPaymentsCsvStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ExportPaymentsCsvStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsCsvStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ExportPaymentsCsvStatusRequest}
 */
proto.claims_messages.ExportPaymentsCsvStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ExportPaymentsCsvStatusRequest;
  return proto.claims_messages.ExportPaymentsCsvStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ExportPaymentsCsvStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ExportPaymentsCsvStatusRequest}
 */
proto.claims_messages.ExportPaymentsCsvStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportPaymentsCsvStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ExportPaymentsCsvStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ExportPaymentsCsvStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsCsvStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ExportPaymentsCsvStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ExportPaymentsCsvStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
inProgress: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ExportPaymentsCsvStatusResponse}
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ExportPaymentsCsvStatusResponse;
  return proto.claims_messages.ExportPaymentsCsvStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ExportPaymentsCsvStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ExportPaymentsCsvStatusResponse}
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ExportPaymentsCsvStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ExportPaymentsCsvStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInProgress();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool in_progress = 1;
 * @return {boolean}
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.prototype.getInProgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ExportPaymentsCsvStatusResponse} returns this
 */
proto.claims_messages.ExportPaymentsCsvStatusResponse.prototype.setInProgress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ExportClaimsToCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ExportClaimsToCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportClaimsToCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
assignedAnalystId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
attyId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
searchField: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
searchString: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
sortField: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
sortDir: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest}
 */
proto.claims_messages.ExportClaimsToCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ExportClaimsToCsvRequest;
  return proto.claims_messages.ExportClaimsToCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ExportClaimsToCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest}
 */
proto.claims_messages.ExportClaimsToCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssignedAnalystId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchField(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchString(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDir(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ExportClaimsToCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ExportClaimsToCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportClaimsToCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 assigned_analyst_id = 1;
 * @return {number}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.getAssignedAnalystId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.setAssignedAnalystId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.clearAssignedAnalystId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.hasAssignedAnalystId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 atty_id = 2;
 * @return {number}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.clearAttyId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.hasAttyId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string search_field = 3;
 * @return {string}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.getSearchField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.setSearchField = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.clearSearchField = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.hasSearchField = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string search_string = 4;
 * @return {string}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.getSearchString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.setSearchString = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.clearSearchString = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.hasSearchString = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string sort_field = 5;
 * @return {string}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.setSortField = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.clearSortField = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.hasSortField = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string sort_dir = 6;
 * @return {string}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.getSortDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.setSortDir = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ExportClaimsToCsvRequest} returns this
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.clearSortDir = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ExportClaimsToCsvRequest.prototype.hasSortDir = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ExportClaimsToCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ExportClaimsToCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportClaimsToCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
csvData: msg.getCsvData_asB64(),
fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalClaims: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ExportClaimsToCsvResponse}
 */
proto.claims_messages.ExportClaimsToCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ExportClaimsToCsvResponse;
  return proto.claims_messages.ExportClaimsToCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ExportClaimsToCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ExportClaimsToCsvResponse}
 */
proto.claims_messages.ExportClaimsToCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCsvData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalClaims(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ExportClaimsToCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ExportClaimsToCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportClaimsToCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsvData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalClaims();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional bytes csv_data = 1;
 * @return {string}
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.getCsvData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes csv_data = 1;
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {string}
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.getCsvData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCsvData()));
};


/**
 * optional bytes csv_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.getCsvData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCsvData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.claims_messages.ExportClaimsToCsvResponse} returns this
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.setCsvData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ExportClaimsToCsvResponse} returns this
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_claims = 3;
 * @return {number}
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.getTotalClaims = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ExportClaimsToCsvResponse} returns this
 */
proto.claims_messages.ExportClaimsToCsvResponse.prototype.setTotalClaims = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ExportFilterPair.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ExportFilterPair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ExportFilterPair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportFilterPair.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ExportFilterPair}
 */
proto.claims_messages.ExportFilterPair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ExportFilterPair;
  return proto.claims_messages.ExportFilterPair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ExportFilterPair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ExportFilterPair}
 */
proto.claims_messages.ExportFilterPair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ExportFilterPair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ExportFilterPair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ExportFilterPair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ExportFilterPair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.claims_messages.ExportFilterPair.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ExportFilterPair} returns this
 */
proto.claims_messages.ExportFilterPair.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.claims_messages.ExportFilterPair.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ExportFilterPair} returns this
 */
proto.claims_messages.ExportFilterPair.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.DynamicExportToCsvRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DynamicExportToCsvRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DynamicExportToCsvRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DynamicExportToCsvRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
entityType: jspb.Message.getFieldWithDefault(msg, 1, 0),
columnsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
filtersList: jspb.Message.toObjectList(msg.getFiltersList(),
    proto.claims_messages.ExportFilterPair.toObject, includeInstance),
sortField: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
sortDir: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
limit: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DynamicExportToCsvRequest}
 */
proto.claims_messages.DynamicExportToCsvRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DynamicExportToCsvRequest;
  return proto.claims_messages.DynamicExportToCsvRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DynamicExportToCsvRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DynamicExportToCsvRequest}
 */
proto.claims_messages.DynamicExportToCsvRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.claims_messages.ExportEntityType} */ (reader.readEnum());
      msg.setEntityType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumns(value);
      break;
    case 3:
      var value = new proto.claims_messages.ExportFilterPair;
      reader.readMessage(value,proto.claims_messages.ExportFilterPair.deserializeBinaryFromReader);
      msg.addFilters(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDir(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DynamicExportToCsvRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DynamicExportToCsvRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DynamicExportToCsvRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getColumnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.claims_messages.ExportFilterPair.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional ExportEntityType entity_type = 1;
 * @return {!proto.claims_messages.ExportEntityType}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.getEntityType = function() {
  return /** @type {!proto.claims_messages.ExportEntityType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.claims_messages.ExportEntityType} value
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.setEntityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string columns = 2;
 * @return {!Array<string>}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.getColumnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.setColumnsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.addColumns = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.clearColumnsList = function() {
  return this.setColumnsList([]);
};


/**
 * repeated ExportFilterPair filters = 3;
 * @return {!Array<!proto.claims_messages.ExportFilterPair>}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.getFiltersList = function() {
  return /** @type{!Array<!proto.claims_messages.ExportFilterPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ExportFilterPair, 3));
};


/**
 * @param {!Array<!proto.claims_messages.ExportFilterPair>} value
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
*/
proto.claims_messages.DynamicExportToCsvRequest.prototype.setFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.claims_messages.ExportFilterPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ExportFilterPair}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.addFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.claims_messages.ExportFilterPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.clearFiltersList = function() {
  return this.setFiltersList([]);
};


/**
 * optional string sort_field = 4;
 * @return {string}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.setSortField = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.clearSortField = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.hasSortField = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string sort_dir = 5;
 * @return {string}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.getSortDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.setSortDir = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.clearSortDir = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.hasSortDir = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 limit = 6;
 * @return {number}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.setLimit = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.DynamicExportToCsvRequest} returns this
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.clearLimit = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.DynamicExportToCsvRequest.prototype.hasLimit = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.DynamicExportToCsvResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.DynamicExportToCsvResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DynamicExportToCsvResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
csvData: msg.getCsvData_asB64(),
fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalRecords: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.DynamicExportToCsvResponse}
 */
proto.claims_messages.DynamicExportToCsvResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.DynamicExportToCsvResponse;
  return proto.claims_messages.DynamicExportToCsvResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.DynamicExportToCsvResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.DynamicExportToCsvResponse}
 */
proto.claims_messages.DynamicExportToCsvResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCsvData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRecords(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.DynamicExportToCsvResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.DynamicExportToCsvResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.DynamicExportToCsvResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCsvData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalRecords();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional bytes csv_data = 1;
 * @return {string}
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.getCsvData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes csv_data = 1;
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {string}
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.getCsvData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCsvData()));
};


/**
 * optional bytes csv_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCsvData()`
 * @return {!Uint8Array}
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.getCsvData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCsvData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.claims_messages.DynamicExportToCsvResponse} returns this
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.setCsvData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.DynamicExportToCsvResponse} returns this
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_records = 3;
 * @return {number}
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.getTotalRecords = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.DynamicExportToCsvResponse} returns this
 */
proto.claims_messages.DynamicExportToCsvResponse.prototype.setTotalRecords = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreatePaymentExportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreatePaymentExportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreatePaymentExportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreatePaymentExportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreatePaymentExportRequest}
 */
proto.claims_messages.CreatePaymentExportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreatePaymentExportRequest;
  return proto.claims_messages.CreatePaymentExportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreatePaymentExportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreatePaymentExportRequest}
 */
proto.claims_messages.CreatePaymentExportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreatePaymentExportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreatePaymentExportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreatePaymentExportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreatePaymentExportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.claims_messages.CreatePaymentExportRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreatePaymentExportRequest} returns this
 */
proto.claims_messages.CreatePaymentExportRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.CreatePaymentExportRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreatePaymentExportRequest} returns this
 */
proto.claims_messages.CreatePaymentExportRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreatePaymentExportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreatePaymentExportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreatePaymentExportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreatePaymentExportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreatePaymentExportResponse}
 */
proto.claims_messages.CreatePaymentExportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreatePaymentExportResponse;
  return proto.claims_messages.CreatePaymentExportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreatePaymentExportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreatePaymentExportResponse}
 */
proto.claims_messages.CreatePaymentExportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreatePaymentExportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreatePaymentExportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreatePaymentExportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreatePaymentExportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PaymentExport.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PaymentExport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PaymentExport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PaymentExport.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
createdByUserId: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdByUserName: jspb.Message.getFieldWithDefault(msg, 4, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PaymentExport}
 */
proto.claims_messages.PaymentExport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PaymentExport;
  return proto.claims_messages.PaymentExport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PaymentExport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PaymentExport}
 */
proto.claims_messages.PaymentExport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedByUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PaymentExport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PaymentExport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PaymentExport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PaymentExport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedByUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCreatedByUserName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.claims_messages.PaymentExport.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PaymentExport} returns this
 */
proto.claims_messages.PaymentExport.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.claims_messages.PaymentExport.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PaymentExport} returns this
 */
proto.claims_messages.PaymentExport.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 created_by_user_id = 3;
 * @return {number}
 */
proto.claims_messages.PaymentExport.prototype.getCreatedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.PaymentExport} returns this
 */
proto.claims_messages.PaymentExport.prototype.setCreatedByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string created_by_user_name = 4;
 * @return {string}
 */
proto.claims_messages.PaymentExport.prototype.getCreatedByUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PaymentExport} returns this
 */
proto.claims_messages.PaymentExport.prototype.setCreatedByUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 created_at = 5;
 * @return {number}
 */
proto.claims_messages.PaymentExport.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.PaymentExport} returns this
 */
proto.claims_messages.PaymentExport.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PaymentExportListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PaymentExportListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PaymentExportListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PaymentExportListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
sortField: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
sortDir: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
searchField: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
searchString: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PaymentExportListRequest}
 */
proto.claims_messages.PaymentExportListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PaymentExportListRequest;
  return proto.claims_messages.PaymentExportListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PaymentExportListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PaymentExportListRequest}
 */
proto.claims_messages.PaymentExportListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDir(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchField(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchString(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PaymentExportListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PaymentExportListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PaymentExportListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PaymentExportListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.claims_messages.PaymentExportListRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.claims_messages.PaymentExportListRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sort_field = 3;
 * @return {string}
 */
proto.claims_messages.PaymentExportListRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.setSortField = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.clearSortField = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.PaymentExportListRequest.prototype.hasSortField = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string sort_dir = 4;
 * @return {string}
 */
proto.claims_messages.PaymentExportListRequest.prototype.getSortDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.setSortDir = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.clearSortDir = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.PaymentExportListRequest.prototype.hasSortDir = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string search_field = 5;
 * @return {string}
 */
proto.claims_messages.PaymentExportListRequest.prototype.getSearchField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.setSearchField = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.clearSearchField = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.PaymentExportListRequest.prototype.hasSearchField = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string search_string = 6;
 * @return {string}
 */
proto.claims_messages.PaymentExportListRequest.prototype.getSearchString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.setSearchString = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.PaymentExportListRequest} returns this
 */
proto.claims_messages.PaymentExportListRequest.prototype.clearSearchString = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.PaymentExportListRequest.prototype.hasSearchString = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.PaymentExportListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PaymentExportListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PaymentExportListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PaymentExportListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PaymentExportListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentExportsList: jspb.Message.toObjectList(msg.getPaymentExportsList(),
    proto.claims_messages.PaymentExport.toObject, includeInstance),
paginationResponse: (f = msg.getPaginationResponse()) && messages_core_message_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PaymentExportListResponse}
 */
proto.claims_messages.PaymentExportListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PaymentExportListResponse;
  return proto.claims_messages.PaymentExportListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PaymentExportListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PaymentExportListResponse}
 */
proto.claims_messages.PaymentExportListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.PaymentExport;
      reader.readMessage(value,proto.claims_messages.PaymentExport.deserializeBinaryFromReader);
      msg.addPaymentExports(value);
      break;
    case 2:
      var value = new messages_core_message_pb.PaginationResponse;
      reader.readMessage(value,messages_core_message_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PaymentExportListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PaymentExportListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PaymentExportListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PaymentExportListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentExportsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.PaymentExport.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PaymentExport payment_exports = 1;
 * @return {!Array<!proto.claims_messages.PaymentExport>}
 */
proto.claims_messages.PaymentExportListResponse.prototype.getPaymentExportsList = function() {
  return /** @type{!Array<!proto.claims_messages.PaymentExport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.PaymentExport, 1));
};


/**
 * @param {!Array<!proto.claims_messages.PaymentExport>} value
 * @return {!proto.claims_messages.PaymentExportListResponse} returns this
*/
proto.claims_messages.PaymentExportListResponse.prototype.setPaymentExportsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.PaymentExport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.PaymentExport}
 */
proto.claims_messages.PaymentExportListResponse.prototype.addPaymentExports = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.PaymentExport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.PaymentExportListResponse} returns this
 */
proto.claims_messages.PaymentExportListResponse.prototype.clearPaymentExportsList = function() {
  return this.setPaymentExportsList([]);
};


/**
 * optional core_messages.PaginationResponse pagination_response = 2;
 * @return {?proto.core_messages.PaginationResponse}
 */
proto.claims_messages.PaymentExportListResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.core_messages.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.core_messages.PaginationResponse|undefined} value
 * @return {!proto.claims_messages.PaymentExportListResponse} returns this
*/
proto.claims_messages.PaymentExportListResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.PaymentExportListResponse} returns this
 */
proto.claims_messages.PaymentExportListResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.PaymentExportListResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetApprovedCountForAnalystRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetApprovedCountForAnalystRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetApprovedCountForAnalystRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetApprovedCountForAnalystRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetApprovedCountForAnalystRequest}
 */
proto.claims_messages.GetApprovedCountForAnalystRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetApprovedCountForAnalystRequest;
  return proto.claims_messages.GetApprovedCountForAnalystRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetApprovedCountForAnalystRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetApprovedCountForAnalystRequest}
 */
proto.claims_messages.GetApprovedCountForAnalystRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetApprovedCountForAnalystRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetApprovedCountForAnalystRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetApprovedCountForAnalystRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetApprovedCountForAnalystRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetApprovedCountForAnalystResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetApprovedCountForAnalystResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
count: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetApprovedCountForAnalystResponse}
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetApprovedCountForAnalystResponse;
  return proto.claims_messages.GetApprovedCountForAnalystResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetApprovedCountForAnalystResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetApprovedCountForAnalystResponse}
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetApprovedCountForAnalystResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetApprovedCountForAnalystResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 count = 1;
 * @return {number}
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetApprovedCountForAnalystResponse} returns this
 */
proto.claims_messages.GetApprovedCountForAnalystResponse.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.Checklist.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.Checklist.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.Checklist} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Checklist.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
label: jspb.Message.getFieldWithDefault(msg, 3, ""),
checklistType: jspb.Message.getFieldWithDefault(msg, 4, 0),
value: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.Checklist}
 */
proto.claims_messages.Checklist.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.Checklist;
  return proto.claims_messages.Checklist.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.Checklist} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.Checklist}
 */
proto.claims_messages.Checklist.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {!proto.claims_messages.ChecklistType} */ (reader.readEnum());
      msg.setChecklistType(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.Checklist.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.Checklist.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.Checklist} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.Checklist.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChecklistType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getValue();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.Checklist.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Checklist} returns this
 */
proto.claims_messages.Checklist.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.Checklist.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.Checklist} returns this
 */
proto.claims_messages.Checklist.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.claims_messages.Checklist.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.Checklist} returns this
 */
proto.claims_messages.Checklist.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ChecklistType checklist_type = 4;
 * @return {!proto.claims_messages.ChecklistType}
 */
proto.claims_messages.Checklist.prototype.getChecklistType = function() {
  return /** @type {!proto.claims_messages.ChecklistType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.claims_messages.ChecklistType} value
 * @return {!proto.claims_messages.Checklist} returns this
 */
proto.claims_messages.Checklist.prototype.setChecklistType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool value = 5;
 * @return {boolean}
 */
proto.claims_messages.Checklist.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.Checklist} returns this
 */
proto.claims_messages.Checklist.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertChecklistItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertChecklistItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertChecklistItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
claimId: jspb.Message.getFieldWithDefault(msg, 2, 0),
label: jspb.Message.getFieldWithDefault(msg, 3, ""),
checklistType: jspb.Message.getFieldWithDefault(msg, 4, 0),
value: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertChecklistItemRequest}
 */
proto.claims_messages.UpsertChecklistItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertChecklistItemRequest;
  return proto.claims_messages.UpsertChecklistItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertChecklistItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertChecklistItemRequest}
 */
proto.claims_messages.UpsertChecklistItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {!proto.claims_messages.ChecklistType} */ (reader.readEnum());
      msg.setChecklistType(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertChecklistItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertChecklistItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertChecklistItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChecklistType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getValue();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.UpsertChecklistItemRequest} returns this
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.UpsertChecklistItemRequest} returns this
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 claim_id = 2;
 * @return {number}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.UpsertChecklistItemRequest} returns this
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.UpsertChecklistItemRequest} returns this
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ChecklistType checklist_type = 4;
 * @return {!proto.claims_messages.ChecklistType}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.getChecklistType = function() {
  return /** @type {!proto.claims_messages.ChecklistType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.claims_messages.ChecklistType} value
 * @return {!proto.claims_messages.UpsertChecklistItemRequest} returns this
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.setChecklistType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool value = 5;
 * @return {boolean}
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.UpsertChecklistItemRequest} returns this
 */
proto.claims_messages.UpsertChecklistItemRequest.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertChecklistItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertChecklistItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertChecklistItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertChecklistItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertChecklistItemResponse}
 */
proto.claims_messages.UpsertChecklistItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertChecklistItemResponse;
  return proto.claims_messages.UpsertChecklistItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertChecklistItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertChecklistItemResponse}
 */
proto.claims_messages.UpsertChecklistItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertChecklistItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertChecklistItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertChecklistItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertChecklistItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.InitializeChecklistByClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.InitializeChecklistByClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.InitializeChecklistByClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.InitializeChecklistByClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.InitializeChecklistByClaimRequest}
 */
proto.claims_messages.InitializeChecklistByClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.InitializeChecklistByClaimRequest;
  return proto.claims_messages.InitializeChecklistByClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.InitializeChecklistByClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.InitializeChecklistByClaimRequest}
 */
proto.claims_messages.InitializeChecklistByClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.InitializeChecklistByClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.InitializeChecklistByClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.InitializeChecklistByClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.InitializeChecklistByClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.InitializeChecklistByClaimRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.InitializeChecklistByClaimRequest} returns this
 */
proto.claims_messages.InitializeChecklistByClaimRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.InitializeChecklistByClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.InitializeChecklistByClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.InitializeChecklistByClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.InitializeChecklistByClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.InitializeChecklistByClaimResponse}
 */
proto.claims_messages.InitializeChecklistByClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.InitializeChecklistByClaimResponse;
  return proto.claims_messages.InitializeChecklistByClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.InitializeChecklistByClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.InitializeChecklistByClaimResponse}
 */
proto.claims_messages.InitializeChecklistByClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.InitializeChecklistByClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.InitializeChecklistByClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.InitializeChecklistByClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.InitializeChecklistByClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CheckClaimHasChecklistItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CheckClaimHasChecklistItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CheckClaimHasChecklistItemsRequest}
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CheckClaimHasChecklistItemsRequest;
  return proto.claims_messages.CheckClaimHasChecklistItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CheckClaimHasChecklistItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CheckClaimHasChecklistItemsRequest}
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CheckClaimHasChecklistItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CheckClaimHasChecklistItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CheckClaimHasChecklistItemsRequest} returns this
 */
proto.claims_messages.CheckClaimHasChecklistItemsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CheckClaimHasChecklistItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CheckClaimHasChecklistItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hasChecklistItems: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CheckClaimHasChecklistItemsResponse}
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CheckClaimHasChecklistItemsResponse;
  return proto.claims_messages.CheckClaimHasChecklistItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CheckClaimHasChecklistItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CheckClaimHasChecklistItemsResponse}
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasChecklistItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CheckClaimHasChecklistItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CheckClaimHasChecklistItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasChecklistItems();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool has_checklist_items = 1;
 * @return {boolean}
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.prototype.getHasChecklistItems = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.CheckClaimHasChecklistItemsResponse} returns this
 */
proto.claims_messages.CheckClaimHasChecklistItemsResponse.prototype.setHasChecklistItems = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetChecklistItemsByClaimIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetChecklistItemsByClaimIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetChecklistItemsByClaimIdRequest}
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetChecklistItemsByClaimIdRequest;
  return proto.claims_messages.GetChecklistItemsByClaimIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetChecklistItemsByClaimIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetChecklistItemsByClaimIdRequest}
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetChecklistItemsByClaimIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetChecklistItemsByClaimIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetChecklistItemsByClaimIdRequest} returns this
 */
proto.claims_messages.GetChecklistItemsByClaimIdRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetChecklistItemsByClaimIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetChecklistItemsByClaimIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
checklistItemsList: jspb.Message.toObjectList(msg.getChecklistItemsList(),
    proto.claims_messages.Checklist.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetChecklistItemsByClaimIdResponse}
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetChecklistItemsByClaimIdResponse;
  return proto.claims_messages.GetChecklistItemsByClaimIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetChecklistItemsByClaimIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetChecklistItemsByClaimIdResponse}
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Checklist;
      reader.readMessage(value,proto.claims_messages.Checklist.deserializeBinaryFromReader);
      msg.addChecklistItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetChecklistItemsByClaimIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetChecklistItemsByClaimIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChecklistItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Checklist.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Checklist checklist_items = 1;
 * @return {!Array<!proto.claims_messages.Checklist>}
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.prototype.getChecklistItemsList = function() {
  return /** @type{!Array<!proto.claims_messages.Checklist>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Checklist, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Checklist>} value
 * @return {!proto.claims_messages.GetChecklistItemsByClaimIdResponse} returns this
*/
proto.claims_messages.GetChecklistItemsByClaimIdResponse.prototype.setChecklistItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Checklist=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Checklist}
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.prototype.addChecklistItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Checklist, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetChecklistItemsByClaimIdResponse} returns this
 */
proto.claims_messages.GetChecklistItemsByClaimIdResponse.prototype.clearChecklistItemsList = function() {
  return this.setChecklistItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetChecklistTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetChecklistTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetChecklistTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetChecklistTemplateRequest}
 */
proto.claims_messages.GetChecklistTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetChecklistTemplateRequest;
  return proto.claims_messages.GetChecklistTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetChecklistTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetChecklistTemplateRequest}
 */
proto.claims_messages.GetChecklistTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetChecklistTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetChecklistTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetChecklistTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetChecklistTemplateResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetChecklistTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetChecklistTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetChecklistTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
checklistItemsList: jspb.Message.toObjectList(msg.getChecklistItemsList(),
    proto.claims_messages.Checklist.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetChecklistTemplateResponse}
 */
proto.claims_messages.GetChecklistTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetChecklistTemplateResponse;
  return proto.claims_messages.GetChecklistTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetChecklistTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetChecklistTemplateResponse}
 */
proto.claims_messages.GetChecklistTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Checklist;
      reader.readMessage(value,proto.claims_messages.Checklist.deserializeBinaryFromReader);
      msg.addChecklistItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetChecklistTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetChecklistTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetChecklistTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetChecklistTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChecklistItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Checklist.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Checklist checklist_items = 1;
 * @return {!Array<!proto.claims_messages.Checklist>}
 */
proto.claims_messages.GetChecklistTemplateResponse.prototype.getChecklistItemsList = function() {
  return /** @type{!Array<!proto.claims_messages.Checklist>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Checklist, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Checklist>} value
 * @return {!proto.claims_messages.GetChecklistTemplateResponse} returns this
*/
proto.claims_messages.GetChecklistTemplateResponse.prototype.setChecklistItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Checklist=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Checklist}
 */
proto.claims_messages.GetChecklistTemplateResponse.prototype.addChecklistItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Checklist, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetChecklistTemplateResponse} returns this
 */
proto.claims_messages.GetChecklistTemplateResponse.prototype.clearChecklistItemsList = function() {
  return this.setChecklistItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimDetailListingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimDetailListingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimDetailListingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimDetailListingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
caseId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimDetailListingRequest}
 */
proto.claims_messages.GetClaimDetailListingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimDetailListingRequest;
  return proto.claims_messages.GetClaimDetailListingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimDetailListingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimDetailListingRequest}
 */
proto.claims_messages.GetClaimDetailListingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimDetailListingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimDetailListingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimDetailListingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimDetailListingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 case_id = 1;
 * @return {number}
 */
proto.claims_messages.GetClaimDetailListingRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetClaimDetailListingRequest} returns this
 */
proto.claims_messages.GetClaimDetailListingRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetClaimDetailListingResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimDetailListingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimDetailListingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimDetailListingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimDetailListingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsList: jspb.Message.toObjectList(msg.getClaimsList(),
    proto.claims_messages.CaseClaimDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimDetailListingResponse}
 */
proto.claims_messages.GetClaimDetailListingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimDetailListingResponse;
  return proto.claims_messages.GetClaimDetailListingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimDetailListingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimDetailListingResponse}
 */
proto.claims_messages.GetClaimDetailListingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.CaseClaimDetail;
      reader.readMessage(value,proto.claims_messages.CaseClaimDetail.deserializeBinaryFromReader);
      msg.addClaims(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimDetailListingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimDetailListingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimDetailListingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimDetailListingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.CaseClaimDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CaseClaimDetail claims = 1;
 * @return {!Array<!proto.claims_messages.CaseClaimDetail>}
 */
proto.claims_messages.GetClaimDetailListingResponse.prototype.getClaimsList = function() {
  return /** @type{!Array<!proto.claims_messages.CaseClaimDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.CaseClaimDetail, 1));
};


/**
 * @param {!Array<!proto.claims_messages.CaseClaimDetail>} value
 * @return {!proto.claims_messages.GetClaimDetailListingResponse} returns this
*/
proto.claims_messages.GetClaimDetailListingResponse.prototype.setClaimsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.CaseClaimDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.CaseClaimDetail}
 */
proto.claims_messages.GetClaimDetailListingResponse.prototype.addClaims = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.CaseClaimDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetClaimDetailListingResponse} returns this
 */
proto.claims_messages.GetClaimDetailListingResponse.prototype.clearClaimsList = function() {
  return this.setClaimsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsDueDates.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsDueDates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsDueDates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDueDates.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
dueDate: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsDueDates}
 */
proto.claims_messages.ClaimsDueDates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsDueDates;
  return proto.claims_messages.ClaimsDueDates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsDueDates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsDueDates}
 */
proto.claims_messages.ClaimsDueDates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsDueDates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsDueDates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsDueDates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsDueDates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDueDate();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsDueDates.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsDueDates} returns this
 */
proto.claims_messages.ClaimsDueDates.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 due_date = 2;
 * @return {number}
 */
proto.claims_messages.ClaimsDueDates.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsDueDates} returns this
 */
proto.claims_messages.ClaimsDueDates.prototype.setDueDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimsDueDatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimsDueDatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsDueDatesList: jspb.Message.toObjectList(msg.getClaimsDueDatesList(),
    proto.claims_messages.ClaimsDueDates.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimsDueDatesRequest}
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimsDueDatesRequest;
  return proto.claims_messages.UpdateClaimsDueDatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimsDueDatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimsDueDatesRequest}
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsDueDates;
      reader.readMessage(value,proto.claims_messages.ClaimsDueDates.deserializeBinaryFromReader);
      msg.addClaimsDueDates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimsDueDatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimsDueDatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsDueDatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsDueDates.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsDueDates claims_due_dates = 1;
 * @return {!Array<!proto.claims_messages.ClaimsDueDates>}
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.prototype.getClaimsDueDatesList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsDueDates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsDueDates, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsDueDates>} value
 * @return {!proto.claims_messages.UpdateClaimsDueDatesRequest} returns this
*/
proto.claims_messages.UpdateClaimsDueDatesRequest.prototype.setClaimsDueDatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsDueDates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsDueDates}
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.prototype.addClaimsDueDates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsDueDates, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.UpdateClaimsDueDatesRequest} returns this
 */
proto.claims_messages.UpdateClaimsDueDatesRequest.prototype.clearClaimsDueDatesList = function() {
  return this.setClaimsDueDatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimsDueDatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimsDueDatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimsDueDatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsDueDatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimsDueDatesResponse}
 */
proto.claims_messages.UpdateClaimsDueDatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimsDueDatesResponse;
  return proto.claims_messages.UpdateClaimsDueDatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimsDueDatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimsDueDatesResponse}
 */
proto.claims_messages.UpdateClaimsDueDatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimsDueDatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimsDueDatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimsDueDatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsDueDatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimCleanDateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimCleanDateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimCleanDateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimCleanDateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
cleanDate: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimCleanDateRequest}
 */
proto.claims_messages.UpdateClaimCleanDateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimCleanDateRequest;
  return proto.claims_messages.UpdateClaimCleanDateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimCleanDateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimCleanDateRequest}
 */
proto.claims_messages.UpdateClaimCleanDateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCleanDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimCleanDateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimCleanDateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimCleanDateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimCleanDateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCleanDate();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.UpdateClaimCleanDateRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.UpdateClaimCleanDateRequest} returns this
 */
proto.claims_messages.UpdateClaimCleanDateRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 clean_date = 2;
 * @return {number}
 */
proto.claims_messages.UpdateClaimCleanDateRequest.prototype.getCleanDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.UpdateClaimCleanDateRequest} returns this
 */
proto.claims_messages.UpdateClaimCleanDateRequest.prototype.setCleanDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimCleanDateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimCleanDateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimCleanDateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimCleanDateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimCleanDateResponse}
 */
proto.claims_messages.UpdateClaimCleanDateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimCleanDateResponse;
  return proto.claims_messages.UpdateClaimCleanDateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimCleanDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimCleanDateResponse}
 */
proto.claims_messages.UpdateClaimCleanDateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimCleanDateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimCleanDateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimCleanDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimCleanDateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssignees.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssignees.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssignees} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssignees.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
assigneeId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssignees}
 */
proto.claims_messages.ClaimsAssignees.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssignees;
  return proto.claims_messages.ClaimsAssignees.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssignees} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssignees}
 */
proto.claims_messages.ClaimsAssignees.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAssigneeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssignees.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssignees.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssignees} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssignees.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAssigneeId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsAssignees.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssignees} returns this
 */
proto.claims_messages.ClaimsAssignees.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 assignee_id = 2;
 * @return {number}
 */
proto.claims_messages.ClaimsAssignees.prototype.getAssigneeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssignees} returns this
 */
proto.claims_messages.ClaimsAssignees.prototype.setAssigneeId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsAssigneesUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsAssigneesUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssigneesUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
assignedAnalyst: (f = msg.getAssignedAnalyst()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
status: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate}
 */
proto.claims_messages.ClaimsAssigneesUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsAssigneesUpdate;
  return proto.claims_messages.ClaimsAssigneesUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsAssigneesUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate}
 */
proto.claims_messages.ClaimsAssigneesUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setAssignedAnalyst(value);
      break;
    case 3:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsAssigneesUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsAssigneesUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsAssigneesUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAssignedAnalyst();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate} returns this
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ClaimPerson assigned_analyst = 2;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.getAssignedAnalyst = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 2));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate} returns this
*/
proto.claims_messages.ClaimsAssigneesUpdate.prototype.setAssignedAnalyst = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate} returns this
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.clearAssignedAnalyst = function() {
  return this.setAssignedAnalyst(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.hasAssignedAnalyst = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ClaimsStatus status = 3;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.getStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate} returns this
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate} returns this
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsAssigneesUpdate.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimsAssigneesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimsAssigneesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsAssigneesList: jspb.Message.toObjectList(msg.getClaimsAssigneesList(),
    proto.claims_messages.ClaimsAssignees.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimsAssigneesRequest}
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimsAssigneesRequest;
  return proto.claims_messages.UpdateClaimsAssigneesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimsAssigneesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimsAssigneesRequest}
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsAssignees;
      reader.readMessage(value,proto.claims_messages.ClaimsAssignees.deserializeBinaryFromReader);
      msg.addClaimsAssignees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimsAssigneesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimsAssigneesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsAssigneesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsAssignees.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsAssignees claims_assignees = 1;
 * @return {!Array<!proto.claims_messages.ClaimsAssignees>}
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.prototype.getClaimsAssigneesList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsAssignees>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsAssignees, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsAssignees>} value
 * @return {!proto.claims_messages.UpdateClaimsAssigneesRequest} returns this
*/
proto.claims_messages.UpdateClaimsAssigneesRequest.prototype.setClaimsAssigneesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsAssignees=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsAssignees}
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.prototype.addClaimsAssignees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsAssignees, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.UpdateClaimsAssigneesRequest} returns this
 */
proto.claims_messages.UpdateClaimsAssigneesRequest.prototype.clearClaimsAssigneesList = function() {
  return this.setClaimsAssigneesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimsAssigneesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimsAssigneesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsAssigneesUpdatesList: jspb.Message.toObjectList(msg.getClaimsAssigneesUpdatesList(),
    proto.claims_messages.ClaimsAssigneesUpdate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimsAssigneesResponse}
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimsAssigneesResponse;
  return proto.claims_messages.UpdateClaimsAssigneesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimsAssigneesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimsAssigneesResponse}
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsAssigneesUpdate;
      reader.readMessage(value,proto.claims_messages.ClaimsAssigneesUpdate.deserializeBinaryFromReader);
      msg.addClaimsAssigneesUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimsAssigneesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimsAssigneesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsAssigneesUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsAssigneesUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsAssigneesUpdate claims_assignees_updates = 1;
 * @return {!Array<!proto.claims_messages.ClaimsAssigneesUpdate>}
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.prototype.getClaimsAssigneesUpdatesList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsAssigneesUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsAssigneesUpdate, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsAssigneesUpdate>} value
 * @return {!proto.claims_messages.UpdateClaimsAssigneesResponse} returns this
*/
proto.claims_messages.UpdateClaimsAssigneesResponse.prototype.setClaimsAssigneesUpdatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsAssigneesUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsAssigneesUpdate}
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.prototype.addClaimsAssigneesUpdates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsAssigneesUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.UpdateClaimsAssigneesResponse} returns this
 */
proto.claims_messages.UpdateClaimsAssigneesResponse.prototype.clearClaimsAssigneesUpdatesList = function() {
  return this.setClaimsAssigneesUpdatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsStatuses.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsStatuses.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsStatuses} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsStatuses.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsStatuses}
 */
proto.claims_messages.ClaimsStatuses.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsStatuses;
  return proto.claims_messages.ClaimsStatuses.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsStatuses} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsStatuses}
 */
proto.claims_messages.ClaimsStatuses.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsStatuses.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsStatuses.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsStatuses} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsStatuses.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsStatuses.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsStatuses} returns this
 */
proto.claims_messages.ClaimsStatuses.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ClaimsStatus status = 2;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.ClaimsStatuses.prototype.getStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.ClaimsStatuses} returns this
 */
proto.claims_messages.ClaimsStatuses.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsStatusesUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsStatusesUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsStatusesUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsStatusesUpdate}
 */
proto.claims_messages.ClaimsStatusesUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsStatusesUpdate;
  return proto.claims_messages.ClaimsStatusesUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsStatusesUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsStatusesUpdate}
 */
proto.claims_messages.ClaimsStatusesUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsStatusesUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsStatusesUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsStatusesUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsStatusesUpdate} returns this
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ClaimsStatus status = 2;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.getStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.ClaimsStatusesUpdate} returns this
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsStatusesUpdate} returns this
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsStatusesUpdate.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.UpdateClaimsStatusesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimsStatusesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimsStatusesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimsStatusesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsStatusesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsStatusesList: jspb.Message.toObjectList(msg.getClaimsStatusesList(),
    proto.claims_messages.ClaimsStatuses.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimsStatusesRequest}
 */
proto.claims_messages.UpdateClaimsStatusesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimsStatusesRequest;
  return proto.claims_messages.UpdateClaimsStatusesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimsStatusesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimsStatusesRequest}
 */
proto.claims_messages.UpdateClaimsStatusesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsStatuses;
      reader.readMessage(value,proto.claims_messages.ClaimsStatuses.deserializeBinaryFromReader);
      msg.addClaimsStatuses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimsStatusesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimsStatusesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimsStatusesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsStatusesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsStatusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsStatuses.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsStatuses claims_statuses = 1;
 * @return {!Array<!proto.claims_messages.ClaimsStatuses>}
 */
proto.claims_messages.UpdateClaimsStatusesRequest.prototype.getClaimsStatusesList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsStatuses>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsStatuses, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsStatuses>} value
 * @return {!proto.claims_messages.UpdateClaimsStatusesRequest} returns this
*/
proto.claims_messages.UpdateClaimsStatusesRequest.prototype.setClaimsStatusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsStatuses=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsStatuses}
 */
proto.claims_messages.UpdateClaimsStatusesRequest.prototype.addClaimsStatuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsStatuses, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.UpdateClaimsStatusesRequest} returns this
 */
proto.claims_messages.UpdateClaimsStatusesRequest.prototype.clearClaimsStatusesList = function() {
  return this.setClaimsStatusesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.UpdateClaimsStatusesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpdateClaimsStatusesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpdateClaimsStatusesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpdateClaimsStatusesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsStatusesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsStatusesUpdatesList: jspb.Message.toObjectList(msg.getClaimsStatusesUpdatesList(),
    proto.claims_messages.ClaimsStatusesUpdate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpdateClaimsStatusesResponse}
 */
proto.claims_messages.UpdateClaimsStatusesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpdateClaimsStatusesResponse;
  return proto.claims_messages.UpdateClaimsStatusesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpdateClaimsStatusesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpdateClaimsStatusesResponse}
 */
proto.claims_messages.UpdateClaimsStatusesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsStatusesUpdate;
      reader.readMessage(value,proto.claims_messages.ClaimsStatusesUpdate.deserializeBinaryFromReader);
      msg.addClaimsStatusesUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpdateClaimsStatusesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpdateClaimsStatusesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpdateClaimsStatusesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpdateClaimsStatusesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsStatusesUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsStatusesUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsStatusesUpdate claims_statuses_updates = 1;
 * @return {!Array<!proto.claims_messages.ClaimsStatusesUpdate>}
 */
proto.claims_messages.UpdateClaimsStatusesResponse.prototype.getClaimsStatusesUpdatesList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsStatusesUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsStatusesUpdate, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsStatusesUpdate>} value
 * @return {!proto.claims_messages.UpdateClaimsStatusesResponse} returns this
*/
proto.claims_messages.UpdateClaimsStatusesResponse.prototype.setClaimsStatusesUpdatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsStatusesUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsStatusesUpdate}
 */
proto.claims_messages.UpdateClaimsStatusesResponse.prototype.addClaimsStatusesUpdates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsStatusesUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.UpdateClaimsStatusesResponse} returns this
 */
proto.claims_messages.UpdateClaimsStatusesResponse.prototype.clearClaimsStatusesUpdatesList = function() {
  return this.setClaimsStatusesUpdatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimsStatusReasons.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimsStatusReasons.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimsStatusReasons} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsStatusReasons.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
reason: jspb.Message.getFieldWithDefault(msg, 3, 0),
note: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimsStatusReasons}
 */
proto.claims_messages.ClaimsStatusReasons.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimsStatusReasons;
  return proto.claims_messages.ClaimsStatusReasons.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimsStatusReasons} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimsStatusReasons}
 */
proto.claims_messages.ClaimsStatusReasons.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.claims_messages.ClaimsStatusReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimsStatusReasons.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimsStatusReasons.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimsStatusReasons} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimsStatusReasons.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimsStatusReasons.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimsStatusReasons} returns this
 */
proto.claims_messages.ClaimsStatusReasons.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ClaimsStatus status = 2;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.ClaimsStatusReasons.prototype.getStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.ClaimsStatusReasons} returns this
 */
proto.claims_messages.ClaimsStatusReasons.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ClaimsStatusReason reason = 3;
 * @return {!proto.claims_messages.ClaimsStatusReason}
 */
proto.claims_messages.ClaimsStatusReasons.prototype.getReason = function() {
  return /** @type {!proto.claims_messages.ClaimsStatusReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatusReason} value
 * @return {!proto.claims_messages.ClaimsStatusReasons} returns this
 */
proto.claims_messages.ClaimsStatusReasons.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string note = 4;
 * @return {string}
 */
proto.claims_messages.ClaimsStatusReasons.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimsStatusReasons} returns this
 */
proto.claims_messages.ClaimsStatusReasons.prototype.setNote = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimsStatusReasons} returns this
 */
proto.claims_messages.ClaimsStatusReasons.prototype.clearNote = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimsStatusReasons.prototype.hasNote = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimsStatusReasonsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimsStatusReasonsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimsStatusReasonsRequest}
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimsStatusReasonsRequest;
  return proto.claims_messages.GetClaimsStatusReasonsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimsStatusReasonsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimsStatusReasonsRequest}
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimsStatusReasonsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimsStatusReasonsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetClaimsStatusReasonsRequest} returns this
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ClaimsStatus status = 2;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.getStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.GetClaimsStatusReasonsRequest} returns this
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.GetClaimsStatusReasonsRequest} returns this
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetClaimsStatusReasonsRequest.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimsStatusReasonsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimsStatusReasonsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsStatusReasonsList: jspb.Message.toObjectList(msg.getClaimsStatusReasonsList(),
    proto.claims_messages.ClaimsStatusReasons.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimsStatusReasonsResponse}
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimsStatusReasonsResponse;
  return proto.claims_messages.GetClaimsStatusReasonsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimsStatusReasonsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimsStatusReasonsResponse}
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsStatusReasons;
      reader.readMessage(value,proto.claims_messages.ClaimsStatusReasons.deserializeBinaryFromReader);
      msg.addClaimsStatusReasons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimsStatusReasonsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimsStatusReasonsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsStatusReasonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsStatusReasons.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsStatusReasons claims_status_reasons = 1;
 * @return {!Array<!proto.claims_messages.ClaimsStatusReasons>}
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.prototype.getClaimsStatusReasonsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsStatusReasons>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsStatusReasons, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsStatusReasons>} value
 * @return {!proto.claims_messages.GetClaimsStatusReasonsResponse} returns this
*/
proto.claims_messages.GetClaimsStatusReasonsResponse.prototype.setClaimsStatusReasonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsStatusReasons=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsStatusReasons}
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.prototype.addClaimsStatusReasons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsStatusReasons, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetClaimsStatusReasonsResponse} returns this
 */
proto.claims_messages.GetClaimsStatusReasonsResponse.prototype.clearClaimsStatusReasonsList = function() {
  return this.setClaimsStatusReasonsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertClaimsStatusReasonsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertClaimsStatusReasonsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimsStatusReasonsList: jspb.Message.toObjectList(msg.getClaimsStatusReasonsList(),
    proto.claims_messages.ClaimsStatusReasons.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertClaimsStatusReasonsRequest}
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertClaimsStatusReasonsRequest;
  return proto.claims_messages.UpsertClaimsStatusReasonsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertClaimsStatusReasonsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertClaimsStatusReasonsRequest}
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimsStatusReasons;
      reader.readMessage(value,proto.claims_messages.ClaimsStatusReasons.deserializeBinaryFromReader);
      msg.addClaimsStatusReasons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertClaimsStatusReasonsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertClaimsStatusReasonsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimsStatusReasonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimsStatusReasons.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimsStatusReasons claims_status_reasons = 1;
 * @return {!Array<!proto.claims_messages.ClaimsStatusReasons>}
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.prototype.getClaimsStatusReasonsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimsStatusReasons>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimsStatusReasons, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsStatusReasons>} value
 * @return {!proto.claims_messages.UpsertClaimsStatusReasonsRequest} returns this
*/
proto.claims_messages.UpsertClaimsStatusReasonsRequest.prototype.setClaimsStatusReasonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimsStatusReasons=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimsStatusReasons}
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.prototype.addClaimsStatusReasons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimsStatusReasons, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.UpsertClaimsStatusReasonsRequest} returns this
 */
proto.claims_messages.UpsertClaimsStatusReasonsRequest.prototype.clearClaimsStatusReasonsList = function() {
  return this.setClaimsStatusReasonsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.UpsertClaimsStatusReasonsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.UpsertClaimsStatusReasonsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.UpsertClaimsStatusReasonsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimsStatusReasonsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.UpsertClaimsStatusReasonsResponse}
 */
proto.claims_messages.UpsertClaimsStatusReasonsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.UpsertClaimsStatusReasonsResponse;
  return proto.claims_messages.UpsertClaimsStatusReasonsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.UpsertClaimsStatusReasonsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.UpsertClaimsStatusReasonsResponse}
 */
proto.claims_messages.UpsertClaimsStatusReasonsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.UpsertClaimsStatusReasonsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.UpsertClaimsStatusReasonsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.UpsertClaimsStatusReasonsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.UpsertClaimsStatusReasonsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.SearchNotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.SearchNotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.SearchNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SearchNotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
sortField: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
sortDir: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
searchField: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
searchString: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
filterRole: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
filterNoteType: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.SearchNotesRequest}
 */
proto.claims_messages.SearchNotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.SearchNotesRequest;
  return proto.claims_messages.SearchNotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.SearchNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.SearchNotesRequest}
 */
proto.claims_messages.SearchNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDir(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchField(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchString(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterRole(value);
      break;
    case 9:
      var value = /** @type {!proto.claims_messages.NoteTypeName} */ (reader.readEnum());
      msg.setFilterNoteType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.SearchNotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.SearchNotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.SearchNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SearchNotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {!proto.claims_messages.NoteTypeName} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.claims_messages.SearchNotesRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.claims_messages.SearchNotesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.claims_messages.SearchNotesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string sort_field = 4;
 * @return {string}
 */
proto.claims_messages.SearchNotesRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setSortField = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.clearSortField = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.SearchNotesRequest.prototype.hasSortField = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string sort_dir = 5;
 * @return {string}
 */
proto.claims_messages.SearchNotesRequest.prototype.getSortDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setSortDir = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.clearSortDir = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.SearchNotesRequest.prototype.hasSortDir = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string search_field = 6;
 * @return {string}
 */
proto.claims_messages.SearchNotesRequest.prototype.getSearchField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setSearchField = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.clearSearchField = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.SearchNotesRequest.prototype.hasSearchField = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string search_string = 7;
 * @return {string}
 */
proto.claims_messages.SearchNotesRequest.prototype.getSearchString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setSearchString = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.clearSearchString = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.SearchNotesRequest.prototype.hasSearchString = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string filter_role = 8;
 * @return {string}
 */
proto.claims_messages.SearchNotesRequest.prototype.getFilterRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setFilterRole = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.clearFilterRole = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.SearchNotesRequest.prototype.hasFilterRole = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional NoteTypeName filter_note_type = 9;
 * @return {!proto.claims_messages.NoteTypeName}
 */
proto.claims_messages.SearchNotesRequest.prototype.getFilterNoteType = function() {
  return /** @type {!proto.claims_messages.NoteTypeName} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.claims_messages.NoteTypeName} value
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.setFilterNoteType = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.SearchNotesRequest} returns this
 */
proto.claims_messages.SearchNotesRequest.prototype.clearFilterNoteType = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.SearchNotesRequest.prototype.hasFilterNoteType = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.SearchNotesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.SearchNotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.SearchNotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.SearchNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SearchNotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.claims_messages.Note.toObject, includeInstance),
paginationResponse: (f = msg.getPaginationResponse()) && messages_core_message_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.SearchNotesResponse}
 */
proto.claims_messages.SearchNotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.SearchNotesResponse;
  return proto.claims_messages.SearchNotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.SearchNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.SearchNotesResponse}
 */
proto.claims_messages.SearchNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.Note;
      reader.readMessage(value,proto.claims_messages.Note.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    case 2:
      var value = new messages_core_message_pb.PaginationResponse;
      reader.readMessage(value,messages_core_message_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.SearchNotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.SearchNotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.SearchNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.SearchNotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.Note.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Note notes = 1;
 * @return {!Array<!proto.claims_messages.Note>}
 */
proto.claims_messages.SearchNotesResponse.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.claims_messages.Note>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.Note, 1));
};


/**
 * @param {!Array<!proto.claims_messages.Note>} value
 * @return {!proto.claims_messages.SearchNotesResponse} returns this
*/
proto.claims_messages.SearchNotesResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.Note}
 */
proto.claims_messages.SearchNotesResponse.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.Note, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.SearchNotesResponse} returns this
 */
proto.claims_messages.SearchNotesResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};


/**
 * optional core_messages.PaginationResponse pagination_response = 2;
 * @return {?proto.core_messages.PaginationResponse}
 */
proto.claims_messages.SearchNotesResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.core_messages.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.core_messages.PaginationResponse|undefined} value
 * @return {!proto.claims_messages.SearchNotesResponse} returns this
*/
proto.claims_messages.SearchNotesResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.SearchNotesResponse} returns this
 */
proto.claims_messages.SearchNotesResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.SearchNotesResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CheckForDuplicateClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CheckForDuplicateClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CheckForDuplicateClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckForDuplicateClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
passCaseId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CheckForDuplicateClaimRequest}
 */
proto.claims_messages.CheckForDuplicateClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CheckForDuplicateClaimRequest;
  return proto.claims_messages.CheckForDuplicateClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CheckForDuplicateClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CheckForDuplicateClaimRequest}
 */
proto.claims_messages.CheckForDuplicateClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPassCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CheckForDuplicateClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CheckForDuplicateClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CheckForDuplicateClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckForDuplicateClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 pass_case_id = 1;
 * @return {number}
 */
proto.claims_messages.CheckForDuplicateClaimRequest.prototype.getPassCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CheckForDuplicateClaimRequest} returns this
 */
proto.claims_messages.CheckForDuplicateClaimRequest.prototype.setPassCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CheckForDuplicateClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CheckForDuplicateClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CheckForDuplicateClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckForDuplicateClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isDupe: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CheckForDuplicateClaimResponse}
 */
proto.claims_messages.CheckForDuplicateClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CheckForDuplicateClaimResponse;
  return proto.claims_messages.CheckForDuplicateClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CheckForDuplicateClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CheckForDuplicateClaimResponse}
 */
proto.claims_messages.CheckForDuplicateClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDupe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CheckForDuplicateClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CheckForDuplicateClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CheckForDuplicateClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CheckForDuplicateClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsDupe();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_dupe = 1;
 * @return {boolean}
 */
proto.claims_messages.CheckForDuplicateClaimResponse.prototype.getIsDupe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.CheckForDuplicateClaimResponse} returns this
 */
proto.claims_messages.CheckForDuplicateClaimResponse.prototype.setIsDupe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ClaimReservation.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ClaimReservation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ClaimReservation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimReservation.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
passGroupId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
legalFilingState: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
benefitCode: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
createdByUserId: jspb.Message.getFieldWithDefault(msg, 7, 0),
createdOn: jspb.Message.getFieldWithDefault(msg, 8, 0),
removedByUserId: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
removedOn: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
isDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
user: (f = msg.getUser()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
createdByUser: (f = msg.getCreatedByUser()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
removedByUser: (f = msg.getRemovedByUser()) && proto.claims_messages.ClaimPerson.toObject(includeInstance, f),
claimStatus: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ClaimReservation}
 */
proto.claims_messages.ClaimReservation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ClaimReservation;
  return proto.claims_messages.ClaimReservation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ClaimReservation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ClaimReservation}
 */
proto.claims_messages.ClaimReservation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassGroupId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalFilingState(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedByUserId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedOn(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemovedByUserId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRemovedOn(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeleted(value);
      break;
    case 12:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 13:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setCreatedByUser(value);
      break;
    case 14:
      var value = new proto.claims_messages.ClaimPerson;
      reader.readMessage(value,proto.claims_messages.ClaimPerson.deserializeBinaryFromReader);
      msg.setRemovedByUser(value);
      break;
    case 15:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setClaimStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ClaimReservation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ClaimReservation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ClaimReservation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ClaimReservation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedByUserId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCreatedOn();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getIsDeleted();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = message.getCreatedByUser();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = message.getRemovedByUser();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.claims_messages.ClaimPerson.serializeBinaryToWriter
    );
  }
  f = message.getClaimStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.ClaimReservation.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.claims_messages.ClaimReservation.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.claims_messages.ClaimReservation.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string pass_group_id = 4;
 * @return {string}
 */
proto.claims_messages.ClaimReservation.prototype.getPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setPassGroupId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearPassGroupId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasPassGroupId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string legal_filing_state = 5;
 * @return {string}
 */
proto.claims_messages.ClaimReservation.prototype.getLegalFilingState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setLegalFilingState = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearLegalFilingState = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasLegalFilingState = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string benefit_code = 6;
 * @return {string}
 */
proto.claims_messages.ClaimReservation.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setBenefitCode = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearBenefitCode = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasBenefitCode = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 created_by_user_id = 7;
 * @return {number}
 */
proto.claims_messages.ClaimReservation.prototype.getCreatedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setCreatedByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 created_on = 8;
 * @return {number}
 */
proto.claims_messages.ClaimReservation.prototype.getCreatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setCreatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 removed_by_user_id = 9;
 * @return {number}
 */
proto.claims_messages.ClaimReservation.prototype.getRemovedByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setRemovedByUserId = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearRemovedByUserId = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasRemovedByUserId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int64 removed_on = 10;
 * @return {number}
 */
proto.claims_messages.ClaimReservation.prototype.getRemovedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setRemovedOn = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearRemovedOn = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasRemovedOn = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool is_deleted = 11;
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.getIsDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setIsDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional ClaimPerson user = 12;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.ClaimReservation.prototype.getUser = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 12));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
*/
proto.claims_messages.ClaimReservation.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasUser = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ClaimPerson created_by_user = 13;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.ClaimReservation.prototype.getCreatedByUser = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 13));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
*/
proto.claims_messages.ClaimReservation.prototype.setCreatedByUser = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearCreatedByUser = function() {
  return this.setCreatedByUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasCreatedByUser = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ClaimPerson removed_by_user = 14;
 * @return {?proto.claims_messages.ClaimPerson}
 */
proto.claims_messages.ClaimReservation.prototype.getRemovedByUser = function() {
  return /** @type{?proto.claims_messages.ClaimPerson} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimPerson, 14));
};


/**
 * @param {?proto.claims_messages.ClaimPerson|undefined} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
*/
proto.claims_messages.ClaimReservation.prototype.setRemovedByUser = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.clearRemovedByUser = function() {
  return this.setRemovedByUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ClaimReservation.prototype.hasRemovedByUser = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional ClaimsStatus claim_status = 15;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.ClaimReservation.prototype.getClaimStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.ClaimReservation} returns this
 */
proto.claims_messages.ClaimReservation.prototype.setClaimStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateClaimReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateClaimReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateClaimReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
passGroupId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
benefitCode: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
legalFilingState: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
claimStatus: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateClaimReservationRequest}
 */
proto.claims_messages.CreateClaimReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateClaimReservationRequest;
  return proto.claims_messages.CreateClaimReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateClaimReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateClaimReservationRequest}
 */
proto.claims_messages.CreateClaimReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalFilingState(value);
      break;
    case 5:
      var value = /** @type {!proto.claims_messages.ClaimsStatus} */ (reader.readEnum());
      msg.setClaimStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateClaimReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateClaimReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateClaimReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClaimStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string pass_group_id = 2;
 * @return {string}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.getPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.setPassGroupId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.clearPassGroupId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.hasPassGroupId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string benefit_code = 3;
 * @return {string}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.setBenefitCode = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.clearBenefitCode = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.hasBenefitCode = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string legal_filing_state = 4;
 * @return {string}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.getLegalFilingState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.setLegalFilingState = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.clearLegalFilingState = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.hasLegalFilingState = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ClaimsStatus claim_status = 5;
 * @return {!proto.claims_messages.ClaimsStatus}
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.getClaimStatus = function() {
  return /** @type {!proto.claims_messages.ClaimsStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @return {!proto.claims_messages.CreateClaimReservationRequest} returns this
 */
proto.claims_messages.CreateClaimReservationRequest.prototype.setClaimStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.CreateClaimReservationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.CreateClaimReservationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.CreateClaimReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateClaimReservationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
reservation: (f = msg.getReservation()) && proto.claims_messages.ClaimReservation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.CreateClaimReservationResponse}
 */
proto.claims_messages.CreateClaimReservationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.CreateClaimReservationResponse;
  return proto.claims_messages.CreateClaimReservationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.CreateClaimReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.CreateClaimReservationResponse}
 */
proto.claims_messages.CreateClaimReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimReservation;
      reader.readMessage(value,proto.claims_messages.ClaimReservation.deserializeBinaryFromReader);
      msg.setReservation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.CreateClaimReservationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.CreateClaimReservationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.CreateClaimReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.CreateClaimReservationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimReservation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimReservation reservation = 1;
 * @return {?proto.claims_messages.ClaimReservation}
 */
proto.claims_messages.CreateClaimReservationResponse.prototype.getReservation = function() {
  return /** @type{?proto.claims_messages.ClaimReservation} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimReservation, 1));
};


/**
 * @param {?proto.claims_messages.ClaimReservation|undefined} value
 * @return {!proto.claims_messages.CreateClaimReservationResponse} returns this
*/
proto.claims_messages.CreateClaimReservationResponse.prototype.setReservation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.CreateClaimReservationResponse} returns this
 */
proto.claims_messages.CreateClaimReservationResponse.prototype.clearReservation = function() {
  return this.setReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.CreateClaimReservationResponse.prototype.hasReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RemoveClaimReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RemoveClaimReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RemoveClaimReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveClaimReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RemoveClaimReservationRequest}
 */
proto.claims_messages.RemoveClaimReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RemoveClaimReservationRequest;
  return proto.claims_messages.RemoveClaimReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RemoveClaimReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RemoveClaimReservationRequest}
 */
proto.claims_messages.RemoveClaimReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RemoveClaimReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RemoveClaimReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RemoveClaimReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveClaimReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.RemoveClaimReservationRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.RemoveClaimReservationRequest} returns this
 */
proto.claims_messages.RemoveClaimReservationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RemoveClaimReservationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RemoveClaimReservationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RemoveClaimReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveClaimReservationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
reservation: (f = msg.getReservation()) && proto.claims_messages.ClaimReservation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RemoveClaimReservationResponse}
 */
proto.claims_messages.RemoveClaimReservationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RemoveClaimReservationResponse;
  return proto.claims_messages.RemoveClaimReservationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RemoveClaimReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RemoveClaimReservationResponse}
 */
proto.claims_messages.RemoveClaimReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimReservation;
      reader.readMessage(value,proto.claims_messages.ClaimReservation.deserializeBinaryFromReader);
      msg.setReservation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RemoveClaimReservationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RemoveClaimReservationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RemoveClaimReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RemoveClaimReservationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimReservation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimReservation reservation = 1;
 * @return {?proto.claims_messages.ClaimReservation}
 */
proto.claims_messages.RemoveClaimReservationResponse.prototype.getReservation = function() {
  return /** @type{?proto.claims_messages.ClaimReservation} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimReservation, 1));
};


/**
 * @param {?proto.claims_messages.ClaimReservation|undefined} value
 * @return {!proto.claims_messages.RemoveClaimReservationResponse} returns this
*/
proto.claims_messages.RemoveClaimReservationResponse.prototype.setReservation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.RemoveClaimReservationResponse} returns this
 */
proto.claims_messages.RemoveClaimReservationResponse.prototype.clearReservation = function() {
  return this.setReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.RemoveClaimReservationResponse.prototype.hasReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RecoverClaimReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RecoverClaimReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RecoverClaimReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverClaimReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RecoverClaimReservationRequest}
 */
proto.claims_messages.RecoverClaimReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RecoverClaimReservationRequest;
  return proto.claims_messages.RecoverClaimReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RecoverClaimReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RecoverClaimReservationRequest}
 */
proto.claims_messages.RecoverClaimReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RecoverClaimReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RecoverClaimReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RecoverClaimReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverClaimReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.RecoverClaimReservationRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.RecoverClaimReservationRequest} returns this
 */
proto.claims_messages.RecoverClaimReservationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.RecoverClaimReservationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.RecoverClaimReservationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.RecoverClaimReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverClaimReservationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
reservation: (f = msg.getReservation()) && proto.claims_messages.ClaimReservation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.RecoverClaimReservationResponse}
 */
proto.claims_messages.RecoverClaimReservationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.RecoverClaimReservationResponse;
  return proto.claims_messages.RecoverClaimReservationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.RecoverClaimReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.RecoverClaimReservationResponse}
 */
proto.claims_messages.RecoverClaimReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimReservation;
      reader.readMessage(value,proto.claims_messages.ClaimReservation.deserializeBinaryFromReader);
      msg.setReservation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.RecoverClaimReservationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.RecoverClaimReservationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.RecoverClaimReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.RecoverClaimReservationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimReservation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimReservation reservation = 1;
 * @return {?proto.claims_messages.ClaimReservation}
 */
proto.claims_messages.RecoverClaimReservationResponse.prototype.getReservation = function() {
  return /** @type{?proto.claims_messages.ClaimReservation} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimReservation, 1));
};


/**
 * @param {?proto.claims_messages.ClaimReservation|undefined} value
 * @return {!proto.claims_messages.RecoverClaimReservationResponse} returns this
*/
proto.claims_messages.RecoverClaimReservationResponse.prototype.setReservation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.RecoverClaimReservationResponse} returns this
 */
proto.claims_messages.RecoverClaimReservationResponse.prototype.clearReservation = function() {
  return this.setReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.RecoverClaimReservationResponse.prototype.hasReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ListClaimReservationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ListClaimReservationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ListClaimReservationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
sortField: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
sortDir: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
filterUserId: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
filterPassGroupId: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
includeDeleted: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ListClaimReservationsRequest}
 */
proto.claims_messages.ListClaimReservationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ListClaimReservationsRequest;
  return proto.claims_messages.ListClaimReservationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ListClaimReservationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ListClaimReservationsRequest}
 */
proto.claims_messages.ListClaimReservationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDir(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFilterUserId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterPassGroupId(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ListClaimReservationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ListClaimReservationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ListClaimReservationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sort_field = 3;
 * @return {string}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.setSortField = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.clearSortField = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.hasSortField = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string sort_dir = 4;
 * @return {string}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.getSortDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.setSortDir = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.clearSortDir = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.hasSortDir = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 filter_user_id = 5;
 * @return {number}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.getFilterUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.setFilterUserId = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.clearFilterUserId = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.hasFilterUserId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string filter_pass_group_id = 6;
 * @return {string}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.getFilterPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.setFilterPassGroupId = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.clearFilterPassGroupId = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.hasFilterPassGroupId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool include_deleted = 7;
 * @return {boolean}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.getIncludeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.setIncludeDeleted = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.claims_messages.ListClaimReservationsRequest} returns this
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.clearIncludeDeleted = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ListClaimReservationsRequest.prototype.hasIncludeDeleted = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.ListClaimReservationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.ListClaimReservationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.ListClaimReservationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ListClaimReservationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
reservationsList: jspb.Message.toObjectList(msg.getReservationsList(),
    proto.claims_messages.ClaimReservation.toObject, includeInstance),
paginationResponse: (f = msg.getPaginationResponse()) && messages_core_message_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.ListClaimReservationsResponse}
 */
proto.claims_messages.ListClaimReservationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.ListClaimReservationsResponse;
  return proto.claims_messages.ListClaimReservationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.ListClaimReservationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.ListClaimReservationsResponse}
 */
proto.claims_messages.ListClaimReservationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimReservation;
      reader.readMessage(value,proto.claims_messages.ClaimReservation.deserializeBinaryFromReader);
      msg.addReservations(value);
      break;
    case 2:
      var value = new messages_core_message_pb.PaginationResponse;
      reader.readMessage(value,messages_core_message_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.ListClaimReservationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.ListClaimReservationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.ListClaimReservationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.ClaimReservation.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClaimReservation reservations = 1;
 * @return {!Array<!proto.claims_messages.ClaimReservation>}
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.getReservationsList = function() {
  return /** @type{!Array<!proto.claims_messages.ClaimReservation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.ClaimReservation, 1));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimReservation>} value
 * @return {!proto.claims_messages.ListClaimReservationsResponse} returns this
*/
proto.claims_messages.ListClaimReservationsResponse.prototype.setReservationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.ClaimReservation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.ClaimReservation}
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.addReservations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.ClaimReservation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.ListClaimReservationsResponse} returns this
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.clearReservationsList = function() {
  return this.setReservationsList([]);
};


/**
 * optional core_messages.PaginationResponse pagination_response = 2;
 * @return {?proto.core_messages.PaginationResponse}
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.core_messages.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.core_messages.PaginationResponse|undefined} value
 * @return {!proto.claims_messages.ListClaimReservationsResponse} returns this
*/
proto.claims_messages.ListClaimReservationsResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.ListClaimReservationsResponse} returns this
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.ListClaimReservationsResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimReservationRequest}
 */
proto.claims_messages.GetClaimReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimReservationRequest;
  return proto.claims_messages.GetClaimReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimReservationRequest}
 */
proto.claims_messages.GetClaimReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.claims_messages.GetClaimReservationRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.claims_messages.GetClaimReservationRequest} returns this
 */
proto.claims_messages.GetClaimReservationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimReservationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimReservationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
reservation: (f = msg.getReservation()) && proto.claims_messages.ClaimReservation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimReservationResponse}
 */
proto.claims_messages.GetClaimReservationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimReservationResponse;
  return proto.claims_messages.GetClaimReservationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimReservationResponse}
 */
proto.claims_messages.GetClaimReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.ClaimReservation;
      reader.readMessage(value,proto.claims_messages.ClaimReservation.deserializeBinaryFromReader);
      msg.setReservation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimReservationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimReservationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.claims_messages.ClaimReservation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimReservation reservation = 1;
 * @return {?proto.claims_messages.ClaimReservation}
 */
proto.claims_messages.GetClaimReservationResponse.prototype.getReservation = function() {
  return /** @type{?proto.claims_messages.ClaimReservation} */ (
    jspb.Message.getWrapperField(this, proto.claims_messages.ClaimReservation, 1));
};


/**
 * @param {?proto.claims_messages.ClaimReservation|undefined} value
 * @return {!proto.claims_messages.GetClaimReservationResponse} returns this
*/
proto.claims_messages.GetClaimReservationResponse.prototype.setReservation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.claims_messages.GetClaimReservationResponse} returns this
 */
proto.claims_messages.GetClaimReservationResponse.prototype.clearReservation = function() {
  return this.setReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.claims_messages.GetClaimReservationResponse.prototype.hasReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimReservationFormDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimReservationFormDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimReservationFormDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationFormDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimReservationFormDataRequest}
 */
proto.claims_messages.GetClaimReservationFormDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimReservationFormDataRequest;
  return proto.claims_messages.GetClaimReservationFormDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimReservationFormDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimReservationFormDataRequest}
 */
proto.claims_messages.GetClaimReservationFormDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimReservationFormDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimReservationFormDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimReservationFormDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationFormDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.PassGroupOption.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.PassGroupOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.PassGroupOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PassGroupOption.toObject = function(includeInstance, msg) {
  var f, obj = {
passGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
groupName: jspb.Message.getFieldWithDefault(msg, 2, ""),
groupNameShort: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.PassGroupOption}
 */
proto.claims_messages.PassGroupOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.PassGroupOption;
  return proto.claims_messages.PassGroupOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.PassGroupOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.PassGroupOption}
 */
proto.claims_messages.PassGroupOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupNameShort(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.PassGroupOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.PassGroupOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.PassGroupOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.PassGroupOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupNameShort();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string pass_group_id = 1;
 * @return {string}
 */
proto.claims_messages.PassGroupOption.prototype.getPassGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PassGroupOption} returns this
 */
proto.claims_messages.PassGroupOption.prototype.setPassGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_name = 2;
 * @return {string}
 */
proto.claims_messages.PassGroupOption.prototype.getGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PassGroupOption} returns this
 */
proto.claims_messages.PassGroupOption.prototype.setGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string group_name_short = 3;
 * @return {string}
 */
proto.claims_messages.PassGroupOption.prototype.getGroupNameShort = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.PassGroupOption} returns this
 */
proto.claims_messages.PassGroupOption.prototype.setGroupNameShort = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.BenefitCodeOption.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.BenefitCodeOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.BenefitCodeOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BenefitCodeOption.toObject = function(includeInstance, msg) {
  var f, obj = {
matterBillingCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
matterTitle: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.BenefitCodeOption}
 */
proto.claims_messages.BenefitCodeOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.BenefitCodeOption;
  return proto.claims_messages.BenefitCodeOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.BenefitCodeOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.BenefitCodeOption}
 */
proto.claims_messages.BenefitCodeOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterBillingCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatterTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.BenefitCodeOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.BenefitCodeOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.BenefitCodeOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.BenefitCodeOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatterBillingCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatterTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string matter_billing_code = 1;
 * @return {string}
 */
proto.claims_messages.BenefitCodeOption.prototype.getMatterBillingCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.BenefitCodeOption} returns this
 */
proto.claims_messages.BenefitCodeOption.prototype.setMatterBillingCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string matter_title = 2;
 * @return {string}
 */
proto.claims_messages.BenefitCodeOption.prototype.getMatterTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.claims_messages.BenefitCodeOption} returns this
 */
proto.claims_messages.BenefitCodeOption.prototype.setMatterTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.claims_messages.GetClaimReservationFormDataResponse.repeatedFields_ = [1,2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.claims_messages.GetClaimReservationFormDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.claims_messages.GetClaimReservationFormDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationFormDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
passGroupsList: jspb.Message.toObjectList(msg.getPassGroupsList(),
    proto.claims_messages.PassGroupOption.toObject, includeInstance),
statesList: jspb.Message.toObjectList(msg.getStatesList(),
    messages_core_message_pb.State.toObject, includeInstance),
benefitCodesList: jspb.Message.toObjectList(msg.getBenefitCodesList(),
    proto.claims_messages.BenefitCodeOption.toObject, includeInstance),
claimStatusesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.claims_messages.GetClaimReservationFormDataResponse;
  return proto.claims_messages.GetClaimReservationFormDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.claims_messages.GetClaimReservationFormDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.claims_messages.PassGroupOption;
      reader.readMessage(value,proto.claims_messages.PassGroupOption.deserializeBinaryFromReader);
      msg.addPassGroups(value);
      break;
    case 2:
      var value = new messages_core_message_pb.State;
      reader.readMessage(value,messages_core_message_pb.State.deserializeBinaryFromReader);
      msg.addStates(value);
      break;
    case 3:
      var value = new proto.claims_messages.BenefitCodeOption;
      reader.readMessage(value,proto.claims_messages.BenefitCodeOption.deserializeBinaryFromReader);
      msg.addBenefitCodes(value);
      break;
    case 4:
      var values = /** @type {!Array<!proto.claims_messages.ClaimsStatus>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addClaimStatuses(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.claims_messages.GetClaimReservationFormDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.claims_messages.GetClaimReservationFormDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.claims_messages.GetClaimReservationFormDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.claims_messages.PassGroupOption.serializeBinaryToWriter
    );
  }
  f = message.getStatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      messages_core_message_pb.State.serializeBinaryToWriter
    );
  }
  f = message.getBenefitCodesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.claims_messages.BenefitCodeOption.serializeBinaryToWriter
    );
  }
  f = message.getClaimStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
};


/**
 * repeated PassGroupOption pass_groups = 1;
 * @return {!Array<!proto.claims_messages.PassGroupOption>}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.getPassGroupsList = function() {
  return /** @type{!Array<!proto.claims_messages.PassGroupOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.PassGroupOption, 1));
};


/**
 * @param {!Array<!proto.claims_messages.PassGroupOption>} value
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
*/
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.setPassGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.claims_messages.PassGroupOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.PassGroupOption}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.addPassGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.claims_messages.PassGroupOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.clearPassGroupsList = function() {
  return this.setPassGroupsList([]);
};


/**
 * repeated core_messages.State states = 2;
 * @return {!Array<!proto.core_messages.State>}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.getStatesList = function() {
  return /** @type{!Array<!proto.core_messages.State>} */ (
    jspb.Message.getRepeatedWrapperField(this, messages_core_message_pb.State, 2));
};


/**
 * @param {!Array<!proto.core_messages.State>} value
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
*/
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.setStatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.core_messages.State=} opt_value
 * @param {number=} opt_index
 * @return {!proto.core_messages.State}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.addStates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.core_messages.State, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.clearStatesList = function() {
  return this.setStatesList([]);
};


/**
 * repeated BenefitCodeOption benefit_codes = 3;
 * @return {!Array<!proto.claims_messages.BenefitCodeOption>}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.getBenefitCodesList = function() {
  return /** @type{!Array<!proto.claims_messages.BenefitCodeOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.claims_messages.BenefitCodeOption, 3));
};


/**
 * @param {!Array<!proto.claims_messages.BenefitCodeOption>} value
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
*/
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.setBenefitCodesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.claims_messages.BenefitCodeOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.BenefitCodeOption}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.addBenefitCodes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.claims_messages.BenefitCodeOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.clearBenefitCodesList = function() {
  return this.setBenefitCodesList([]);
};


/**
 * repeated ClaimsStatus claim_statuses = 4;
 * @return {!Array<!proto.claims_messages.ClaimsStatus>}
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.getClaimStatusesList = function() {
  return /** @type {!Array<!proto.claims_messages.ClaimsStatus>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.claims_messages.ClaimsStatus>} value
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.setClaimStatusesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.claims_messages.ClaimsStatus} value
 * @param {number=} opt_index
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.addClaimStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.claims_messages.GetClaimReservationFormDataResponse} returns this
 */
proto.claims_messages.GetClaimReservationFormDataResponse.prototype.clearClaimStatusesList = function() {
  return this.setClaimStatusesList([]);
};


/**
 * @enum {number}
 */
proto.claims_messages.MemberType = {
  PRIMARY: 0,
  SPOUSE: 1,
  DOMESTIC_PARTNER: 2,
  DEPENDANT_CHILD: 3,
  ELDER_PARENT: 4,
  OTHER: 5
};

/**
 * @enum {number}
 */
proto.claims_messages.BillingProviderType = {
  ATTORNEY: 0,
  PARALEGAL: 1
};

/**
 * @enum {number}
 */
proto.claims_messages.DocumentCategory = {
  INVOICES: 0,
  SUPPORTING_DOCUMENTS: 1,
  PROOF_OF_FULL_TIME_SCHOOL_ENROLLMENT: 2,
  CLAIM_FORMS: 3,
  CCS: 4,
  DENIED_DOCUMENTS: 5,
  AUDIT_DOCUMENTS: 6
};

/**
 * @enum {number}
 */
proto.claims_messages.ClaimsStatus = {
  DRAFT: 0,
  SUBMITTED: 1,
  IN_REVIEW: 2,
  CANCELLED: 3,
  APPROVED: 4,
  DENIED: 5,
  QUEUED_FOR_PAYMENT: 6,
  CLOSED_NOT_PAID: 7,
  CLOSED_PAID: 8,
  ARCHIVED: 9,
  PENDING_PROVIDER: 10,
  PENDING_VERIFICATION: 11,
  PENDING_INTERNAL_REVIEW: 12,
  CLOSED_NOT_PAID_GOODWILL: 13,
  DUPLICATE: 14
};

/**
 * @enum {number}
 */
proto.claims_messages.ClaimsStatusReason = {
  CLAIMS_STATUS_REASON_HOURLY_INVOICE: 0,
  CLAIMS_STATUS_REASON_FLAT_FEE_INVOICE: 1,
  CLAIMS_STATUS_REASON_SUPPORTING_DOCUMENTS: 2,
  CLAIMS_STATUS_REASON_PROOF_OF_ENROLLMENT: 3,
  CLAIMS_STATUS_REASON_OTHER: 4
};

/**
 * @enum {number}
 */
proto.claims_messages.ClaimReportType = {
  POSITIVE: 0,
  NEGATIVE: 1
};

/**
 * @enum {number}
 */
proto.claims_messages.NoteTypeName = {
  NOTE_TYPE_GENERAL: 0,
  NOTE_TYPE_CASE_REVIEW: 1,
  NOTE_TYPE_FOLLOW_UP: 2,
  NOTE_TYPE_OTHER: 3
};

/**
 * @enum {number}
 */
proto.claims_messages.ActivityTypeName = {
  ASSIGNMENT: 0,
  BILLING: 1,
  CHECKLIST: 2,
  DOCUMENT: 3,
  GENERAL: 4,
  NOTE: 5,
  SERVICE: 6,
  STATUS: 7,
  AUTO_ASSIGNMENT: 8
};

/**
 * @enum {number}
 */
proto.claims_messages.ExportEntityType = {
  EXPORT_ENTITY_TYPE_UNSPECIFIED: 0,
  EXPORT_ENTITY_TYPE_CLAIMS: 1,
  EXPORT_ENTITY_TYPE_NOTES: 2,
  EXPORT_ENTITY_TYPE_ACTIVITIES: 3,
  EXPORT_ENTITY_TYPE_PAYMENT_EXPORTS: 4,
  EXPORT_ENTITY_TYPE_DOCUMENTS: 5
};

/**
 * @enum {number}
 */
proto.claims_messages.ChecklistType = {
  ELIGIBILITY_ACTIVE: 0,
  ELIGIBILITY_SINGLE_OR_FAMILY: 1,
  ELIGIBILITY_ELIGIBLE: 2,
  ELIGIBILITY_DEPENDENT: 3,
  ELIGIBILITY_PREMIUMS: 4,
  ELIGIBILITY_PREVIOUS_PAYMENT: 5,
  INVOICES_REQUIREMENTS: 6,
  INVOICES_ELIGIBLE_DATES: 7,
  INVOICES_HOURS_BILLED: 8,
  INVOICES_NON_ALLOWABLE_CHARGES: 9,
  INVOICES_PLAN_MAXIMUM: 10,
  DOCS_SERVICES_FOR_ELIGIBLE: 11,
  DOCS_BEST_EVIDENCE_BACKUP: 12,
  DOCS_INVOICE_DATE_CHECK: 13
};

goog.object.extend(exports, proto.claims_messages);
